webpackJsonp([1],{

/***/ 124:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/logo.26b21b5.svg";

/***/ }),

/***/ 15:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__apis__ = __webpack_require__(486);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__(197);



// URL and endpoint constants
var PATH_PREFIX = 'adapt/';
var PATH_INSTAGRAM_TAGPAGE = 'api/instagram/tagpage/';
var PATH_INSTAGRAM_USERPAGE = 'api/instagram/userpage/';

/* harmony default export */ __webpack_exports__["a"] = ({
  instagramUser: function instagramUser(token, maxid) {
    var maxidString = maxid ? '/' + maxid : '';
    return __WEBPACK_IMPORTED_MODULE_0__apis__["a" /* default */].get('' + __WEBPACK_IMPORTED_MODULE_1__constants__["a" /* default */].BASE_API + PATH_INSTAGRAM_USERPAGE + token + maxidString);
  },
  instagramTag: function instagramTag(tag, maxid) {
    var maxidString = maxid ? '/' + maxid : '';
    return __WEBPACK_IMPORTED_MODULE_0__apis__["a" /* default */].get('' + __WEBPACK_IMPORTED_MODULE_1__constants__["a" /* default */].BASE_API + PATH_INSTAGRAM_TAGPAGE + tag + '/24' + maxidString);
  },


  // info = info
  infos: function infos() {
    return __WEBPACK_IMPORTED_MODULE_0__apis__["a" /* default */].get('' + __WEBPACK_IMPORTED_MODULE_1__constants__["a" /* default */].BASE_API + PATH_PREFIX + 'info/all');
  },
  infoNamed: function infoNamed(name) {
    return __WEBPACK_IMPORTED_MODULE_0__apis__["a" /* default */].get('' + __WEBPACK_IMPORTED_MODULE_1__constants__["a" /* default */].BASE_API + PATH_PREFIX + 'info/name/' + name);
  },


  // hotlinks
  hotlinks: function hotlinks() {
    return __WEBPACK_IMPORTED_MODULE_0__apis__["a" /* default */].get('' + __WEBPACK_IMPORTED_MODULE_1__constants__["a" /* default */].BASE_API + PATH_PREFIX + 'hotlink/all');
  },
  hotlinkNamed: function hotlinkNamed(name) {
    return __WEBPACK_IMPORTED_MODULE_0__apis__["a" /* default */].get('' + __WEBPACK_IMPORTED_MODULE_1__constants__["a" /* default */].BASE_API + PATH_PREFIX + 'hotlink/name/' + name);
  },
  hotlinkNameLike: function hotlinkNameLike(name) {
    return __WEBPACK_IMPORTED_MODULE_0__apis__["a" /* default */].get('' + __WEBPACK_IMPORTED_MODULE_1__constants__["a" /* default */].BASE_API + PATH_PREFIX + 'hotlink/name-like/' + name);
  },


  // service = testimonials
  services: function services() {
    return __WEBPACK_IMPORTED_MODULE_0__apis__["a" /* default */].get('' + __WEBPACK_IMPORTED_MODULE_1__constants__["a" /* default */].BASE_API + PATH_PREFIX + 'service/all');
  },
  serviceNamed: function serviceNamed(name) {
    return __WEBPACK_IMPORTED_MODULE_0__apis__["a" /* default */].get('' + __WEBPACK_IMPORTED_MODULE_1__constants__["a" /* default */].BASE_API + PATH_PREFIX + 'service/name/' + name);
  },


  // about = pages
  abouts: function abouts() {
    return __WEBPACK_IMPORTED_MODULE_0__apis__["a" /* default */].get('' + __WEBPACK_IMPORTED_MODULE_1__constants__["a" /* default */].BASE_API + PATH_PREFIX + 'about/all');
  },
  aboutNamed: function aboutNamed(name) {
    return __WEBPACK_IMPORTED_MODULE_0__apis__["a" /* default */].get('' + __WEBPACK_IMPORTED_MODULE_1__constants__["a" /* default */].BASE_API + PATH_PREFIX + 'about/name/' + name);
  },


  // links
  links: function links() {
    return __WEBPACK_IMPORTED_MODULE_0__apis__["a" /* default */].get('' + __WEBPACK_IMPORTED_MODULE_1__constants__["a" /* default */].BASE_API + PATH_PREFIX + 'link/all');
  },
  linkNamed: function linkNamed(name) {
    return __WEBPACK_IMPORTED_MODULE_0__apis__["a" /* default */].get('' + __WEBPACK_IMPORTED_MODULE_1__constants__["a" /* default */].BASE_API + PATH_PREFIX + 'link/name/' + name);
  },


  // links
  references: function references() {
    return __WEBPACK_IMPORTED_MODULE_0__apis__["a" /* default */].get('' + __WEBPACK_IMPORTED_MODULE_1__constants__["a" /* default */].BASE_API + PATH_PREFIX + 'reference/all');
  },
  referenceNamed: function referenceNamed(name) {
    return __WEBPACK_IMPORTED_MODULE_0__apis__["a" /* default */].get('' + __WEBPACK_IMPORTED_MODULE_1__constants__["a" /* default */].BASE_API + PATH_PREFIX + 'reference/name/' + name);
  },


  // faq
  faqs: function faqs() {
    return __WEBPACK_IMPORTED_MODULE_0__apis__["a" /* default */].get('' + __WEBPACK_IMPORTED_MODULE_1__constants__["a" /* default */].BASE_API + PATH_PREFIX + 'faq/all');
  },
  faqNamed: function faqNamed(name) {
    return __WEBPACK_IMPORTED_MODULE_0__apis__["a" /* default */].get('' + __WEBPACK_IMPORTED_MODULE_1__constants__["a" /* default */].BASE_API + PATH_PREFIX + 'faq/name/' + name);
  },


  // survey
  surveyStatus: function surveyStatus(code) {
    return __WEBPACK_IMPORTED_MODULE_0__apis__["a" /* default */].get('' + __WEBPACK_IMPORTED_MODULE_1__constants__["a" /* default */].BASE_API + PATH_PREFIX + 'survey/status/' + code);
  },
  surveySubmit: function surveySubmit(data) {
    return __WEBPACK_IMPORTED_MODULE_0__apis__["a" /* default */].post('' + __WEBPACK_IMPORTED_MODULE_1__constants__["a" /* default */].BASE_API + PATH_PREFIX + 'survey/submit', data);
  },


  // carousel () {
  //   return apis.get(`${Constants.BASE_API}carousel`)
  // },
  //
  // company () {
  //   return apis.get(`${Constants.BASE_API}company`)
  // },
  //
  // gallery () {
  //   return apis.get(`${Constants.BASE_API}gallery`)
  // },
  //
  // eventDetail (showId) {
  //   return apis.get(`${Constants.BASE_API}event/show/${showId}`)
  // },
  //
  // eventPrevious () {
  //   return apis.get(`${Constants.BASE_API}event/previous`)
  // },
  //
  // eventUpcoming () {
  //   return apis.get(`${Constants.BASE_API}event/upcoming`)
  // },

  email: function email(name, _email, message, captcha, session) {
    return __WEBPACK_IMPORTED_MODULE_0__apis__["a" /* default */].post(__WEBPACK_IMPORTED_MODULE_1__constants__["a" /* default */].BASE_API + 'email', { name: name, email: _email, phone: '-', message: message, captcha: captcha, session: session });
  },
  subscribe: function subscribe(name, email) {
    return __WEBPACK_IMPORTED_MODULE_0__apis__["a" /* default */].post(__WEBPACK_IMPORTED_MODULE_1__constants__["a" /* default */].BASE_API + 'email/subscribe', { name: name, email: email });
  },
  getRecaptcha: function getRecaptcha() {
    return __WEBPACK_IMPORTED_MODULE_0__apis__["a" /* default */].get(__WEBPACK_IMPORTED_MODULE_1__constants__["a" /* default */].BASE_API_BARE + 'captcha.php');
  },
  youtube: function youtube(path, params) {
    return __WEBPACK_IMPORTED_MODULE_0__apis__["a" /* default */].get('https://www.googleapis.com/youtube/v3/' + path, params);
  }
});

/***/ }),

/***/ 16:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_showdown__ = __webpack_require__(406);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_showdown___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_showdown__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__constants__ = __webpack_require__(197);





// export const EventBus = new Vue({ el: '#app' }) <-- in this case access using import { EventBus }
/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue__["default"]({
  data: {
    _navMain: [{
      name: 'about',
      label: 'About Us',
      path: '/about'
    }, {
      name: 'services',
      label: 'Services',
      path: '/services'
    }, {
      name: 'links',
      label: 'Helpful Links',
      path: '/links'
    }, {
      name: 'faq',
      label: 'FAQ',
      path: '/faq'
    }, {
      name: 'reports',
      label: 'Web Reports',
      path: '/reports'
    }, {
      name: 'payment',
      label: 'Make A Payment',
      path: '/payment'
    }, {
      name: 'contact',
      label: 'Contact Us',
      path: '/contact'
    }],
    info: {}
  },
  computed: {
    isDesktop: {
      get: function get() {
        return this._isDesktop;
      },
      set: function set(isDesktop) {
        if (this._isDesktop !== isDesktop) {
          // do not update immediately, only change if necessary
          this._isDesktop = isDesktop;
          this.$emit('isDesktopChanged', isDesktop);
        }
      }
    }
  },
  watch: {},
  mounted: function mounted() {
    // console.log('-- mounted')
  },

  methods: {
    devMode: function devMode() {
      var url = __WEBPACK_IMPORTED_MODULE_4__constants__["a" /* default */].BASE_API;
      if (url.indexOf('.com') >= 0) {
        return 'production';
      } else if (url.indexOf('localhost') >= 0) {
        return 'development';
      }
      return undefined;
    },

    loadImage: function loadImage(url) {
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
        var img = new Image();
        img.src = url;
        img.onload = function () {
          return resolve(img);
        };
      });
    },

    getHtml: function getHtml(content) {
      var converter = new __WEBPACK_IMPORTED_MODULE_2_showdown___default.a.Converter();
      var html = converter.makeHtml(content);
      return html;
    },

    toggleSubnavOpen: function toggleSubnavOpen(name) {
      var navItem = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.find(this._data._navMain, ['name', name]);
      if (navItem && navItem.hasOwnProperty('subnavOpen')) {
        navItem.subnavOpen = !navItem.subnavOpen;
      }
    },

    getNav: function getNav() {
      return this._data._navMain;
    },

    detectIE: function detectIE() {
      /**
       * detect IE
       * returns version of IE or false, if browser is not Internet Explorer
       */
      var ua = window.navigator.userAgent;

      // Test values; Uncomment to check result …

      // IE 10
      // ua = 'Mozilla/5.0 (compatible; MSIE 10.0; Windows NT 6.2; Trident/6.0)';

      // IE 11
      // ua = 'Mozilla/5.0 (Windows NT 6.3; Trident/7.0; rv:11.0) like Gecko';

      // Edge 12 (Spartan)
      // ua = 'Mozilla/5.0 (Windows NT 10.0; WOW64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/39.0.2171.71 Safari/537.36 Edge/12.0';

      // Edge 13
      // ua = 'Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/46.0.2486.0 Safari/537.36 Edge/13.10586';

      var msie = ua.indexOf('MSIE ');
      if (msie > 0) {
        // IE 10 or older => return version number
        return parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)), 10);
      }

      var trident = ua.indexOf('Trident/');
      if (trident > 0) {
        // IE 11 => return version number
        var rv = ua.indexOf('rv:');
        return parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10);
      }

      var edge = ua.indexOf('Edge/');
      if (edge > 0) {
        // Edge (IE 12+) => return version number
        return parseInt(ua.substring(edge + 5, ua.indexOf('.', edge)), 10);
      }

      // other browser
      return false;
    }
  }
}));

/***/ }),

/***/ 183:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/logo-text.64b3a24.svg";

/***/ }),

/***/ 184:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(797)
}
var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(495),
  /* template */
  __webpack_require__(960),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 188:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(800)
}
var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(499),
  /* template */
  __webpack_require__(963),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 197:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_freeze__ = __webpack_require__(523);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_freeze___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_freeze__);

var DevType = {
  DEV: 'dev',
  STAGING: 'staging',
  PROD: 'prod'
};

var devType = DevType.DEV;
var BASE_API = 'http://localhost/october_cms/';
if (window.location && window.location.hostname) {
  if (window.location.hostname.includes('staging') || window.location.hostname.includes('adaptconcepts')) {
    // staging
    BASE_API = 'https://cmsystem.adaptconcepts.com/october/';
    devType = DevType.STAGING;
  }
  if (window.location.hostname.includes('clientmanagementprobation')) {
    // live
    BASE_API = 'https://clientmanagementprobation.com/october/';
    devType = DevType.PROD;
  }
  if (window.location.hostname.includes('localhost')) {
    BASE_API = 'http://localhost/october_cms/'; // localhost
    // BASE_API = 'https://cmsystem.adaptconcepts.com/october/' // azure dev
    // BASE_API: 'https://prod.clientmanagementprobation.com/october/', // prod staging
    // BASE_API = 'https://clientmanagementprobation.com/october/' // prod
    devType = DevType.DEV;
    // noAria = true
  }
}

var Constants = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_freeze___default()({
  devType: devType,
  BASE_API: BASE_API,
  BASE_API_BARE: 'https://clientmanagementprobation.com/'
  // BASE_API_BARE: 'http://localhost:8081/static/'
});

/* harmony default export */ __webpack_exports__["a"] = (Constants);

/***/ }),

/***/ 412:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(804)
}
var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(503),
  /* template */
  __webpack_require__(968),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-1d98de09",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 419:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue__ = __webpack_require__(12);





// Facebook Analytics
(function (d, s, id) {
  /* eslint one-var: 0 */
  // console.log('init FB in application.js')
  var js,
      fjs = d.getElementsByTagName(s)[0];
  if (d.getElementById(id)) {
    return;
  }
  js = d.createElement(s);js.id = id;
  js.src = '//connect.facebook.net/en_US/sdk.js';
  fjs.parentNode.insertBefore(js, fjs);
})(document, 'script', 'facebook-jssdk');

var FBControl = {
  install: function install(Vue, options) {
    var _this = this;

    if (options && options.awaitAsyncTime) {
      this.awaitAsyncTime = options.awaitAsyncTime;
    }

    if (!window.FB) {
      // the following is template from FB developers
      // with compliance for ESlint
      window.fbAsyncInit = function () {
        _this.init();
      };
    } else {
      this.init();
    }
  },

  awaitAsyncTime: 100,
  init: function init() {
    /* global FB */
    FB.init({
      appId: '782732588553167',
      xfbml: true,
      version: 'v2.7'
    });
    window.FB = FB;
    Object.defineProperty(__WEBPACK_IMPORTED_MODULE_3_vue__["default"].prototype, '$FB', { value: FB });
    return FB;
  },
  getFB: function () {
    var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                var failsafe = 100;
                var repeat = setInterval(function () {
                  // console.log('logging event pending...' + Vue.$FB + ',' + window.FB)
                  if (__WEBPACK_IMPORTED_MODULE_3_vue__["default"].$FB !== undefined) {
                    // console.log('logging event logged later with Vue.$FB')
                    resolve(__WEBPACK_IMPORTED_MODULE_3_vue__["default"].$FB);
                    clearInterval(repeat);
                  } else if (window.FB !== undefined) {
                    // console.log('logging event logged later with window.FB')
                    resolve(window.FB);
                    clearInterval(repeat);
                  }
                  failsafe--;
                  if (failsafe <= 0) {
                    clearInterval(repeat);
                  }
                }, _this2.awaitAsyncTime);
              });

            case 2:
              return _context.abrupt('return', _context.sent);

            case 3:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function getFB() {
      return _ref.apply(this, arguments);
    }

    return getFB;
  }(),
  logEvent: function () {
    var _ref2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(name) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              if (!(__WEBPACK_IMPORTED_MODULE_3_vue__["default"].$FB !== undefined)) {
                _context2.next = 4;
                break;
              }

              // console.log('logging event logged now with Vue.$FB')
              __WEBPACK_IMPORTED_MODULE_3_vue__["default"].$FB.AppEvents.logEvent(name);
              _context2.next = 13;
              break;

            case 4:
              if (!(window.FB !== undefined)) {
                _context2.next = 8;
                break;
              }

              // console.log('logging event logged now with window.FB')
              window.FB.AppEvents.logEvent(name);
              _context2.next = 13;
              break;

            case 8:
              if (this.awaitAsyncTime) {
                _context2.next = 11;
                break;
              }

              console.error('Invalid await async time');
              return _context2.abrupt('return');

            case 11:
              _context2.next = 13;
              return this.getFB().then(function (FB) {
                FB.AppEvents.logEvent(name);
              }).catch(function (error) {
                console.error('Internal error in FBControl failsafe', error);
              });

            case 13:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, this);
    }));

    function logEvent(_x) {
      return _ref2.apply(this, arguments);
    }

    return logEvent;
  }(),
  logPageView: function () {
    var _ref3 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              if (!(__WEBPACK_IMPORTED_MODULE_3_vue__["default"].$FB !== undefined)) {
                _context3.next = 4;
                break;
              }

              __WEBPACK_IMPORTED_MODULE_3_vue__["default"].$FB.AppEvents.logPageView();
              _context3.next = 13;
              break;

            case 4:
              if (!(window.FB !== undefined)) {
                _context3.next = 8;
                break;
              }

              window.FB.AppEvents.logPageView();
              _context3.next = 13;
              break;

            case 8:
              if (this.awaitAsyncTime) {
                _context3.next = 11;
                break;
              }

              console.error('Invalid await async time');
              return _context3.abrupt('return');

            case 11:
              _context3.next = 13;
              return this.getFB().then(function (FB) {
                FB.AppEvents.logPageView();
              }).catch(function (error) {
                console.error('Internal error in FBControl failsafe', error);
              });

            case 13:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, this);
    }));

    function logPageView() {
      return _ref3.apply(this, arguments);
    }

    return logPageView;
  }()
};

/* harmony default export */ __webpack_exports__["a"] = (FBControl);

/***/ }),

/***/ 420:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = install;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(199);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_masonry_layout__ = __webpack_require__(187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_masonry_layout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_masonry_layout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_imagesloaded__ = __webpack_require__(829);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_imagesloaded___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_imagesloaded__);





var attributesMap = {
  'column-width': 'columnWidth',
  'transition-duration': 'transitionDuration',
  'item-selector': 'itemSelector',
  'origin-left': 'originLeft',
  'origin-top': 'originTop',
  'fit-width': 'fitWidth',
  'stamp': 'stamp',
  'gutter': 'gutter'
};
var EVENT_ADD = 'vuemasonry.itemAdded';
var EVENT_REMOVE = 'vuemasonry.itemRemoved';
var EVENT_IMAGE_LOADED = 'vuemasonry.imageLoaded';

var stringToBool = function stringToBool(val) {
  return (val + '').toLowerCase() === 'true';
};

var collectOptions = function collectOptions(attrs) {
  var res = {};
  var attributesArray = Array.prototype.slice.call(attrs);
  attributesArray.forEach(function (attr) {
    if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(attributesMap).indexOf(attr.name) > -1) {
      res[attributesMap[attr.name]] = attr.name.indexOf('origin') > -1 ? stringToBool(attr.value) : attr.value;
    }
  });
  return res;
};

var Events = new __WEBPACK_IMPORTED_MODULE_1_vue__["default"]({});

// NoctorusCode: changed install method
// export const VueMasonryPlugin = function () {}

function install(Vue, options) {
  Vue.redrawVueMasonry = function () {
    Events.$emit(EVENT_ADD);
  };

  Vue.directive('masonry', {
    props: ['transitionDuration', ' itemSelector'],

    inserted: function inserted(el, nodeObj) {
      if (!__WEBPACK_IMPORTED_MODULE_2_masonry_layout___default.a) {
        throw new Error('Masonry plugin is not defined. Please check it\'s connected and parsed correctly.');
      }
      var masonry = new __WEBPACK_IMPORTED_MODULE_2_masonry_layout___default.a(el, collectOptions(el.attributes));
      var masonryDraw = function masonryDraw() {
        masonry.reloadItems();
        masonry.layout();
      };
      Vue.nextTick(function () {
        masonryDraw();
      });

      Events.$on(EVENT_ADD, function (eventData) {
        masonryDraw();
      });
      Events.$on(EVENT_REMOVE, function (eventData) {
        masonryDraw();
      });
      Events.$on(EVENT_IMAGE_LOADED, function (eventData) {
        masonryDraw();
      });
    }
  });

  Vue.directive('masonryTile', {

    inserted: function inserted(el) {
      Events.$emit(EVENT_ADD, {
        'element': el
      });

      /* eslint-disable no-new */
      new __WEBPACK_IMPORTED_MODULE_3_imagesloaded___default.a(el, function () {
        Events.$emit(EVENT_IMAGE_LOADED, {
          'element': el
        });
      });
    },
    beforeDestroy: function beforeDestroy(el) {
      Events.$emit(EVENT_REMOVE, {
        'element': el
      });
    }
  });
}

/***/ }),

/***/ 421:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = install;
/**
 * Created by lingchenxuan on 16-11-9.
 * https://github.com/ibufu/vue2-scrollspy
 */
var scrollSections = [];

var bodyScrollEl = {};

// For ff, ie
Object.defineProperty(bodyScrollEl, 'scrollTop', {
  get: function get() {
    return document.body.scrollTop || document.documentElement.scrollTop;
  },
  set: function set(val) {
    document.body.scrollTop = val;
    document.documentElement.scrollTop = val;
  }
});

function init(el) {
  scrollSections = [];
  var sections = el.children;
  if (sections[0] && sections[0].offsetParent !== el) {
    el[scrollSpyContext].eventEl = window;
    el[scrollSpyContext].scrollEl = bodyScrollEl;
  }

  for (var i = 0; i < sections.length; i++) {
    if (sections[i].offsetTop >= 0) {
      scrollSections.push(sections[i].offsetTop);
    }
  }
}

var scrollSpyContext = '@@scrollSpyContext';

function install(Vue) {
  Vue.directive('scroll-spy', {
    bind: function bind(el, binding, vnode) {
      function onScroll() {
        var _el$scrollSpyContext = el[scrollSpyContext],
            scrollEl = _el$scrollSpyContext.scrollEl,
            expression = _el$scrollSpyContext.expression;

        var pos = scrollEl.scrollTop;
        var i = 0;
        while (pos >= scrollSections[i]) {
          i++;
        }
        vnode.context.$data[expression] = i ? i - 1 : 0;
      }

      function scrollToIndex(index) {
        console.log('scroll!!!!');
        var scrollEl = el[scrollSpyContext].scrollEl;

        var current = scrollEl.scrollTop;
        var target = scrollSections[index];
        var time = 200;
        var steps = 30;
        var timems = parseInt(time / steps);
        var gap = target - current;

        var _loop = function _loop(i) {
          var pos = current + gap / steps * i;
          setTimeout(function () {
            scrollEl.scrollTop = pos;
          }, timems * i);
        };

        for (var i = 0; i <= steps; i++) {
          _loop(i);
        }
      }
      vnode.context.$scrollToIndex = scrollToIndex;

      el[scrollSpyContext] = {
        onScroll: onScroll,
        expression: binding.expression,
        eventEl: el,
        scrollEl: el
      };
    },
    inserted: function inserted(el) {
      init(el);

      var _el$scrollSpyContext2 = el[scrollSpyContext],
          eventEl = _el$scrollSpyContext2.eventEl,
          onScroll = _el$scrollSpyContext2.onScroll;

      eventEl.addEventListener('scroll', onScroll);
    },
    componentUpdated: function componentUpdated(el) {
      init(el);
    },
    unbind: function unbind(el) {
      var _el$scrollSpyContext3 = el[scrollSpyContext],
          eventEl = _el$scrollSpyContext3.eventEl,
          onScroll = _el$scrollSpyContext3.onScroll;

      eventEl.removeEventListener('scroll', onScroll);
    }
  });
}

/***/ }),

/***/ 422:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(415);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex_persist__ = __webpack_require__(1011);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex_persist___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vuex_persist__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_js_cookie__ = __webpack_require__(262);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_js_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_js_cookie__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios__ = __webpack_require__(190);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_axios__);







__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* default */]);

var state = {
  count: 0,
  authentication: undefined
};

var getters = {
  evenOrOdd: function evenOrOdd(state) {
    return state.count % 2 === 0 ? 'even' : 'odd';
  },
  isAuthenticated: function isAuthenticated(state) {
    if (!state.authentication || state.authentication === undefined) {
      return false;
    }

    var data = state.authentication;
    if (!data || !data.expires_in || !data.token_type || !data.access_token || !data.refresh_token) {
      return false;
    }

    return true;
  },
  authenticatedUsername: function authenticatedUsername(state) {
    if (!state.authentication) {
      return '';
    }
    return state.authentication.email;
  },
  authenticatedAuthorization: function authenticatedAuthorization(state) {
    if (!state.authentication || !state.authentication.access_token || !state.authentication.token_type) {
      return undefined;
    }
    return state.authentication.token_type + ' ' + state.authentication.access_token;
  }
};

var mutations = {
  increment: function increment(state) {
    state.count++;
  },
  decrement: function decrement(state) {
    state.count--;
  },
  authenticated: function authenticated(state, data) {
    // console.log('mutation:authenticated')
    // console.log(data)
    state.authentication = data;
  },
  unauthenticated: function unauthenticated(state) {
    // console.log('mutation:unauthenticated')
    state.authentication = undefined;
  }
};

var actions = {
  increment: function increment(_ref) {
    var commit = _ref.commit;
    return commit('increment');
  },
  decrement: function decrement(_ref2) {
    var commit = _ref2.commit;
    return commit('decrement');
  },
  incrementIfOdd: function incrementIfOdd(_ref3) {
    var commit = _ref3.commit,
        state = _ref3.state;

    if ((state.count + 1) % 2 === 0) {
      commit('increment');
    }
  },
  incrementAsync: function incrementAsync(_ref4) {
    var commit = _ref4.commit;

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      setTimeout(function () {
        commit('increment');
        resolve();
      }, 1000);
    });
  },
  authenticated: function authenticated(_ref5, data) {
    var commit = _ref5.commit;

    // console.log('actions:authenticated')
    // console.log(data)

    if (!data || !data.expires_in || !data.token_type || !data.access_token || !data.refresh_token) {
      console.error('actions:authenticated:invalid authentication data', data);
      return;
    }

    // set header & update cookie
    __WEBPACK_IMPORTED_MODULE_5_axios___default.a.defaults.headers.post['Authorization'] = data.token_type + ' ' + data.access_token;
    __WEBPACK_IMPORTED_MODULE_5_axios___default.a.defaults.headers.get['Authorization'] = data.token_type + ' ' + data.access_token;
    return commit('authenticated', data);
  },
  unauthenticated: function unauthenticated(_ref6) {
    var commit = _ref6.commit;

    // console.log('actions:unauthenticated')

    // remove header & clear cookie
    __WEBPACK_IMPORTED_MODULE_5_axios___default.a.defaults.headers.post['Authorization'] = undefined;
    __WEBPACK_IMPORTED_MODULE_5_axios___default.a.defaults.headers.get['Authorization'] = undefined;
    return commit('unauthenticated');
  }
};

// authentication cookie store to store persistent storage
var authCookieStore = new __WEBPACK_IMPORTED_MODULE_3_vuex_persist___default.a({
  key: 'authorization',
  restoreState: function restoreState(key, storage) {
    // console.log('cookie:restoreState')
    // console.log(key)
    // console.log(state)
    var data = __WEBPACK_IMPORTED_MODULE_4_js_cookie___default.a.getJSON(key);
    state.authentication = data;
    if (!data || !data.token_type || !data.access_token) {
      // console.error('Invalid authorization')
      return __WEBPACK_IMPORTED_MODULE_4_js_cookie___default.a.getJSON(key);
    }

    __WEBPACK_IMPORTED_MODULE_5_axios___default.a.defaults.headers.post['Authorization'] = data.token_type + ' ' + data.access_token;
    __WEBPACK_IMPORTED_MODULE_5_axios___default.a.defaults.headers.get['Authorization'] = data.token_type + ' ' + data.access_token;

    // hopefully the following doesn't simply bind to override
    return __WEBPACK_IMPORTED_MODULE_4_js_cookie___default.a.getJSON(key);
  },
  saveState: function saveState(key, state, storage) {
    // console.log('cookie:saveState')
    // console.log(key)
    // console.log(state)
    if (!state.authentication || state.authentication === undefined || !state.authentication.expires_in || state.authentication.expires_in === undefined || !state.authentication.access_token || state.authentication.access_token === undefined || !state.authentication.refresh_token || state.authentication.refresh_token === undefined || !state.authentication.token_type || state.authentication.token_type === undefined) {
      __WEBPACK_IMPORTED_MODULE_4_js_cookie___default.a.remove(key);
      return;
    }

    var expires = state.authentication.expires_in / 60 / 60 / 24;
    console.log('cookie authentication expires in: ' + expires);
    return __WEBPACK_IMPORTED_MODULE_4_js_cookie___default.a.set(key, state.authentication, {
      expires: expires
    });
  },
  reducer: function reducer(state) {
    // console.log('cookie:reducer')
    // console.log(state)
    return { authentication: state.authentication };
  },
  filter: function filter(mutation) {
    // console.log('cookie:filter, mutation.type=' + mutation.type)
    return mutation.type === 'authenticated' || mutation.type === 'unauthenticated';
  }
});

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* default */].Store({
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations,
  plugins: [authCookieStore.plugin]
}));

/***/ }),

/***/ 423:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(992);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__pages_Landing__ = __webpack_require__(951);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__pages_Landing___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__pages_Landing__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__pages_About__ = __webpack_require__(949);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__pages_About___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__pages_About__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__pages_Services__ = __webpack_require__(954);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__pages_Services___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__pages_Services__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__pages_Links__ = __webpack_require__(952);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__pages_Links___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__pages_Links__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__pages_Faq__ = __webpack_require__(950);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__pages_Faq___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__pages_Faq__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__pages_reports__ = __webpack_require__(957);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__pages_reports___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__pages_reports__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__pages_payment__ = __webpack_require__(956);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__pages_payment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__pages_payment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__pages_contact__ = __webpack_require__(955);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__pages_contact___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__pages_contact__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__pages_survey__ = __webpack_require__(958);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__pages_survey___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__pages_survey__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__pages_NotFound__ = __webpack_require__(953);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__pages_NotFound___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__pages_NotFound__);



// import StayTuned from '@/pages/StayTuned'









// import Shows from '@/pages/Shows'
// import ShowDetail from '@/pages/ShowDetail'


__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

var vueRouter = new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: 'history',
  routes: [
  // {
  //   path: '/staytuned',
  //   name: 'staytuned',
  //   id: -1,
  //   title: 'Stay Tuned',
  //   component: StayTuned
  // },
  {
    path: '/',
    name: 'landing',
    id: 0,
    title: 'Landing',
    component: __WEBPACK_IMPORTED_MODULE_2__pages_Landing___default.a
  }, {
    path: '/about',
    name: 'about',
    id: 0,
    title: 'About',
    component: __WEBPACK_IMPORTED_MODULE_3__pages_About___default.a
  }, {
    path: '/services',
    name: 'services',
    id: 0,
    title: 'Services',
    component: __WEBPACK_IMPORTED_MODULE_4__pages_Services___default.a
  }, {
    path: '/links',
    name: 'links',
    id: 0,
    title: 'Links',
    component: __WEBPACK_IMPORTED_MODULE_5__pages_Links___default.a
  }, {
    path: '/faq',
    name: 'faq',
    id: 0,
    title: 'Faq',
    component: __WEBPACK_IMPORTED_MODULE_6__pages_Faq___default.a
  }, {
    path: '/reports',
    name: 'reports',
    id: 0,
    title: 'Reports',
    component: __WEBPACK_IMPORTED_MODULE_7__pages_reports___default.a
  }, {
    path: '/payment',
    name: 'payment',
    id: 0,
    title: 'Payment',
    component: __WEBPACK_IMPORTED_MODULE_8__pages_payment___default.a
  }, {
    path: '/contact',
    name: 'contact',
    id: 0,
    title: 'Contact',
    component: __WEBPACK_IMPORTED_MODULE_9__pages_contact___default.a
  }, {
    path: '/survey',
    name: 'survey',
    id: 0,
    title: 'Survey',
    component: __WEBPACK_IMPORTED_MODULE_10__pages_survey___default.a
  },
  // {
  //   path: '/shows',
  //   name: 'shows',
  //   id: 1,
  //   title: 'Shows',
  //   component: Shows
  // },
  // {
  //   path: '/show-detail',
  //   name: 'show-detail',
  //   id: 2,
  //   title: 'Show Detail',
  //   component: ShowDetail
  // },
  {
    path: '*',
    name: 'notfound',
    id: 404,
    title: 'Not Found',
    component: __WEBPACK_IMPORTED_MODULE_11__pages_NotFound___default.a
  }]
});

/* harmony default export */ __webpack_exports__["a"] = (vueRouter);

/***/ }),

/***/ 429:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 430:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 431:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 432:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 433:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 434:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 435:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 436:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var __cov_0GTwwl$GMPTkkuRWFDyc4w = (Function('return this'))();
if (!__cov_0GTwwl$GMPTkkuRWFDyc4w.__coverage__) { __cov_0GTwwl$GMPTkkuRWFDyc4w.__coverage__ = {}; }
__cov_0GTwwl$GMPTkkuRWFDyc4w = __cov_0GTwwl$GMPTkkuRWFDyc4w.__coverage__;
if (!(__cov_0GTwwl$GMPTkkuRWFDyc4w['/home/fahrenq/code/v-img/lib/ImgScreen.vue'])) {
   __cov_0GTwwl$GMPTkkuRWFDyc4w['/home/fahrenq/code/v-img/lib/ImgScreen.vue'] = {"path":"/home/fahrenq/code/v-img/lib/ImgScreen.vue","s":{"1":0,"2":0,"3":0,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0},"b":{"1":[0,0],"2":[0,0],"3":[0,0],"4":[0,0],"5":[0,0],"6":[0,0],"7":[0,0],"8":[0,0],"9":[0,0],"10":[0,0],"11":[0,0],"12":[0,0],"13":[0,0],"14":[0,0],"15":[0,0],"16":[0,0],"17":[0,0],"18":[0,0],"19":[0,0]},"f":{"1":0,"2":0,"3":0,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0},"fnMap":{"1":{"name":"(anonymous_1)","line":1,"loc":{"start":{"line":1,"column":1},"end":{"line":1,"column":13}}},"2":{"name":"render","line":13,"loc":{"start":{"line":13,"column":25},"end":{"line":13,"column":43}}},"3":{"name":"click","line":14,"loc":{"start":{"line":14,"column":225},"end":{"line":14,"column":248}}},"4":{"name":"data","line":20,"loc":{"start":{"line":20,"column":8},"end":{"line":20,"column":24}}},"5":{"name":"close","line":31,"loc":{"start":{"line":31,"column":11},"end":{"line":31,"column":28}}},"6":{"name":"next","line":37,"loc":{"start":{"line":37,"column":10},"end":{"line":37,"column":26}}},"7":{"name":"prev","line":45,"loc":{"start":{"line":45,"column":10},"end":{"line":45,"column":26}}},"8":{"name":"showUI","line":53,"loc":{"start":{"line":53,"column":12},"end":{"line":53,"column":30}}},"9":{"name":"(anonymous_9)","line":60,"loc":{"start":{"line":60,"column":34},"end":{"line":60,"column":46}}},"10":{"name":"created","line":65,"loc":{"start":{"line":65,"column":11},"end":{"line":65,"column":30}}},"11":{"name":"(anonymous_11)","line":68,"loc":{"start":{"line":68,"column":37},"end":{"line":68,"column":50}}},"12":{"name":"(anonymous_12)","line":76,"loc":{"start":{"line":76,"column":38},"end":{"line":76,"column":50}}},"13":{"name":"(anonymous_13)","line":79,"loc":{"start":{"line":79,"column":41},"end":{"line":79,"column":53}}}},"statementMap":{"1":{"start":{"line":1,"column":0},"end":{"line":11,"column":5}},"2":{"start":{"line":2,"column":2},"end":{"line":10,"column":3}},"3":{"start":{"line":3,"column":4},"end":{"line":5,"column":2130}},"4":{"start":{"line":5,"column":2130},"end":{"line":5,"column":2154}},"5":{"start":{"line":5,"column":2154},"end":{"line":9,"column":5}},"6":{"start":{"line":6,"column":6},"end":{"line":6,"column":37}},"7":{"start":{"line":8,"column":6},"end":{"line":8,"column":54}},"8":{"start":{"line":9,"column":5},"end":{"line":9,"column":29}},"9":{"start":{"line":14,"column":4},"end":{"line":14,"column":19}},"10":{"start":{"line":14,"column":19},"end":{"line":14,"column":47}},"11":{"start":{"line":14,"column":47},"end":{"line":14,"column":75}},"12":{"start":{"line":14,"column":75},"end":{"line":18,"column":1683}},"13":{"start":{"line":15,"column":10},"end":{"line":17,"column":11}},"14":{"start":{"line":16,"column":12},"end":{"line":16,"column":24}},"15":{"start":{"line":17,"column":11},"end":{"line":17,"column":23}},"16":{"start":{"line":21,"column":4},"end":{"line":27,"column":6}},"17":{"start":{"line":32,"column":6},"end":{"line":32,"column":71}},"18":{"start":{"line":33,"column":6},"end":{"line":33,"column":23}},"19":{"start":{"line":34,"column":6},"end":{"line":34,"column":33}},"20":{"start":{"line":35,"column":6},"end":{"line":35,"column":25}},"21":{"start":{"line":39,"column":6},"end":{"line":43,"column":7}},"22":{"start":{"line":40,"column":8},"end":{"line":40,"column":33}},"23":{"start":{"line":42,"column":8},"end":{"line":42,"column":35}},"24":{"start":{"line":47,"column":6},"end":{"line":51,"column":7}},"25":{"start":{"line":48,"column":8},"end":{"line":48,"column":33}},"26":{"start":{"line":50,"column":8},"end":{"line":50,"column":56}},"27":{"start":{"line":54,"column":6},"end":{"line":54,"column":23}},"28":{"start":{"line":58,"column":6},"end":{"line":58,"column":35}},"29":{"start":{"line":59,"column":6},"end":{"line":59,"column":28}},"30":{"start":{"line":60,"column":6},"end":{"line":62,"column":15}},"31":{"start":{"line":61,"column":8},"end":{"line":61,"column":32}},"32":{"start":{"line":66,"column":4},"end":{"line":66,"column":22}},"33":{"start":{"line":68,"column":4},"end":{"line":75,"column":7}},"34":{"start":{"line":70,"column":6},"end":{"line":70,"column":63}},"35":{"start":{"line":70,"column":48},"end":{"line":70,"column":63}},"36":{"start":{"line":72,"column":6},"end":{"line":72,"column":62}},"37":{"start":{"line":72,"column":48},"end":{"line":72,"column":62}},"38":{"start":{"line":74,"column":6},"end":{"line":74,"column":62}},"39":{"start":{"line":74,"column":48},"end":{"line":74,"column":62}},"40":{"start":{"line":76,"column":4},"end":{"line":78,"column":7}},"41":{"start":{"line":77,"column":6},"end":{"line":77,"column":21}},"42":{"start":{"line":79,"column":4},"end":{"line":81,"column":7}},"43":{"start":{"line":80,"column":6},"end":{"line":80,"column":22}}},"branchMap":{"1":{"line":2,"type":"if","locations":[{"start":{"line":2,"column":2},"end":{"line":2,"column":2}},{"start":{"line":2,"column":2},"end":{"line":2,"column":2}}]},"2":{"line":3,"type":"binary-expr","locations":[{"start":{"line":3,"column":15},"end":{"line":3,"column":28}},{"start":{"line":3,"column":32},"end":{"line":3,"column":72}}]},"3":{"line":5,"type":"if","locations":[{"start":{"line":5,"column":2154},"end":{"line":5,"column":2154}},{"start":{"line":5,"column":2154},"end":{"line":5,"column":2154}}]},"4":{"line":14,"type":"binary-expr","locations":[{"start":{"line":14,"column":56},"end":{"line":14,"column":68}},{"start":{"line":14,"column":72},"end":{"line":14,"column":74}}]},"5":{"line":14,"type":"cond-expr","locations":[{"start":{"line":14,"column":165},"end":{"line":18,"column":1669}},{"start":{"line":18,"column":1672},"end":{"line":18,"column":1680}}]},"6":{"line":15,"type":"if","locations":[{"start":{"line":15,"column":10},"end":{"line":15,"column":10}},{"start":{"line":15,"column":10},"end":{"line":15,"column":10}}]},"7":{"line":18,"type":"cond-expr","locations":[{"start":{"line":18,"column":84},"end":{"line":18,"column":211}},{"start":{"line":18,"column":214},"end":{"line":18,"column":222}}]},"8":{"line":18,"type":"cond-expr","locations":[{"start":{"line":18,"column":425},"end":{"line":18,"column":903}},{"start":{"line":18,"column":906},"end":{"line":18,"column":914}}]},"9":{"line":18,"type":"binary-expr","locations":[{"start":{"line":18,"column":382},"end":{"line":18,"column":395}},{"start":{"line":18,"column":399},"end":{"line":18,"column":422}}]},"10":{"line":18,"type":"cond-expr","locations":[{"start":{"line":18,"column":1030},"end":{"line":18,"column":1509}},{"start":{"line":18,"column":1512},"end":{"line":18,"column":1520}}]},"11":{"line":18,"type":"binary-expr","locations":[{"start":{"line":18,"column":987},"end":{"line":18,"column":1000}},{"start":{"line":18,"column":1004},"end":{"line":18,"column":1027}}]},"12":{"line":39,"type":"if","locations":[{"start":{"line":39,"column":6},"end":{"line":39,"column":6}},{"start":{"line":39,"column":6},"end":{"line":39,"column":6}}]},"13":{"line":47,"type":"if","locations":[{"start":{"line":47,"column":6},"end":{"line":47,"column":6}},{"start":{"line":47,"column":6},"end":{"line":47,"column":6}}]},"14":{"line":70,"type":"if","locations":[{"start":{"line":70,"column":6},"end":{"line":70,"column":6}},{"start":{"line":70,"column":6},"end":{"line":70,"column":6}}]},"15":{"line":70,"type":"binary-expr","locations":[{"start":{"line":70,"column":10},"end":{"line":70,"column":26}},{"start":{"line":70,"column":30},"end":{"line":70,"column":46}}]},"16":{"line":72,"type":"if","locations":[{"start":{"line":72,"column":6},"end":{"line":72,"column":6}},{"start":{"line":72,"column":6},"end":{"line":72,"column":6}}]},"17":{"line":72,"type":"binary-expr","locations":[{"start":{"line":72,"column":10},"end":{"line":72,"column":26}},{"start":{"line":72,"column":30},"end":{"line":72,"column":46}}]},"18":{"line":74,"type":"if","locations":[{"start":{"line":74,"column":6},"end":{"line":74,"column":6}},{"start":{"line":74,"column":6},"end":{"line":74,"column":6}}]},"19":{"line":74,"type":"binary-expr","locations":[{"start":{"line":74,"column":10},"end":{"line":74,"column":26}},{"start":{"line":74,"column":30},"end":{"line":74,"column":46}}]}}};
}
__cov_0GTwwl$GMPTkkuRWFDyc4w = __cov_0GTwwl$GMPTkkuRWFDyc4w['/home/fahrenq/code/v-img/lib/ImgScreen.vue'];
__cov_0GTwwl$GMPTkkuRWFDyc4w.s['1']++;(function(){__cov_0GTwwl$GMPTkkuRWFDyc4w.f['1']++;__cov_0GTwwl$GMPTkkuRWFDyc4w.s['2']++;if(document){__cov_0GTwwl$GMPTkkuRWFDyc4w.b['1'][0]++;__cov_0GTwwl$GMPTkkuRWFDyc4w.s['3']++;var head=(__cov_0GTwwl$GMPTkkuRWFDyc4w.b['2'][0]++,document.head)||(__cov_0GTwwl$GMPTkkuRWFDyc4w.b['2'][1]++,document.getElementsByTagName('head')[0]),style=document.createElement('style'),css=' *[data-v-5928e1c7] { -webkit-box-sizing: border-box; box-sizing: border-box; } .fullscreen-v-img[data-v-5928e1c7] { height: 100%; width: 100%; position: fixed; top: 0; left: 0; overflow: hidden; background-color: rgba(0, 0, 0, .7); -ms-touch-action: none; touch-action: none; } .content-v-img img[data-v-5928e1c7] { width: auto; height: auto; max-width: 100%; max-height: 100%; position: absolute; top: 0; left: 0; right: 0; bottom: 0; margin: auto; -webkit-user-select: none; -moz-user-select: none; -ms-user-select: none; user-select: none; } .header-v-img[data-v-5928e1c7] { position: absolute; width: 100%; background-color: rgba(0, 0, 0, .3); height: 50px; z-index: 9999; } .count-v-img[data-v-5928e1c7] { font-family: \'Avenir\', Helvetica, Arial, sans-serif; font-size: 15px; color: white; margin-left: 10px; line-height: 50px; } .close-v-img[data-v-5928e1c7] { float: right; margin-right: 10px; font-family: \'Avenir\', Helvetica, Arial, sans-serif; color: #E5E6EB; font-size: 30px; line-height: 50px; cursor: pointer; -webkit-transition: color .4s ease-in-out; transition: color .4s ease-in-out; } .close-v-img[data-v-5928e1c7]:hover { color: white; } .prev-v-img svg[data-v-5928e1c7], .next-v-img svg[data-v-5928e1c7] { margin: 5px auto; } .prev-v-img[data-v-5928e1c7], .next-v-img[data-v-5928e1c7] { color: white; width: 35px; height: 35px; position: absolute; top: 50%; margin-top: -12.5px; font-size: 15px; font-family: \'Avenir\', Helvetica, Arial, sans-serif; text-align: center; background-color: rgba(0, 0, 0, .3); z-index: 1000; opacity: .3; -webkit-transition: opacity .3s ease-in-out; transition: opacity .3s ease-in-out; cursor: pointer; } .prev-v-img[data-v-5928e1c7]:hover, .next-v-img[data-v-5928e1c7]:hover { opacity: 1; } .prev-v-img[data-v-5928e1c7] { left: 10px; } .next-v-img[data-v-5928e1c7] { right: 10px; } .v-img-fade-enter[data-v-5928e1c7], .v-img-fade-leave-to[data-v-5928e1c7] { opacity: 0; } .v-img-fade-enter-active[data-v-5928e1c7], .v-img-fade-leave-active[data-v-5928e1c7] { -webkit-transition: opacity .3s ease-in-out; transition: opacity .3s ease-in-out; } .body-fs-v-img {} ';__cov_0GTwwl$GMPTkkuRWFDyc4w.s['4']++;style.type='text/css';__cov_0GTwwl$GMPTkkuRWFDyc4w.s['5']++;if(style.styleSheet){__cov_0GTwwl$GMPTkkuRWFDyc4w.b['3'][0]++;__cov_0GTwwl$GMPTkkuRWFDyc4w.s['6']++;style.styleSheet.cssText=css;}else{__cov_0GTwwl$GMPTkkuRWFDyc4w.b['3'][1]++;__cov_0GTwwl$GMPTkkuRWFDyc4w.s['7']++;style.appendChild(document.createTextNode(css));}__cov_0GTwwl$GMPTkkuRWFDyc4w.s['8']++;head.appendChild(style);}else{__cov_0GTwwl$GMPTkkuRWFDyc4w.b['1'][1]++;}}());var ImgScreen = {render:function render(){__cov_0GTwwl$GMPTkkuRWFDyc4w.f['2']++;__cov_0GTwwl$GMPTkkuRWFDyc4w.s['9']++;var _vm=this;__cov_0GTwwl$GMPTkkuRWFDyc4w.s['10']++;var _h=_vm.$createElement;__cov_0GTwwl$GMPTkkuRWFDyc4w.s['11']++;var _c=(__cov_0GTwwl$GMPTkkuRWFDyc4w.b['4'][0]++,_vm._self._c)||(__cov_0GTwwl$GMPTkkuRWFDyc4w.b['4'][1]++,_h);__cov_0GTwwl$GMPTkkuRWFDyc4w.s['12']++;return _c('transition',{attrs:{'appear':'','name':'v-img-fade'}},[!_vm.closed?(__cov_0GTwwl$GMPTkkuRWFDyc4w.b['5'][0]++,_c('div',{staticClass:'fullscreen-v-img',on:{'click':function click($event){__cov_0GTwwl$GMPTkkuRWFDyc4w.f['3']++;__cov_0GTwwl$GMPTkkuRWFDyc4w.s['13']++;if($event.target!==$event.currentTarget){__cov_0GTwwl$GMPTkkuRWFDyc4w.b['6'][0]++;__cov_0GTwwl$GMPTkkuRWFDyc4w.s['14']++;return null;}else{__cov_0GTwwl$GMPTkkuRWFDyc4w.b['6'][1]++;}__cov_0GTwwl$GMPTkkuRWFDyc4w.s['15']++;_vm.close();}}},[_c('div',{staticClass:'header-v-img'},[_vm.images.length>1?(__cov_0GTwwl$GMPTkkuRWFDyc4w.b['7'][0]++,_c('span',{staticClass:'count-v-img'},[_vm._v(_vm._s(_vm.currentImageIndex+1)+'/'+_vm._s(_vm.images.length)+' ')])):(__cov_0GTwwl$GMPTkkuRWFDyc4w.b['7'][1]++,_vm._e()),_c('span',{staticClass:'close-v-img',on:{'click':_vm.close}},[_vm._v('\xD7')])]),_c('transition',{attrs:{'appear':'','name':'v-img-fade'}},[(__cov_0GTwwl$GMPTkkuRWFDyc4w.b['9'][0]++,_vm.visibleUI)&&(__cov_0GTwwl$GMPTkkuRWFDyc4w.b['9'][1]++,_vm.images.length!==1)?(__cov_0GTwwl$GMPTkkuRWFDyc4w.b['8'][0]++,_c('span',{staticClass:'prev-v-img',on:{'click':_vm.prev}},[_c('svg',{attrs:{'width':'25','height':'25','viewBox':'0 0 1792 1915','xmlns':'http://www.w3.org/2000/svg'}},[_c('path',{attrs:{'d':'M1664 896v128q0 53-32.5 90.5t-84.5 37.5h-704l293 294q38 36 38 90t-38 90l-75 76q-37 37-90 37-52 0-91-37l-651-652q-37-37-37-90 0-52 37-91l651-650q38-38 91-38 52 0 90 38l75 74q38 38 38 91t-38 91l-293 293h704q52 0 84.5 37.5t32.5 90.5z','fill':'#fff'}})])])):(__cov_0GTwwl$GMPTkkuRWFDyc4w.b['8'][1]++,_vm._e())]),_c('transition',{attrs:{'appear':'','name':'v-img-fade'}},[(__cov_0GTwwl$GMPTkkuRWFDyc4w.b['11'][0]++,_vm.visibleUI)&&(__cov_0GTwwl$GMPTkkuRWFDyc4w.b['11'][1]++,_vm.images.length!==1)?(__cov_0GTwwl$GMPTkkuRWFDyc4w.b['10'][0]++,_c('span',{staticClass:'next-v-img',on:{'click':_vm.next}},[_c('svg',{attrs:{'width':'25','height':'25','viewBox':'0 0 1792 1915','xmlns':'http://www.w3.org/2000/svg'}},[_c('path',{attrs:{'d':'M1600 960q0 54-37 91l-651 651q-39 37-91 37-51 0-90-37l-75-75q-38-38-38-91t38-91l293-293h-704q-52 0-84.5-37.5t-32.5-90.5v-128q0-53 32.5-90.5t84.5-37.5h704l-293-294q-38-36-38-90t38-90l75-75q38-38 90-38 53 0 91 38l651 651q37 35 37 90z','fill':'#fff'}})])])):(__cov_0GTwwl$GMPTkkuRWFDyc4w.b['10'][1]++,_vm._e())]),_c('div',{staticClass:'content-v-img'},[_c('img',{attrs:{'src':_vm.images[_vm.currentImageIndex]},on:{'click':_vm.next}})])],1)):(__cov_0GTwwl$GMPTkkuRWFDyc4w.b['5'][1]++,_vm._e())]);},staticRenderFns:[],_scopeId:'data-v-5928e1c7',data:function data(){__cov_0GTwwl$GMPTkkuRWFDyc4w.f['4']++;__cov_0GTwwl$GMPTkkuRWFDyc4w.s['16']++;return{images:[],visibleUI:true,currentImageIndex:0,closed:true,uiTimeout:null};},methods:{close:function close(){__cov_0GTwwl$GMPTkkuRWFDyc4w.f['5']++;__cov_0GTwwl$GMPTkkuRWFDyc4w.s['17']++;document.querySelector('body').classList.remove('body-fs-v-img');__cov_0GTwwl$GMPTkkuRWFDyc4w.s['18']++;this.images=[];__cov_0GTwwl$GMPTkkuRWFDyc4w.s['19']++;this.currentImageIndex=0;__cov_0GTwwl$GMPTkkuRWFDyc4w.s['20']++;this.closed=true;},next:function next(){__cov_0GTwwl$GMPTkkuRWFDyc4w.f['6']++;__cov_0GTwwl$GMPTkkuRWFDyc4w.s['21']++;if(this.currentImageIndex+1<this.images.length){__cov_0GTwwl$GMPTkkuRWFDyc4w.b['12'][0]++;__cov_0GTwwl$GMPTkkuRWFDyc4w.s['22']++;this.currentImageIndex++;}else{__cov_0GTwwl$GMPTkkuRWFDyc4w.b['12'][1]++;__cov_0GTwwl$GMPTkkuRWFDyc4w.s['23']++;this.currentImageIndex=0;}},prev:function prev(){__cov_0GTwwl$GMPTkkuRWFDyc4w.f['7']++;__cov_0GTwwl$GMPTkkuRWFDyc4w.s['24']++;if(this.currentImageIndex>0){__cov_0GTwwl$GMPTkkuRWFDyc4w.b['13'][0]++;__cov_0GTwwl$GMPTkkuRWFDyc4w.s['25']++;this.currentImageIndex--;}else{__cov_0GTwwl$GMPTkkuRWFDyc4w.b['13'][1]++;__cov_0GTwwl$GMPTkkuRWFDyc4w.s['26']++;this.currentImageIndex=this.images.length-1;}},showUI:function showUI(){__cov_0GTwwl$GMPTkkuRWFDyc4w.f['8']++;__cov_0GTwwl$GMPTkkuRWFDyc4w.s['27']++;var _this=this;__cov_0GTwwl$GMPTkkuRWFDyc4w.s['28']++;clearTimeout(this.uiTimeout);__cov_0GTwwl$GMPTkkuRWFDyc4w.s['29']++;this.visibleUI=true;__cov_0GTwwl$GMPTkkuRWFDyc4w.s['30']++;this.uiTimeout=setTimeout(function(){__cov_0GTwwl$GMPTkkuRWFDyc4w.f['9']++;__cov_0GTwwl$GMPTkkuRWFDyc4w.s['31']++;_this.visibleUI=false;},3500);}},created:function created(){__cov_0GTwwl$GMPTkkuRWFDyc4w.f['10']++;__cov_0GTwwl$GMPTkkuRWFDyc4w.s['32']++;var _this2=this;__cov_0GTwwl$GMPTkkuRWFDyc4w.s['33']++;window.addEventListener('keyup',function(e){__cov_0GTwwl$GMPTkkuRWFDyc4w.f['11']++;__cov_0GTwwl$GMPTkkuRWFDyc4w.s['34']++;if((__cov_0GTwwl$GMPTkkuRWFDyc4w.b['15'][0]++,e.keyCode===27)||(__cov_0GTwwl$GMPTkkuRWFDyc4w.b['15'][1]++,e.keyCode===81)){__cov_0GTwwl$GMPTkkuRWFDyc4w.b['14'][0]++;__cov_0GTwwl$GMPTkkuRWFDyc4w.s['35']++;_this2.close();}else{__cov_0GTwwl$GMPTkkuRWFDyc4w.b['14'][1]++;}__cov_0GTwwl$GMPTkkuRWFDyc4w.s['36']++;if((__cov_0GTwwl$GMPTkkuRWFDyc4w.b['17'][0]++,e.keyCode===39)||(__cov_0GTwwl$GMPTkkuRWFDyc4w.b['17'][1]++,e.keyCode===76)){__cov_0GTwwl$GMPTkkuRWFDyc4w.b['16'][0]++;__cov_0GTwwl$GMPTkkuRWFDyc4w.s['37']++;_this2.next();}else{__cov_0GTwwl$GMPTkkuRWFDyc4w.b['16'][1]++;}__cov_0GTwwl$GMPTkkuRWFDyc4w.s['38']++;if((__cov_0GTwwl$GMPTkkuRWFDyc4w.b['19'][0]++,e.keyCode===37)||(__cov_0GTwwl$GMPTkkuRWFDyc4w.b['19'][1]++,e.keyCode===72)){__cov_0GTwwl$GMPTkkuRWFDyc4w.b['18'][0]++;__cov_0GTwwl$GMPTkkuRWFDyc4w.s['39']++;_this2.prev();}else{__cov_0GTwwl$GMPTkkuRWFDyc4w.b['18'][1]++;}});__cov_0GTwwl$GMPTkkuRWFDyc4w.s['40']++;window.addEventListener('scroll',function(){__cov_0GTwwl$GMPTkkuRWFDyc4w.f['12']++;__cov_0GTwwl$GMPTkkuRWFDyc4w.s['41']++;_this2.close();});__cov_0GTwwl$GMPTkkuRWFDyc4w.s['42']++;window.addEventListener('mousemove',function(){__cov_0GTwwl$GMPTkkuRWFDyc4w.f['13']++;__cov_0GTwwl$GMPTkkuRWFDyc4w.s['43']++;_this2.showUI();});}};

var toConsumableArray = function (arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) arr2[i] = arr[i];

    return arr2;
  } else {
    return Array.from(arr);
  }
};

var __cov_WuSw60ZQZcI1aW7neh6dWA = (Function('return this'))();
if (!__cov_WuSw60ZQZcI1aW7neh6dWA.__coverage__) { __cov_WuSw60ZQZcI1aW7neh6dWA.__coverage__ = {}; }
__cov_WuSw60ZQZcI1aW7neh6dWA = __cov_WuSw60ZQZcI1aW7neh6dWA.__coverage__;
if (!(__cov_WuSw60ZQZcI1aW7neh6dWA['/home/fahrenq/code/v-img/lib/index.js'])) {
   __cov_WuSw60ZQZcI1aW7neh6dWA['/home/fahrenq/code/v-img/lib/index.js'] = {"path":"/home/fahrenq/code/v-img/lib/index.js","s":{"1":0,"2":0,"3":0,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0},"b":{"1":[0,0],"2":[0,0],"3":[0,0],"4":[0,0],"5":[0,0],"6":[0,0],"7":[0,0],"8":[0,0],"9":[0,0],"10":[0,0],"11":[0,0],"12":[0,0]},"f":{"1":0,"2":0,"3":0,"4":0},"fnMap":{"1":{"name":"install","line":6,"loc":{"start":{"line":6,"column":14},"end":{"line":6,"column":36}}},"2":{"name":"bind","line":10,"loc":{"start":{"line":10,"column":10},"end":{"line":10,"column":37}}},"3":{"name":"(anonymous_3)","line":45,"loc":{"start":{"line":45,"column":35},"end":{"line":45,"column":47}}},"4":{"name":"(anonymous_4)","line":52,"loc":{"start":{"line":52,"column":43},"end":{"line":52,"column":56}}}},"statementMap":{"1":{"start":{"line":6,"column":0},"end":{"line":61,"column":2}},"2":{"start":{"line":7,"column":2},"end":{"line":7,"column":37}},"3":{"start":{"line":9,"column":2},"end":{"line":60,"column":5}},"4":{"start":{"line":12,"column":6},"end":{"line":12,"column":29}},"5":{"start":{"line":13,"column":6},"end":{"line":13,"column":23}},"6":{"start":{"line":14,"column":6},"end":{"line":14,"column":38}},"7":{"start":{"line":17,"column":6},"end":{"line":21,"column":7}},"8":{"start":{"line":18,"column":8},"end":{"line":18,"column":48}},"9":{"start":{"line":19,"column":8},"end":{"line":19,"column":39}},"10":{"start":{"line":20,"column":8},"end":{"line":20,"column":45}},"11":{"start":{"line":24,"column":6},"end":{"line":24,"column":59}},"12":{"start":{"line":25,"column":6},"end":{"line":27,"column":7}},"13":{"start":{"line":26,"column":8},"end":{"line":26,"column":63}},"14":{"start":{"line":29,"column":6},"end":{"line":29,"column":70}},"15":{"start":{"line":29,"column":16},"end":{"line":29,"column":70}},"16":{"start":{"line":32,"column":6},"end":{"line":32,"column":31}},"17":{"start":{"line":35,"column":6},"end":{"line":35,"column":29}},"18":{"start":{"line":36,"column":6},"end":{"line":41,"column":7}},"19":{"start":{"line":37,"column":8},"end":{"line":37,"column":52}},"20":{"start":{"line":38,"column":8},"end":{"line":38,"column":50}},"21":{"start":{"line":39,"column":8},"end":{"line":39,"column":60}},"22":{"start":{"line":40,"column":8},"end":{"line":40,"column":65}},"23":{"start":{"line":45,"column":6},"end":{"line":58,"column":9}},"24":{"start":{"line":46,"column":8},"end":{"line":46,"column":70}},"25":{"start":{"line":48,"column":8},"end":{"line":48,"column":133}},"26":{"start":{"line":49,"column":8},"end":{"line":56,"column":9}},"27":{"start":{"line":50,"column":10},"end":{"line":50,"column":39}},"28":{"start":{"line":52,"column":10},"end":{"line":54,"column":14}},"29":{"start":{"line":53,"column":12},"end":{"line":53,"column":48}},"30":{"start":{"line":55,"column":10},"end":{"line":55,"column":63}},"31":{"start":{"line":57,"column":8},"end":{"line":57,"column":37}}},"branchMap":{"1":{"line":14,"type":"binary-expr","locations":[{"start":{"line":14,"column":18},"end":{"line":14,"column":29}},{"start":{"line":14,"column":33},"end":{"line":14,"column":37}}]},"2":{"line":17,"type":"if","locations":[{"start":{"line":17,"column":6},"end":{"line":17,"column":6}},{"start":{"line":17,"column":6},"end":{"line":17,"column":6}}]},"3":{"line":18,"type":"binary-expr","locations":[{"start":{"line":18,"column":17},"end":{"line":18,"column":37}},{"start":{"line":18,"column":41},"end":{"line":18,"column":47}}]},"4":{"line":19,"type":"binary-expr","locations":[{"start":{"line":19,"column":14},"end":{"line":19,"column":31}},{"start":{"line":19,"column":35},"end":{"line":19,"column":38}}]},"5":{"line":20,"type":"binary-expr","locations":[{"start":{"line":20,"column":16},"end":{"line":20,"column":35}},{"start":{"line":20,"column":39},"end":{"line":20,"column":44}}]},"6":{"line":24,"type":"binary-expr","locations":[{"start":{"line":24,"column":44},"end":{"line":24,"column":49}},{"start":{"line":24,"column":53},"end":{"line":24,"column":57}}]},"7":{"line":25,"type":"if","locations":[{"start":{"line":25,"column":6},"end":{"line":25,"column":6}},{"start":{"line":25,"column":6},"end":{"line":25,"column":6}}]},"8":{"line":25,"type":"binary-expr","locations":[{"start":{"line":25,"column":10},"end":{"line":25,"column":23}},{"start":{"line":25,"column":27},"end":{"line":25,"column":44}}]},"9":{"line":29,"type":"if","locations":[{"start":{"line":29,"column":6},"end":{"line":29,"column":6}},{"start":{"line":29,"column":6},"end":{"line":29,"column":6}}]},"10":{"line":36,"type":"if","locations":[{"start":{"line":36,"column":6},"end":{"line":36,"column":6}},{"start":{"line":36,"column":6},"end":{"line":36,"column":6}}]},"11":{"line":49,"type":"if","locations":[{"start":{"line":49,"column":8},"end":{"line":49,"column":8}},{"start":{"line":49,"column":8},"end":{"line":49,"column":8}}]},"12":{"line":53,"type":"binary-expr","locations":[{"start":{"line":53,"column":19},"end":{"line":53,"column":38}},{"start":{"line":53,"column":42},"end":{"line":53,"column":47}}]}}};
}
__cov_WuSw60ZQZcI1aW7neh6dWA = __cov_WuSw60ZQZcI1aW7neh6dWA['/home/fahrenq/code/v-img/lib/index.js'];
__cov_WuSw60ZQZcI1aW7neh6dWA.s['1']++;var install=function install(Vue){__cov_WuSw60ZQZcI1aW7neh6dWA.f['1']++;__cov_WuSw60ZQZcI1aW7neh6dWA.s['2']++;var screen=Vue.extend(ImgScreen);__cov_WuSw60ZQZcI1aW7neh6dWA.s['3']++;Vue.directive('img',{bind:function bind(el,binding){__cov_WuSw60ZQZcI1aW7neh6dWA.f['2']++;__cov_WuSw60ZQZcI1aW7neh6dWA.s['4']++;var cursor='pointer';__cov_WuSw60ZQZcI1aW7neh6dWA.s['5']++;var src=el.src;__cov_WuSw60ZQZcI1aW7neh6dWA.s['6']++;var group=(__cov_WuSw60ZQZcI1aW7neh6dWA.b['1'][0]++,binding.arg)||(__cov_WuSw60ZQZcI1aW7neh6dWA.b['1'][1]++,null);__cov_WuSw60ZQZcI1aW7neh6dWA.s['7']++;if(typeof binding.value!=='undefined'){__cov_WuSw60ZQZcI1aW7neh6dWA.b['2'][0]++;__cov_WuSw60ZQZcI1aW7neh6dWA.s['8']++;cursor=(__cov_WuSw60ZQZcI1aW7neh6dWA.b['3'][0]++,binding.value.cursor)||(__cov_WuSw60ZQZcI1aW7neh6dWA.b['3'][1]++,cursor);__cov_WuSw60ZQZcI1aW7neh6dWA.s['9']++;src=(__cov_WuSw60ZQZcI1aW7neh6dWA.b['4'][0]++,binding.value.src)||(__cov_WuSw60ZQZcI1aW7neh6dWA.b['4'][1]++,src);__cov_WuSw60ZQZcI1aW7neh6dWA.s['10']++;group=(__cov_WuSw60ZQZcI1aW7neh6dWA.b['5'][0]++,binding.value.group)||(__cov_WuSw60ZQZcI1aW7neh6dWA.b['5'][1]++,group);}else{__cov_WuSw60ZQZcI1aW7neh6dWA.b['2'][1]++;}__cov_WuSw60ZQZcI1aW7neh6dWA.s['11']++;el.setAttribute('data-vue-img-group',(__cov_WuSw60ZQZcI1aW7neh6dWA.b['6'][0]++,group)||(__cov_WuSw60ZQZcI1aW7neh6dWA.b['6'][1]++,null));__cov_WuSw60ZQZcI1aW7neh6dWA.s['12']++;if((__cov_WuSw60ZQZcI1aW7neh6dWA.b['8'][0]++,binding.value)&&(__cov_WuSw60ZQZcI1aW7neh6dWA.b['8'][1]++,binding.value.src)){__cov_WuSw60ZQZcI1aW7neh6dWA.b['7'][0]++;__cov_WuSw60ZQZcI1aW7neh6dWA.s['13']++;el.setAttribute('data-vue-img-src',binding.value.src);}else{__cov_WuSw60ZQZcI1aW7neh6dWA.b['7'][1]++;}__cov_WuSw60ZQZcI1aW7neh6dWA.s['14']++;if(!src){__cov_WuSw60ZQZcI1aW7neh6dWA.b['9'][0]++;__cov_WuSw60ZQZcI1aW7neh6dWA.s['15']++;console.error('v-img element missing src parameter.');}else{__cov_WuSw60ZQZcI1aW7neh6dWA.b['9'][1]++;}__cov_WuSw60ZQZcI1aW7neh6dWA.s['16']++;el.style.cursor=cursor;__cov_WuSw60ZQZcI1aW7neh6dWA.s['17']++;var vm=window.vueImg;__cov_WuSw60ZQZcI1aW7neh6dWA.s['18']++;if(!vm){__cov_WuSw60ZQZcI1aW7neh6dWA.b['10'][0]++;__cov_WuSw60ZQZcI1aW7neh6dWA.s['19']++;var element=document.createElement('div');__cov_WuSw60ZQZcI1aW7neh6dWA.s['20']++;element.setAttribute('id','imageScreen');__cov_WuSw60ZQZcI1aW7neh6dWA.s['21']++;document.querySelector('body').appendChild(element);__cov_WuSw60ZQZcI1aW7neh6dWA.s['22']++;vm=window.vueImg=new screen().$mount('#imageScreen');}else{__cov_WuSw60ZQZcI1aW7neh6dWA.b['10'][1]++;}__cov_WuSw60ZQZcI1aW7neh6dWA.s['23']++;el.addEventListener('click',function(){__cov_WuSw60ZQZcI1aW7neh6dWA.f['3']++;__cov_WuSw60ZQZcI1aW7neh6dWA.s['24']++;document.querySelector('body').classList.add('body-fs-v-img');__cov_WuSw60ZQZcI1aW7neh6dWA.s['25']++;var images=[].concat(toConsumableArray(document.querySelectorAll('img[data-vue-img-group="'+group+'"]')));__cov_WuSw60ZQZcI1aW7neh6dWA.s['26']++;if(images.length==0){__cov_WuSw60ZQZcI1aW7neh6dWA.b['11'][0]++;__cov_WuSw60ZQZcI1aW7neh6dWA.s['27']++;Vue.set(vm,'images',[src]);}else{__cov_WuSw60ZQZcI1aW7neh6dWA.b['11'][1]++;__cov_WuSw60ZQZcI1aW7neh6dWA.s['28']++;Vue.set(vm,'images',images.map(function(e){__cov_WuSw60ZQZcI1aW7neh6dWA.f['4']++;__cov_WuSw60ZQZcI1aW7neh6dWA.s['29']++;return(__cov_WuSw60ZQZcI1aW7neh6dWA.b['12'][0]++,e.dataset.vueImgSrc)||(__cov_WuSw60ZQZcI1aW7neh6dWA.b['12'][1]++,e.src);}));__cov_WuSw60ZQZcI1aW7neh6dWA.s['30']++;Vue.set(vm,'currentImageIndex',images.indexOf(el));}__cov_WuSw60ZQZcI1aW7neh6dWA.s['31']++;Vue.set(vm,'closed',false);});}});};

/* harmony default export */ __webpack_exports__["a"] = (install);
//# sourceMappingURL=v-img.mjs.map


/***/ }),

/***/ 440:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(818)
}
var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(491),
  /* template */
  __webpack_require__(982),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 441:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(821)
}
var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(498),
  /* template */
  __webpack_require__(985),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 442:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(811)
}
var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(508),
  /* template */
  __webpack_require__(975),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 443:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(489),
  /* template */
  __webpack_require__(964),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 486:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(190);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__controllers_EventBus__ = __webpack_require__(16);






/* harmony default export */ __webpack_exports__["a"] = ({
  // callback format: (result, data, error)
  post: function post(path, data) {
    // context.$http.interceptors.push(function (request, next) {
    //   request.headers.set('Access-Control-Allow-Origin', '*')
    //   next()
    // })

    __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.merge(data, {
      client_id: 1,
      client_secret: 'n4FdG7FaF14ka2id8WySAwHTtgdAGwBQTqovmeW0'
    });

    return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(path, data).then(function (response) {
        // console.log('response')
        // console.log(response)
        if (!response.data) {
          // EventBus.$emit('unauthenticated')
          // callback(false, { error: 'Invalid response', code: 400 })
          reject({ error: 'Invalid response', code: 400 });
          return;
        }

        // validate if proper JSON
        if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(response.data) !== 'object') {
          console.log(response);
          reject({ error: 'Invalid JSON data', code: 400 });
          return;
        }

        if (response.data.error) {
          reject({ error: response.data.error.msg, code: response.data.error.code });
          return;
        }

        // EventBus.$emit('authenticated', response.data)
        // callback(true)
        resolve(response.data);
      }).catch(function (error) {
        // console.log('error')
        // console.log(error)
        if (!error) {
          reject({ error: 'Blank error response', code: 400 });
          return;
        }

        // console.log(error)
        if (!error.response || !error.response.data) {
          // EventBus.$emit('unauthenticated')
          // callback(context, false, { error: 'Invalid error response', code: 400 })
          reject({ error: 'Invalid error response', code: 400 });
          return;
        }

        // validate if proper JSON
        if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(error.response.data) !== 'object') {
          console.error(error.response);
          reject({ error: 'Invalid JSON error', code: 400 });
          return;
        }

        if (error.response.data.code === 401) {
          __WEBPACK_IMPORTED_MODULE_4__controllers_EventBus__["a" /* default */].$emit('unauthenticated');
        }

        // EventBus.$emit('unauthenticated')
        // callback(context, false, error.response.data)
        reject(error.response.data);
      });
    });

    // context.$http.post(LOGIN_URL, creds, {
    //   headers: {
    //     // 'Access-Control-Allow-Methods': '*'
    //   }
    // }).then(data => {
    //   console.log(data)
    //   localStorage.setItem('id_token', data.id_token)
    //   localStorage.setItem('access_token', data.access_token)
    //
    //   this.user.authenticated = true
    //
    //   // Redirect to a specified route
    //   if (redirect) {
    //     console.log('redirected')
    //     // router.go(redirect)
    //   }
    // }, err => {
    //   console.log('error login')
    //   console.log(err)
    //   context.error = err
    // })
  },
  get: function get(path, params) {
    return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(path, { params: params }, {
        headers: {
          'HTTP_ORIGIN': 'http://localhost:8080'
        }
      }).then(function (response) {
        // console.log('response')
        // console.log(response)
        if (!response.data) {
          // EventBus.$emit('unauthenticated')
          // callback(false, { error: 'Invalid response', code: 400 })
          reject({ error: 'Invalid response', code: 400 });
          return;
        }

        // validate if proper JSON
        if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(response.data) !== 'object') {
          reject({ error: 'Invalid JSON data', code: 400 });
          return;
        }

        if (response.data.error) {
          reject({ error: response.data.error.msg, code: response.data.error.code });
          return;
        }

        // EventBus.$emit('authenticated', response.data)
        // callback(true)
        resolve(response.data);
      }).catch(function (error) {
        // console.log('error')
        // console.log(error)
        if (!error) {
          reject({ error: 'Blank error response', code: 400 });
          return;
        }

        // console.log(error)
        if (!error.response || !error.response.data) {
          // EventBus.$emit('unauthenticated')
          // callback(context, false, { error: 'Invalid error response', code: 400 })
          reject({ error: 'Invalid error response', code: 400 });
          return;
        }

        // validate if proper JSON
        if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(error.response.data) !== 'object') {
          reject({ error: 'Invalid JSON error', code: 400 });
          return;
        }

        if (error.response.data.code === 401) {
          __WEBPACK_IMPORTED_MODULE_4__controllers_EventBus__["a" /* default */].$emit('unauthenticated');
        }

        // EventBus.$emit('unauthenticated')
        // callback(context, false, error.response.data)
        reject(error.response.data);
      });
    });
  }
});

/***/ }),

/***/ 487:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_es6_promise_auto__ = __webpack_require__(428);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_es6_promise_auto___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_es6_promise_auto__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_polyfill__ = __webpack_require__(424);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_polyfill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_polyfill__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios_dist_axios__ = __webpack_require__(418);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios_dist_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios_dist_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_cookie__ = __webpack_require__(438);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_cookie__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_scrollto__ = __webpack_require__(445);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_scrollto___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_scrollto__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__controllers_ScrollSpy__ = __webpack_require__(421);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_infinite_scroll__ = __webpack_require__(439);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_infinite_scroll___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vue_infinite_scroll__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_multiple_back_top__ = __webpack_require__(444);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_multiple_back_top___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_vue_multiple_back_top__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_masonry_layout_masonry__ = __webpack_require__(187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_masonry_layout_masonry___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_masonry_layout_masonry__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__controllers_Masonry__ = __webpack_require__(420);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_v_img__ = __webpack_require__(436);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_buefy__ = __webpack_require__(425);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_buefy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_buefy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_buefy_lib_buefy_css__ = __webpack_require__(431);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_buefy_lib_buefy_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_buefy_lib_buefy_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_aos__ = __webpack_require__(417);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_aos___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_aos__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_aos_dist_aos_css__ = __webpack_require__(430);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_aos_dist_aos_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_aos_dist_aos_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_element_ui__ = __webpack_require__(426);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_element_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_element_ui_lib_locale_lang_en__ = __webpack_require__(427);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_element_ui_lib_locale_lang_en___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_element_ui_lib_locale_lang_en__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_element_ui_lib_theme_chalk_index_css__ = __webpack_require__(432);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_element_ui_lib_theme_chalk_index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_element_ui_lib_theme_chalk_index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_material_design_icons_iconfont_material_icons_css__ = __webpack_require__(433);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_material_design_icons_iconfont_material_icons_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_material_design_icons_iconfont_material_icons_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__styles_app_scss__ = __webpack_require__(429);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__styles_app_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__styles_app_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_slick_carousel_slick_slick_css__ = __webpack_require__(435);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_slick_carousel_slick_slick_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22_slick_carousel_slick_slick_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_slick_carousel_slick_slick_theme_css__ = __webpack_require__(434);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_slick_carousel_slick_slick_theme_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23_slick_carousel_slick_slick_theme_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__App__ = __webpack_require__(440);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__controllers_Store__ = __webpack_require__(422);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__router__ = __webpack_require__(423);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__controllers_FBControl__ = __webpack_require__(419);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_vue_analytics__ = __webpack_require__(437);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_vue_analytics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28_vue_analytics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_vue_youtube_embed__ = __webpack_require__(446);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30_vue_disqus_VueDisqus_vue__ = __webpack_require__(443);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30_vue_disqus_VueDisqus_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_30_vue_disqus_VueDisqus_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__components_FormError__ = __webpack_require__(441);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__components_FormError___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_31__components_FormError__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__components_FormInput__ = __webpack_require__(188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__components_FormInput___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_32__components_FormInput__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__components_SideBar__ = __webpack_require__(442);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__components_SideBar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_33__components_SideBar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_34_moment__);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.







__WEBPACK_IMPORTED_MODULE_2_vue__["default"].prototype.$ajax = __WEBPACK_IMPORTED_MODULE_3_axios_dist_axios___default.a;


__WEBPACK_IMPORTED_MODULE_2_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_4_lodash___default.a);
Object.defineProperty(__WEBPACK_IMPORTED_MODULE_2_vue__["default"].prototype, '$lodash', { value: __WEBPACK_IMPORTED_MODULE_4_lodash___default.a });


__WEBPACK_IMPORTED_MODULE_2_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_5_vue_cookie___default.a);


__WEBPACK_IMPORTED_MODULE_2_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_6_vue_scrollto___default.a, {
  container: 'body',
  duration: 500,
  easing: 'ease',
  offset: 0,
  cancelable: true,
  onDone: false,
  onCancel: false
});


__WEBPACK_IMPORTED_MODULE_2_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_7__controllers_ScrollSpy__["a" /* default */]);


__WEBPACK_IMPORTED_MODULE_2_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_8_vue_infinite_scroll___default.a);


__WEBPACK_IMPORTED_MODULE_2_vue__["default"].component(__WEBPACK_IMPORTED_MODULE_9_vue_multiple_back_top___default.a.name, __WEBPACK_IMPORTED_MODULE_9_vue_multiple_back_top___default.a);



__WEBPACK_IMPORTED_MODULE_2_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_11__controllers_Masonry__["a" /* default */]);


__WEBPACK_IMPORTED_MODULE_2_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_12_v_img__["a" /* default */]);

// Buefy Components UI

__WEBPACK_IMPORTED_MODULE_2_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_13_buefy___default.a);



__WEBPACK_IMPORTED_MODULE_2_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_15_aos___default.a);






__WEBPACK_IMPORTED_MODULE_2_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_17_element_ui___default.a, { locale: __WEBPACK_IMPORTED_MODULE_18_element_ui_lib_locale_lang_en___default.a });

// Material Design Icons


// override common styles UI


// Carousel







// FB

__WEBPACK_IMPORTED_MODULE_2_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_27__controllers_FBControl__["a" /* default */]);

// GA

__WEBPACK_IMPORTED_MODULE_2_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_28_vue_analytics___default.a, {
  id: 'UA-112311200-13',
  router: __WEBPACK_IMPORTED_MODULE_26__router__["a" /* default */]
});


__WEBPACK_IMPORTED_MODULE_2_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_29_vue_youtube_embed__["a" /* default */]);

// // Google Maps
// import * as VueGoogleMaps from 'vue2-google-maps'
// // const VueGoogleMaps = require('vue2-google-maps')
// Vue.use(VueGoogleMaps, {
//   load: {
//     key: 'AIzaSyBm43-gK1svcMQ7ULIOPOCOkdv1NX77TxM',
//     libraries: 'places' // This is required if you use the Autocomplete plugin
//     // OR: libraries: 'places,drawing'
//     // OR: libraries: 'places,drawing,visualization'
//     // (as you require)
//   }
// })
// // The following components are automatically installed globally
// // If you would like to define your own component names,
// // see below
// // GmapMap
// // GmapMarker
// // GmapCluster
// // GmapInfoWindow
// // GmapPolyline
// // GmapPolygon
// // GmapCircle
// // GmapRectangle
// // GmapAutocomplete
// // GmapPlaceInput

// Disqus


// Modules




__WEBPACK_IMPORTED_MODULE_2_vue__["default"].component('form-error', __WEBPACK_IMPORTED_MODULE_31__components_FormError___default.a);
__WEBPACK_IMPORTED_MODULE_2_vue__["default"].component('form-input', __WEBPACK_IMPORTED_MODULE_32__components_FormInput___default.a);
__WEBPACK_IMPORTED_MODULE_2_vue__["default"].component('side-bar', __WEBPACK_IMPORTED_MODULE_33__components_SideBar___default.a);
__WEBPACK_IMPORTED_MODULE_2_vue__["default"].component('vue-disqus', __WEBPACK_IMPORTED_MODULE_30_vue_disqus_VueDisqus_vue___default.a);


__WEBPACK_IMPORTED_MODULE_2_vue__["default"].filter('datetime', function (value, format) {
  format = format && format.slice(1, format.length - 1);
  if (!value) {
    return '0';
  }
  value = value.replace(/\s/, 'T');
  return __WEBPACK_IMPORTED_MODULE_34_moment___default()(new Date(value)).format(format || 'h:mm A - D MMM YYYY');
});

__WEBPACK_IMPORTED_MODULE_2_vue__["default"].filter('dateonly', function (value, format) {
  format = format && format.slice(1, format.length - 1);
  if (!value) {
    return '0';
  }
  value = value.replace(/\s/, 'T');
  return __WEBPACK_IMPORTED_MODULE_34_moment___default()(new Date(value)).format(format || 'MMMM D, YYYY');
});

__WEBPACK_IMPORTED_MODULE_2_vue__["default"].config.productionTip = false;

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_2_vue__["default"]({
  el: '#app',
  store: __WEBPACK_IMPORTED_MODULE_25__controllers_Store__["a" /* default */],
  router: __WEBPACK_IMPORTED_MODULE_26__router__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_24__App___default.a },
  created: function created() {
    __WEBPACK_IMPORTED_MODULE_15_aos___default.a.init({
      duration: 1600
    });
  }
});

/***/ }),

/***/ 488:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export getSurveyStatus */
/* unused harmony export setSurveyStatus */
/* unused harmony export removeSurveyStatus */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_cookie__ = __webpack_require__(262);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_js_cookie__);
// import _ from 'lodash'

// import Constants from '@/constants'

var KeySurveyStatus = 'CmsSurveyStatus';

var SET_OPT = { expires: 7

  // token

};function getSurveyStatus() {
  return __WEBPACK_IMPORTED_MODULE_0_js_cookie___default.a.get(KeySurveyStatus);
}

function setSurveyStatus(status) {
  return __WEBPACK_IMPORTED_MODULE_0_js_cookie___default.a.set(KeySurveyStatus, status, SET_OPT);
}

function removeSurveyStatus() {
  return __WEBPACK_IMPORTED_MODULE_0_js_cookie___default.a.remove(KeySurveyStatus);
}

/* harmony default export */ __webpack_exports__["a"] = ({
  getSurveyStatus: getSurveyStatus,
  setSurveyStatus: setSurveyStatus,
  removeSurveyStatus: removeSurveyStatus
});

/***/ }),

/***/ 489:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'vue-disqus',
  props: {
    shortname: {
      type: String,
      required: true
    },
    identifier: {
      type: String,
      required: false
    },
    url: {
      type: String,
      required: false
    },
    title: {
      type: String,
      required: false
    },
    remote_auth_s3: {
      type: String,
      required: false
    },
    api_key: {
      type: String,
      required: false
    },
    sso_config: {
      type: Object,
      required: false
    },
    language: {
      type: String,
      required: false
    }
  },
  mounted: function mounted() {
    if (window.DISQUS) {
      this.reset(window.DISQUS);
      return;
    }
    this.init();
  },

  methods: {
    reset: function reset(dsq) {
      var self = this;
      dsq.reset({
        reload: true,
        config: function config() {
          self.setBaseConfig(this);
        }
      });
    },
    init: function init() {
      var _this = this;

      var self = this;
      window.disqus_config = function () {
        self.setBaseConfig(this);
      };
      setTimeout(function () {
        var d = document,
            s = d.createElement('script');
        s.setAttribute('id', 'embed-disqus');
        s.setAttribute('data-timestamp', +new Date());
        s.type = 'text/javascript';
        s.async = true;
        s.src = '//' + _this.shortname + '.disqus.com/embed.js';(d.head || d.body).appendChild(s);
      }, 0);
    },
    setBaseConfig: function setBaseConfig(disqusConfig) {
      var _this2 = this;

      disqusConfig.page.identifier = this.identifier || this.$route.path || window.location.pathname;
      disqusConfig.page.url = this.url || this.$el.baseURI;
      if (this.title) {
        disqusConfig.page.title = this.title;
      }
      if (this.remote_auth_s3) {
        disqusConfig.page.remote_auth_s3 = this.remote_auth_s3;
      }
      if (this.api_key) {
        disqusConfig.page.api_key = this.api_key;
      }
      if (this.sso_config) {
        disqusConfig.sso = this.sso_config;
      }
      if (this.language) {
        disqusConfig.language = this.language;
      }

      disqusConfig.callbacks.onReady = [function () {
        _this2.$emit('ready');
      }];
    }
  }
});

/***/ }),

/***/ 490:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({

  name: 'PulseLoader',

  props: {
    loading: {
      type: Boolean,
      default: true
    },
    color: {
      type: String,
      default: '#5dc596'
    },
    size: {
      type: String,
      default: '15px'
    },
    margin: {
      type: String,
      default: '2px'
    },
    radius: {
      type: String,
      default: '100%'
    }
  },
  data: function data() {
    return {
      spinnerStyle: {
        backgroundColor: this.color,
        width: this.size,
        height: this.size,
        margin: this.margin,
        borderRadius: this.radius,
        display: 'inline-block',
        animationName: 'v-pulseStretchDelay',
        animationDuration: '0.75s',
        animationIterationCount: 'infinite',
        animationTimingFunction: 'cubic-bezier(.2,.68,.18,1.08)',
        animationFillMode: 'both'
      },
      spinnerDelay1: {
        animationDelay: '0.12s'
      },
      spinnerDelay2: {
        animationDelay: '0.24s'
      },
      spinnerDelay3: {
        animationDelay: '0.36s'
      }
    };
  }
});

/***/ }),

/***/ 491:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_NavBarFull_vue__ = __webpack_require__(412);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_NavBarFull_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_NavBarFull_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_NavBarOverlay_vue__ = __webpack_require__(944);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_NavBarOverlay_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_NavBarOverlay_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_TopSection_vue__ = __webpack_require__(948);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_TopSection_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_TopSection_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Footer_vue__ = __webpack_require__(939);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Footer_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_Footer_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_spinner_src_PulseLoader_vue__ = __webpack_require__(959);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_spinner_src_PulseLoader_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_spinner_src_PulseLoader_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__controllers_EventBus__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuex__ = __webpack_require__(415);

//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app',
  components: {
    NavbarFull: __WEBPACK_IMPORTED_MODULE_1__components_NavBarFull_vue___default.a,
    NavbarOverlay: __WEBPACK_IMPORTED_MODULE_2__components_NavBarOverlay_vue___default.a,
    TopSection: __WEBPACK_IMPORTED_MODULE_3__components_TopSection_vue___default.a,
    FooterMain: __WEBPACK_IMPORTED_MODULE_4__components_Footer_vue___default.a,
    PulseLoader: __WEBPACK_IMPORTED_MODULE_5_vue_spinner_src_PulseLoader_vue___default.a
  },
  data: function data() {
    return {};
  },

  computed: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_vuex__["a" /* mapGetters */])(['isAuthenticated']),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    sample: function sample(data) {}
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_vuex__["b" /* mapActions */])(['authenticated', 'unauthenticated'])),
  beforeCreate: function beforeCreate() {
    /* global window */
    window.onLoadCallback = function () {
      console.log('callback function here...');
    };
  },
  created: function created() {
    // console.log('created App.vue')
    // EventBus.$off('authenticated')
    // EventBus.$on('authenticated', (data) => {
    //   this.authenticated(data)
    // })
    // EventBus.$off('unauthenticated')
    // EventBus.$on('unauthenticated', () => {
    //   this.unauthenticated()
    // })

    // on master event resize (propagating to EventBus)
    __WEBPACK_IMPORTED_MODULE_6__controllers_EventBus__["a" /* default */].isDesktop = window.innerWidth >= 768;
    __WEBPACK_IMPORTED_MODULE_6__controllers_EventBus__["a" /* default */].windowWidth = window.innerWidth;
    window.addEventListener('resize', function (event) {
      __WEBPACK_IMPORTED_MODULE_6__controllers_EventBus__["a" /* default */].isDesktop = event.target.innerWidth >= 768;
      __WEBPACK_IMPORTED_MODULE_6__controllers_EventBus__["a" /* default */].windowWidth = window.innerWidth;
    });
  },
  beforeMount: function beforeMount() {
    // console.log('beforeMount App.vue')
    window.addEventListener('load', function () {});
  },
  mounted: function mounted() {}
});

/***/ }),

/***/ 492:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__apis_Site__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_showdown__ = __webpack_require__(406);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_showdown___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_showdown__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'about',
  components: {},
  data: function data() {
    return {
      paragraph: {
        title: '',
        content: ''
      },
      error: undefined,
      loading: false
    };
  },

  computed: {},
  watch: {},
  created: function created() {},
  mounted: function mounted() {
    this.refresh();
  },

  methods: {
    onScrollTo: function (name) {
      this.$scrollTo('#' + name);
    }.bind(this),

    getItems: function getItems(onComplete) {
      var _this = this;

      this.loading = true;
      this.error = undefined;
      this.paragraph.content = '';
      this.paragraph.title = '';
      __WEBPACK_IMPORTED_MODULE_0__apis_Site__["a" /* default */].about().then(function (data) {
        _this.loading = false;
        // console.log(data)
        if (data && data.content) {
          var converter = new __WEBPACK_IMPORTED_MODULE_1_showdown___default.a.Converter();
          var html = converter.makeHtml(data.content);
          _this.paragraph.content = html;
          _this.paragraph.title = data.title;
        } else {
          _this.error = 'Unable to load, please kindly refresh the page.';
        }

        if (onComplete) {
          onComplete(data);
        }
      }).catch(function (error) {
        _this.loading = false;
        _this.error = 'Unable to load, please kindly refresh the page.';
        console.log(error);
      });
    },
    refresh: function refresh() {
      this.getItems(function (item) {
        // this.item = item
      });
    }
  }
});

/***/ }),

/***/ 493:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuelidate__ = __webpack_require__(185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuelidate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vuelidate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__ = __webpack_require__(186);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__apis_Site__ = __webpack_require__(15);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'contactsection',
  mixins: [__WEBPACK_IMPORTED_MODULE_0_vuelidate__["validationMixin"]],
  data: function data() {
    return {
      isDesktop: true,
      name: '',
      email: '',
      message: '',
      captcha: '',
      session: '',
      captchaImage: undefined,
      feedback: false,
      loading: false
    };
  },
  mounted: function mounted() {
    var _this = this;

    // on event resize
    this.isDesktop = window.innerWidth >= 768;
    window.addEventListener('resize', function (event) {
      // console.log('on viewport change')
      this.isDesktop = event.target.innerWidth >= 768;
    }.bind(this));

    this.onRecaptcha(function (data) {
      // console.log('recaptcha data!')
      _this.captchaImage = data.data;
      _this.session = data.id;
    });
  },
  methods: {
    onRecaptcha: function onRecaptcha(onRecaptchaSuccess) {
      __WEBPACK_IMPORTED_MODULE_2__apis_Site__["a" /* default */].getRecaptcha().then(function (data) {
        // console.log('get recaptcha')
        // console.log(data)
        if (onRecaptchaSuccess) {
          onRecaptchaSuccess(data);
        }
      }).catch(function (error) {
        console.log('get recaptcha error');
        console.log(error);
      });
    },
    onSend: function onSend($v) {
      var _self = this;
      if ($v.$invalid) {
        _self.feedback = 'Please fill in all fields to proceed.';
        // _self.$toast.open({
        //   duration: 5000,
        //   message: 'Please fill in all fields to proceed.',
        //   position: 'is-bottom',
        //   type: 'is-warning'
        // })
      } else {
        _self.feedback = false;
        _self.loading = true;
        __WEBPACK_IMPORTED_MODULE_2__apis_Site__["a" /* default */].email(_self.name, _self.email, _self.message, _self.captcha, _self.session).then(function (data) {
          _self.loading = false;

          // invalid recaptcha
          if (data && data.status === 'invalid_session') {
            _self.feedback = 'Invalid session, please kindly refresh and try again.';
            return;
          }

          // invalid recaptcha
          if (data && data.status === 'invalid_captcha') {
            _self.feedback = 'Invalid captcha, please re-type again.';
            return;
          }

          if (data && data.status !== 'ok') {
            _self.feedback = 'Oops. Something went wrong. Please email us directly at info@clientmanagementprobation.com';
            return;
          }

          _self.verified = false;
          _self.name = '';
          _self.email = '';
          _self.message = '';
          _self.captcha = '';
          // _self.session = '' // open up to maintain session
          // _self.$toast.open({
          //   message: 'We will be contacting you via email or phone. Thanks!',
          //   position: 'is-bottom',
          //   type: 'is-success'
          // })
          _self.feedback = 'Email sent. Thanks!';
        }).catch(function (error) {
          console.log('invalid email', error);
          // this.error = error.error
          console.log(error);
          _self.captcha = '';

          // invalid recaptcha
          if (error && error.status === 'invalid_session') {
            _self.feedback = 'Invalid session, please kindly refresh and try again.';
            _self.loading = false;
            return;
          }

          // invalid recaptcha
          if (error && error.status === 'invalid_captcha') {
            _self.feedback = 'Invalid captcha, please retype again.';
            _self.loading = false;
            return;
          }

          // _self.$toast.open({
          //   duration: 5000,
          //   message: 'Oops. Something went wrong. Please email us directly at info@clientmanagementprobation.com',
          //   position: 'is-bottom',
          //   type: 'is-warning'
          // })
          _self.feedback = 'Oops. Something went wrong. Please email us directly at info@clientmanagementprobation.com';
          _self.loading = false;
        });
      }
    }
  },
  validations: {
    email: {
      required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"],
      email: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["email"]
    },
    name: {
      required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"]
    },
    message: {
      required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"]
    },
    captcha: {
      required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"]
    }
  }
});

/***/ }),

/***/ 494:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'div-columns',
  props: ['full', 'column-num', 'padding-top', 'padding-bottom', 'background-color', 'text-align'],
  components: {},
  data: function data() {
    return {};
  },

  computed: {},
  watch: {},
  created: function created() {},
  mounted: function mounted() {
    this.refresh();
  },

  methods: {
    onScrollTo: function (name) {
      this.$scrollTo('#' + name);
    }.bind(this),

    refresh: function refresh() {}
  }
});

/***/ }),

/***/ 495:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'div-container',
  props: ['full', 'column-num', 'padding-top', 'padding-bottom'],
  components: {},
  data: function data() {
    return {};
  },

  computed: {},
  watch: {},
  created: function created() {},
  mounted: function mounted() {
    this.refresh();
  },

  methods: {
    onScrollTo: function (name) {
      this.$scrollTo('#' + name);
    }.bind(this),

    refresh: function refresh() {}
  }
});

/***/ }),

/***/ 496:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_markdown__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_markdown___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_markdown__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__apis_Site__ = __webpack_require__(15);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'footer-main',
  components: {
    Markdown: __WEBPACK_IMPORTED_MODULE_2_vue_markdown___default.a
  },
  data: function data() {
    return {
      footer1: undefined,
      footer2: undefined
    };
  },

  methods: {
    onScrollTo: function onScrollTo(name, target) {
      if (this.$route.name !== name) {
        this.$router.replace({ name: name, query: { anchor: target } });
      } else {
        this.$scrollTo('#' + target);
      }
    }
  },
  beforeCreate: function beforeCreate() {},
  created: function created() {},
  beforeMount: function beforeMount() {},
  mounted: function mounted() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      var data;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              data = void 0;
              _context.next = 4;
              return __WEBPACK_IMPORTED_MODULE_3__apis_Site__["a" /* default */].infoNamed('footer-1');

            case 4:
              data = _context.sent;

              if (data && data[0] && data[0].content) {
                _this.footer1 = data[0].content;
              } else {
                _this.footer1 = undefined;
              }
              _context.next = 8;
              return __WEBPACK_IMPORTED_MODULE_3__apis_Site__["a" /* default */].infoNamed('footer-2');

            case 8:
              data = _context.sent;

              if (data && data[0] && data[0].content) {
                _this.footer2 = data[0].content;
              } else {
                _this.footer2 = undefined;
              }
              _context.next = 17;
              break;

            case 12:
              _context.prev = 12;
              _context.t0 = _context['catch'](0);

              _this.footer1 = undefined;
              _this.footer2 = undefined;
              console.log('info error', _context.t0);

            case 17:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this, [[0, 12]]);
    }))();
  }
});

/***/ }),

/***/ 497:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__controllers_EventBus__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_DivContainer__ = __webpack_require__(184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_DivContainer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_DivContainer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_recaptcha__ = __webpack_require__(991);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__apis_Site__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_lightbox__ = __webpack_require__(411);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_lightbox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_lightbox__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'section-sign-up-team',
  components: {
    DivContainer: __WEBPACK_IMPORTED_MODULE_1__components_DivContainer___default.a,
    Lightbox: __WEBPACK_IMPORTED_MODULE_4_vue_lightbox___default.a,
    VueRecaptcha: __WEBPACK_IMPORTED_MODULE_2_vue_recaptcha__["a" /* default */]
  },
  watch: {},
  props: ['type', 'feedback', 'loading', 'names', 'models', 'attributes', 'vuelidate', 'is-print', 'is-print-pdf'],
  data: function data() {
    return {
      isDesktop: true,
      isIE: __WEBPACK_IMPORTED_MODULE_0__controllers_EventBus__["a" /* default */].detectIE(),
      items: [],
      // captcha: '', // use back model's captcha for validation
      captchaImage: undefined,
      session: '',
      recaptchaKey: '6LeaZb0rAAAAALB4GPHaMIetC7nMENnr-KS7kXqP',
      // feedback: false, // capture from external due to send function
      // loading: false,
      navEmail: __WEBPACK_IMPORTED_MODULE_0__controllers_EventBus__["a" /* default */]._data._navEmail
    };
  },
  created: function created() {
    console.log('FormDynamix:created(): $v / models');
    console.log(this.vuelidate);
    console.log(this.models);
    this.init();
  },
  mounted: function mounted() {
    // on event resize
    this.isDesktop = __WEBPACK_IMPORTED_MODULE_0__controllers_EventBus__["a" /* default */]._isDesktop;
    __WEBPACK_IMPORTED_MODULE_0__controllers_EventBus__["a" /* default */].$on('isDesktopChanged', function () {
      this.isDesktop = __WEBPACK_IMPORTED_MODULE_0__controllers_EventBus__["a" /* default */]._isDesktop;
    }.bind(this));

    // this.onRecaptcha(data => {
    //   this.captchaImage = data.data
    //   this.session = data.id
    // })

    console.log('FormDynamix:mounted(): $v / models');
    console.log(this.vuelidate);
    console.log(this.models);
  },
  methods: {
    init: function init() {
      console.log('FormDynamix:init()');
      if (this.vuelidate) {
        if (this.vuelidate.models) {
          for (var i = 0; i < this.names.length; i++) {
            var name = this.names[i];
            if (this.vuelidate.models[name]) {
              if (!this.attributes[name]) {
                this.$set(this.attributes, name, {
                  type: 'text',
                  title: 'Invalid'
                });
              }
              if (this.attributes[name] && !this.attributes[name].type) {
                this.attributes[name].type = 'text';
              }
              // if (this.attributes[name] && !this.attributes[name].title) {
              //   this.attributes[name].title = 'Invalid'
              // }

              // text area custom type
              if (this.attributes[name] && this.attributes[name].type === 'textarea') {
                if (!this.attributes[name].hasOwnProperty('onInput')) {
                  this.attributes[name].onInput = function (model, params) {
                    if (model) {
                      params.curLength = model.length;
                    }
                  };
                }
                if (!this.attributes[name].curLength) {
                  this.attributes[name].curLength = 0;
                }
                if (!this.attributes[name].maxLength) {
                  this.attributes[name].maxLength = 500;
                }
              }

              // check box custom type
              if (this.attributes[name] && this.attributes[name].type === 'checkbox') {}

              // console.log('initializing:' + name)
              // console.log(this.attributes[name])
              this.$set(this.vuelidate.models[name], 'name', name);
              this.$set(this.vuelidate.models[name], 'attributes', this.attributes[name]);
              this.items.push(this.vuelidate.models[name]);
            }
          }
        }
      }
    },
    onRecaptcha: function onRecaptcha(onRecaptchaSuccess) {
      __WEBPACK_IMPORTED_MODULE_3__apis_Site__["a" /* default */].getRecaptcha().then(function (data) {
        // console.log('get recaptcha')
        // console.log(data)
        if (onRecaptchaSuccess) {
          onRecaptchaSuccess(data);
        }
      }).catch(function (error) {
        console.log('get recaptcha error');
        console.log(error);
      });
    },
    onRenderRecaptcha: function onRenderRecaptcha(id) {
      this.$emit('recaptcha', { status: 'init' });
    },
    onExpiredRecaptcha: function onExpiredRecaptcha() {
      this.$emit('recaptcha', { status: 'expired' });
    },
    onVerifyRecaptcha: function onVerifyRecaptcha(response) {
      console.log(response);
      if (response && response.length > 0) {
        this.$emit('recaptcha', { status: 'ok', response: response });
      }
    },
    onResetRecaptcha: function onResetRecaptcha() {
      this.$refs.recaptcha.reset();
      this.$emit('recaptcha', { status: 'reset' });
    },
    onApplicationChanged: function onApplicationChanged(applicationType) {
      console.log('application type changed: ' + applicationType);
    },
    onSend: function onSend(vuelidate) {
      vuelidate.models.$touch();
      // var _self = this
      // console.log(vuelidate)
      // console.log(this.models)
      this.$emit('send', { vuelidate: vuelidate, models: this.models, session: this.session, captcha: this.models.captcha });
    }
  }
});

/***/ }),

/***/ 498:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['error'],
  computed: {
    infos: function infos() {
      var infos = [];
      for (var i = 0; i < this.error.length; i++) {
        infos.push({
          message: this.error[i]
        });
      }
      return infos;
    }
  }
});

/***/ }),

/***/ 499:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import Vue from 'vue'
/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    type: {
      default: 'text'
    },
    name: {
      default: 'invalid'
    },
    mdi: {
      default: 'error_outline'
    },
    placeholder: {
      default: 'invalid'
    },
    value: {
      default: 'invalid'
    },
    error: {
      default: undefined
    },
    required: {
      default: true
    },
    disabled: {
      default: false
    },
    autofocus: {
      default: false
    }
  },
  data: function data() {
    return {
      model: ''
      // value: 'invalid@invalid.com'
      // name: 'invalid',
      // type: 'invalid',
      // fa: 'error',
      // placeholder: 'invalid',
      // error: undefined
    };
  },

  computed: {},
  methods: {
    onInput: function onInput(event) {
      this.model = event.target.value;
      this.$emit('onInput', { name: this.name, value: this.model });
    }
  },
  created: function created() {},
  mounted: function mounted() {},

  watch: {
    value: function value(val, old) {
      // to tally with external value
      this.model = this.value;

      // do not echo back!
      // this.$emit('onInput', { name: this.name, value: val })
    },
    model: function model(val, old) {
      // do not echo back!
      // this.$emit('onInput', { name: this.name, value: val })
    }
  }
});

/***/ }),

/***/ 500:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__apis_Site__ = __webpack_require__(15);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import EventBus from '@/controllers/EventBus'

// import Instafetch from '@/controllers/Instafetch'

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'masonry-instagram',
  components: {},
  data: function data() {
    return {
      isDesktop: true,
      itemsCache: [],
      items: [],
      itemsLoading: false,
      itemsEnded: false,
      itemsHasNext: false,
      itemsHasNextToken: undefined,
      itemsMax: 9,
      error: undefined
    };
  },

  computed: {},
  watch: {},
  created: function created() {
    // console.log('created InstagramSection.vue')
  },
  mounted: function mounted() {
    // console.log('mounted InstagramSection.vue')
    // window.GA('send', 'pageview')

    // on event resize
    this.isDesktop = window.innerWidth >= 768;
    window.addEventListener('resize', function (event) {
      // console.log('on viewport change')
      this.isDesktop = event.target.innerWidth >= 768;
    }.bind(this));

    // refresh masonry
    this.refresh();

    // var callbackInstagram = function (data) {
    //   console.log(data)
    // }
    // var fetcher = new Instafetch('15794449.23ef492.b92d5f8be35a469ebfaeceb6b259b3d7')
    // // var fetcher = new Instafetch('23ef492f142645d7892ae61d3697f3a6')
    // fetcher.fetch({
    //   // user: 15794449,
    //   tag: 'adamlobotv',
    //   limit: 88,
    //   callback: callbackInstagram
    //   // params: '9gagBlock'
    // })
  },

  methods: {
    onScrollTo: function (name) {
      this.$scrollTo('#' + name);
    }.bind(this),

    parseInstagramImageLink: function parseInstagramImageLink(link) {
      var linkOut = link.replace(/(https*:\/\/.*\/.*)\/.*\/.*\/.*(\/.*)/g, '$1$2');
      return linkOut;
    },

    getItems: function getItems(onComplete) {
      var _this = this;

      this.itemsLoading = true;
      __WEBPACK_IMPORTED_MODULE_0__apis_Site__["a" /* default */].instagramUser('5748558782.1677ed0.40f4033451474a879b4a621d646f9a0b', this.itemsHasNextToken).then(function (data) {
        // console.log('get gallery')
        // console.log(data)
        _this.itemsHasNext = data.hasNextPage;
        _this.itemsHasNextToken = data.maxId;
        onComplete(data.items);
        _this.itemsLoading = false;
      }).catch(function (error) {
        // console.log('invalid get gallery', error)
        _this.items = [];
        // this.error = error.error
        _this.error = error.error;
        _this.error = 'Unable to load, please kindly visit our Instagram account <a href="https://www.instagram.com/cms" target="_blank">here</a>.';
        _this.itemsLoading = false;
      });
    },
    refresh: function refresh() {
      var _this2 = this;

      this.getItems(function (items) {
        if (items && items.length > 0) {
          var limitItems = [];
          for (var i = 0; i < _this2.itemsMax; i++) {
            if (i < items.length) {
              limitItems.push(items[i]);
            }
          }
          _this2.items = limitItems;
        } else {
          _this2.items = [];
        }
      });
    },
    loadMore: function loadMore() {
      // return if exceed (showcase purpose)
      if (!this.itemsHasNext) {
        this.itemsEnded = true;
        this.$emit('onItemsEnded', {});
        return;
      }

      if (!this.itemsEnded) {
        this.getItems(function (items) {
          this.items = this.items.concat(items);
          if (this.items.length > this.itemsMax) {
            this.items = this.items.slice(0, this.itemsMax);
            this.itemsEnded = true;
            this.$emit('onItemsEnded', {});
          }
        }.bind(this));
      }
    }
  }
});

/***/ }),

/***/ 501:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_markdown__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_markdown___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_markdown__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__controllers_EventBus__ = __webpack_require__(16);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'MainDialog',
  props: ['visible', 'data'],
  components: {
    Markdown: __WEBPACK_IMPORTED_MODULE_1_vue_markdown___default.a
  },
  onMounted: function onMounted() {
    console.log('MainDialog:onMounted()', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(this.visible));
  },
  data: function data() {
    return {
      isDesktop: true
    };
  },
  created: function created() {},
  mounted: function mounted() {
    // on event resize
    this.isDesktop = __WEBPACK_IMPORTED_MODULE_2__controllers_EventBus__["a" /* default */]._isDesktop;
    __WEBPACK_IMPORTED_MODULE_2__controllers_EventBus__["a" /* default */].$on('isDesktopChanged', function () {
      this.isDesktop = __WEBPACK_IMPORTED_MODULE_2__controllers_EventBus__["a" /* default */]._isDesktop;
    }.bind(this));
  },

  methods: {
    onClose: function onClose() {
      this.$emit('onClose');
    }
  }
});

/***/ }),

/***/ 502:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__apis_Site__ = __webpack_require__(15);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import EventBus from '@/controllers/EventBus'

// import Instafetch from '@/controllers/Instafetch'

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'masonry-youtube',
  components: {},
  data: function data() {
    return {
      isDesktop: true,
      itemsCache: [],
      items: [],
      itemsLoading: false,
      itemsEnded: false,
      itemsHasNext: false,
      itemsHasNextToken: undefined,
      itemsMax: 48,
      error: undefined
    };
  },

  computed: {},
  watch: {},
  created: function created() {
    console.log('created MasonryYoutube.vue');
  },
  mounted: function mounted() {
    console.log('mounted MasonryYoutube.vue');
    // window.GA('send', 'pageview')

    // on event resize
    this.isDesktop = window.innerWidth >= 768;
    window.addEventListener('resize', function (event) {
      // console.log('on viewport change')
      this.isDesktop = event.target.innerWidth >= 768;
    }.bind(this));

    // refresh masonry
    this.refresh();
  },

  methods: {
    onScrollTo: function (name) {
      this.$scrollTo('#' + name);
    }.bind(this),

    parseInstagramImageLink: function parseInstagramImageLink(link) {
      var linkOut = link.replace(/(https*:\/\/.*\/.*)\/.*\/.*\/.*(\/.*)/g, '$1$2');
      return linkOut;
    },

    getItems: function getItems(onComplete) {
      var _this = this;

      this.itemsLoading = true;
      this.error = undefined;
      // Youtube.authenticate({
      //   type: 'key',
      //   key: 'AIzaSyBm43-gK1svcMQ7ULIOPOCOkdv1NX77TxM'
      // })
      // var params = {
      //   term: 'search',
      //   part: 'snippet',
      //   channelId: 'UCLXo7UDZvByw2ixzpQCufnA',
      //   order: 'date',
      //   type: 'video',
      //   videoSyndicated: true,
      //   maxResults: 50,
      //   key: 'AIzaSyBm43-gK1svcMQ7ULIOPOCOkdv1NX77TxM'
      // }
      // apis.get('https://www.googleapis.com/youtube/v3/search?part=snippet&channelId=UCLXo7UDZvByw2ixzpQCufnA&order=date&type=video&videoSyndicated=true&maxResults=50&key=AIzaSyBm43-gK1svcMQ7ULIOPOCOkdv1NX77TxM')
      var params = {
        term: 'playlistItems',
        part: 'snippet',
        playlistId: 'UUy4ssRxw_k0XdiH31OxVHmA',
        maxResults: 12,
        key: 'AIzaSyB0p_sU61SfOC0Pe2-I-gBZl8ebk6xaeJw'
      };
      __WEBPACK_IMPORTED_MODULE_0__apis_Site__["a" /* default */].youtube(params.term, params).then(function (data) {
        // console.log('Youtube Response')
        // console.log(data)
        _this.itemsHasNext = false;
        _this.itemsHasNextToken = undefined;
        onComplete(data.items);
        _this.itemsEnded = true;
        _this.$emit('onItemsEnded', {});
        _this.itemsLoading = false;
      }).catch(function (error) {
        console.log('Youtube Error');
        console.log(error);
        _this.itemsHasNext = false;
        _this.itemsHasNextToken = undefined;
        _this.items = [];
        _this.error = error.error;
        _this.error = 'Unable to load, please kindly visit our Youtube account <a href="https://www.youtube.com/cms" target="_blank">here</a>.';
        _this.itemsEnded = true;
        _this.$emit('onItemsEnded', {});
        _this.itemsLoading = false;
      });
    },
    refresh: function refresh() {
      var _this2 = this;

      this.getItems(function (items) {
        _this2.items = items;
      });
    },
    loadMore: function loadMore() {
      // return if exceed (showcase purpose)
      // if (!this.itemsHasNext) {
      //   this.itemsEnded = true
      //   this.$emit('onItemsEnded', {})
      //   return
      // }
      //
      // if (!this.itemsEnded) {
      //   this.getItems(function (items) {
      //     this.items = this.items.concat(items)
      //     if (this.items.length > this.itemsMax) {
      //       this.items = this.items.slice(0, this.itemsMax)
      //       this.itemsEnded = true
      //       this.$emit('onItemsEnded', {})
      //     }
      //   }.bind(this))
      // }
    }
  }
});

/***/ }),

/***/ 503:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__controllers_EventBus__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__apis_Site__ = __webpack_require__(15);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'navbarfull',
  props: ['toggle'],
  data: function data() {
    return {
      showNav: false,
      navItems: __WEBPACK_IMPORTED_MODULE_2__controllers_EventBus__["a" /* default */].getNav(),
      phone: undefined,
      fax: undefined,
      address: undefined
    };
  },

  computed: {},
  watch: {
    toggle: function toggle(val) {
      this.showNav = val;
    },
    '$route.name': function $routeName(val) {
      // only do this when overlay mode and route change
      if (this.showNav) {
        this.onToggle();
      }
    }
  },
  beforeCreate: function beforeCreate() {
    // in this function
    // modification to data will not invoke
  },
  created: function created() {},
  beforeMount: function beforeMount() {},
  mounted: function mounted() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      var data;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              data = void 0;
              _context.next = 4;
              return __WEBPACK_IMPORTED_MODULE_3__apis_Site__["a" /* default */].infoNamed('navbar-phone');

            case 4:
              data = _context.sent;

              if (data && data[0] && data[0].content) {
                _this.phone = data[0].content;
              } else {
                _this.phone = undefined;
              }
              _context.next = 8;
              return __WEBPACK_IMPORTED_MODULE_3__apis_Site__["a" /* default */].infoNamed('navbar-fax');

            case 8:
              data = _context.sent;

              if (data && data[0] && data[0].content) {
                _this.fax = data[0].content;
              } else {
                _this.fax = undefined;
              }
              _context.next = 12;
              return __WEBPACK_IMPORTED_MODULE_3__apis_Site__["a" /* default */].infoNamed('navbar-address');

            case 12:
              data = _context.sent;

              if (data && data[0] && data[0].content) {
                _this.address = data[0].content;
              } else {
                _this.address = undefined;
              }
              _context.next = 22;
              break;

            case 16:
              _context.prev = 16;
              _context.t0 = _context['catch'](0);

              _this.phone = undefined;
              _this.fax = undefined;
              _this.address = undefined;
              console.log('info error', _context.t0);

            case 22:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this, [[0, 16]]);
    }))();
  },

  methods: {
    onScrollTo: function onScrollTo(name, target) {
      if (this.$route.name !== name) {
        this.$router.replace({ name: name, query: { anchor: target } });
      } else {
        this.$scrollTo('#' + target, { offset: -30 });
      }
    },

    onToggle: function onToggle() {
      this.showNav = !this.showNav;
      var className = 'modal-open';
      var root = document.documentElement;
      root.className = '';
      if (this.showNav) {
        root.className += className;
      } else {
        root.className -= className;
      }
      this.$emit('onToggle', this.showNav);
    }
  }
});

/***/ }),

/***/ 504:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__controllers_EventBus__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__NavBarFull_vue__ = __webpack_require__(412);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__NavBarFull_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__NavBarFull_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__apis_Site__ = __webpack_require__(15);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'topsection',
  components: {
    'NavbarFull': __WEBPACK_IMPORTED_MODULE_3__NavBarFull_vue___default.a
  },
  data: function data() {
    return {
      toggle: false,
      navItems: __WEBPACK_IMPORTED_MODULE_2__controllers_EventBus__["a" /* default */].getNav(),
      phone: undefined,
      fax: undefined,
      address: undefined
    };
  },

  watch: {
    toggle: function toggle(val) {
      // console.log('toggle changed to: ' + val)
    }
  },
  mounted: function mounted() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      var data;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              data = void 0;
              _context.next = 4;
              return __WEBPACK_IMPORTED_MODULE_4__apis_Site__["a" /* default */].infoNamed('navbar-phone');

            case 4:
              data = _context.sent;

              if (data && data[0] && data[0].content) {
                _this.phone = data[0].content;
              } else {
                _this.phone = undefined;
              }
              _context.next = 8;
              return __WEBPACK_IMPORTED_MODULE_4__apis_Site__["a" /* default */].infoNamed('navbar-fax');

            case 8:
              data = _context.sent;

              if (data && data[0] && data[0].content) {
                _this.fax = data[0].content;
              } else {
                _this.fax = undefined;
              }
              _context.next = 12;
              return __WEBPACK_IMPORTED_MODULE_4__apis_Site__["a" /* default */].infoNamed('navbar-address');

            case 12:
              data = _context.sent;

              if (data && data[0] && data[0].content) {
                _this.address = data[0].content;
              } else {
                _this.address = undefined;
              }
              _context.next = 22;
              break;

            case 16:
              _context.prev = 16;
              _context.t0 = _context['catch'](0);

              _this.phone = undefined;
              _this.fax = undefined;
              _this.address = undefined;
              console.log('info error', _context.t0);

            case 22:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this, [[0, 16]]);
    }))();
  },

  methods: {
    onScrollTo: function onScrollTo(name, target) {
      if (this.$route.name !== name) {
        this.$router.replace({ name: name, query: { anchor: target } });
      } else {
        this.toggle = !this.toggle;
        var root = document.documentElement;
        root.className = '';

        // this.$scrollTo(el)
        this.$scrollTo('#' + target, { offset: -50 });
      }
    }
  }
});

/***/ }),

/***/ 505:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuelidate__ = __webpack_require__(185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuelidate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vuelidate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__ = __webpack_require__(186);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__apis_Site__ = __webpack_require__(15);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'newslettersection',
  mixins: [__WEBPACK_IMPORTED_MODULE_0_vuelidate__["validationMixin"]],
  data: function data() {
    return {
      name: '',
      email: '',
      // captcha: '',
      // session: '',
      captchaImage: undefined,
      feedback: false,
      loading: false
    };
  },
  mounted: function mounted() {
    // this.onRecaptcha(data => {
    //   console.log('recaptcha data!')
    //   this.captchaImage = data.data
    //   this.session = data.id
    // })
  },
  methods: {
    onRecaptcha: function onRecaptcha(onRecaptchaSuccess) {
      // Site.getRecaptcha()
      // .then(data => {
      //   console.log('get recaptcha')
      //   console.log(data)
      //   if (onRecaptchaSuccess) {
      //     onRecaptchaSuccess(data)
      //   }
      // })
      // .catch(error => {
      //   console.log('get recaptcha error')
      //   console.log(error)
      // })
    },
    onSend: function onSend($v) {
      var _self = this;
      if ($v.$invalid) {
        _self.feedback = 'Please fill in all fields to proceed.';
        // _self.$toast.open({
        //   duration: 5000,
        //   message: 'Please fill in all fields to proceed.',
        //   position: 'is-bottom',
        //   type: 'is-warning'
        // })
      } else {
        _self.feedback = false;
        _self.loading = true;
        __WEBPACK_IMPORTED_MODULE_2__apis_Site__["a" /* default */].subscribe(_self.name, _self.email).then(function (data) {
          console.log('email sent');
          _self.loading = false;
          _self.name = '';
          _self.email = '';

          if (data && data.status !== 'ok') {
            _self.feedback = 'Oops. Something went wrong. Please try again later..';
            return;
          }

          // _self.session = '' // open up to maintain session
          // _self.$toast.open({
          //   message: 'We will be contacting you via email or phone. Thanks!',
          //   position: 'is-bottom',
          //   type: 'is-success'
          // })
          _self.feedback = 'Subscribed. Thanks!';
          _self.loading = false;
        }).catch(function (error) {
          console.log('invalid email', error);
          // this.error = error.error
          console.log(error);
          _self.captcha = '';

          // invalid recaptcha
          if (error && error.code === 103) {
            _self.feedback = error.error;
            _self.loading = false;
            return;
          }

          // _self.$toast.open({
          //   duration: 5000,
          //   message: 'Oops. Something went wrong. Please email us directly at contact@clientmanagementprobation.com',
          //   position: 'is-bottom',
          //   type: 'is-warning'
          // })
          _self.feedback = 'Oops. Something went wrong. Please try again later..';
          _self.loading = false;
        });
      }
    }
  },
  validations: {
    email: {
      required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"],
      email: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["email"]
    },
    name: {
      required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"]
    }
  }
});

/***/ }),

/***/ 506:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_DivContainer__ = __webpack_require__(184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_DivContainer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_DivContainer__);
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'page-subheader',
  props: ['title', 'text-align', 'title-style'],
  components: {
    DivContainer: __WEBPACK_IMPORTED_MODULE_0__components_DivContainer___default.a
  },
  data: function data() {
    return {};
  },

  computed: {},
  watch: {},
  created: function created() {},
  mounted: function mounted() {},

  methods: {
    refresh: function refresh() {}
  }
});

/***/ }),

/***/ 507:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import Site from '@/apis/Site'
// import ImageMoreBg from '@/assets/thumb_6.jpg'
// import ShowDown from 'showdown'
// import Thumb1 from '@/assets/thumb_1.jpg'
// import Thumb2 from '@/assets/thumb_2.jpg'
// import Thumb3 from '@/assets/thumb_3.jpg'
// import Thumb4 from '@/assets/thumb_4.jpg'
// import Thumb5 from '@/assets/thumb_5.jpg'

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'about',
  props: ['type', 'full'],
  components: {},
  data: function data() {
    return {
      isDesktop: true,
      split: 3,
      shows: [],
      error: undefined,
      loading: false
    };
  },

  computed: {},
  watch: {},
  created: function created() {},
  mounted: function mounted() {
    this.refresh();

    // on event resize
    this.isDesktop = window.innerWidth >= 769;
    window.addEventListener('resize', function (event) {
      // console.log('on viewport change')
      this.isDesktop = event.target.innerWidth >= 769;
    }.bind(this));
  },

  methods: {
    onScrollTo: function (name) {
      this.$scrollTo('#' + name);
    }.bind(this),

    getItems: function getItems(onComplete) {
      this.loading = true;
      this.error = undefined;
      this.shows = [];
      this.loading = false;
      if (onComplete) {
        onComplete([{
          title: 'Chris Chew',
          subtitle: 'Photographer, Filmmaker, Visual Artist',
          date_actual: '2019-08-12 16:13:33',
          // url_1: 'http://www.google.com',
          image: {
            path: '' // Thumb1
          }
        }, {
          title: 'Yuna',
          subtitle: 'R&B Singer-Songwriter',
          date_actual: '2019-08-12 16:13:33',
          // url_1: 'http://www.google.com',
          image: {
            path: '' // Thumb2
          }
        }, {
          title: 'Midnight Fusic',
          subtitle: 'Indie Rock',
          date_actual: '2019-08-12 16:13:33',
          // url_1: 'http://www.google.com',
          image: {
            path: '' // Thumb3
          }
        }, {
          title: 'Project EAR',
          subtitle: 'Southeast Asia Rock Collective',
          date_actual: '2019-08-12 16:13:33',
          // url_1: 'http://www.google.com',
          image: {
            path: '' // Thumb4
          }
        }, {
          title: 'Shoffy',
          subtitle: 'Singer-Songwriter',
          date_actual: '2019-08-12 16:13:33',
          // url_1: 'http://www.google.com',
          image: {
            path: '' // Thumb5
          }
        }]);
      }
      // if (this.type === 'upcoming') {
      //   Site.eventUpcoming()
      //   .then((data) => {
      //     // console.log('upcoming:', data)
      //     this.loading = false
      //     if (onComplete) {
      //       onComplete(data)
      //     }
      //   })
      //   .catch((error) => {
      //     this.loading = false
      //     this.error = 'Unable to load, please kindly refresh the page.'
      //     console.log(error)
      //   })
      // } else if (this.type === 'previous') {
      //   Site.eventPrevious()
      //   .then((data) => {
      //     console.log('previous:', data)
      //     this.loading = false
      //     if (onComplete) {
      //       onComplete(data)
      //     }
      //   })
      //   .catch((error) => {
      //     this.loading = false
      //     this.error = 'Unable to load, please kindly refresh the page.'
      //     console.log(error)
      //   })
      // }
    },
    refresh: function refresh() {
      var _this = this;

      this.getItems(function (items) {
        if (items && items.length > 0) {
          if (items.length === 1 || items.length === 2 || items.length === 4) {
            _this.split = 2;
          } else {
            _this.split = 3;
          }
          for (var i = 0; i < items.length; i++) {
            if (i % 3 === 0) {
              items[i].btnClass = 'is-green';
            } else if (i % 3 === 1) {
              items[i].btnClass = 'is-red';
            } else {
              items[i].btnClass = 'is-blue';
            }
          }
          var allItems = [];
          if (_this.full === 'true') {
            allItems = items;
          } else {
            for (var j = 0; j < 5; j++) {
              if (j < items.length) {
                allItems.push(items[j]);
              }
            }
            if (items.length >= 5) {
              allItems.push({
                image: {
                  path: '' // ImageMoreBg
                },
                isMore: true
              });
            }
          }
          _this.shows = allItems;
        } else {
          _this.error = 'Invalid content.';
        }
      });
    }
  }
});

/***/ }),

/***/ 508:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import _ from 'lodash'
/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'sidebar',
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    next(function (vm) {
      vm.activeLink = to.path;
    });
  },
  beforeRouteUpdate: function beforeRouteUpdate(to, from, next) {
    this.activeLink = to.path;
    next();
  },

  // mounted () {
  //   console.log('Component mounted.')
  //   let match = _.chain(this.$route.matched).sortBy(n => n.path.length).last().value()
  //   this.activeLink = match.path
  // },
  data: function data() {
    return {
      activeLink: null
    };
  }
});

/***/ }),

/***/ 509:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_slick__ = __webpack_require__(413);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_lightbox__ = __webpack_require__(411);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_lightbox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_lightbox__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import Site from '@/apis/Site'


// import SampleImage from '../assets/banner.jpg'
// import SampleImageMobile from '../assets/banner_mobile.jpg'

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'landing',
  components: {
    Slick: __WEBPACK_IMPORTED_MODULE_0_vue_slick__["a" /* default */],
    Lightbox: __WEBPACK_IMPORTED_MODULE_1_vue_lightbox___default.a
  },
  data: function data() {
    return {
      isDesktop: true,
      slickOptions: {
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
        dots: true,
        fade: true,
        speed: 1000,
        swipe: false,
        swipeToSlide: false,
        touchMove: false,
        autoplay: true,
        autoplaySpeed: 4000,
        pauseOnHover: false,
        pauseOnFocus: false,
        pauseOnDotsHover: false,
        focusOnSelect: false,
        responsive: [{
          breakpoint: 1008,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: true,
            dots: true
          }
        }, {
          // 768 = tablet (not break yet)
          breakpoint: 769,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: false,
            dots: true
          }
        }, {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: false,
            dots: true
          }
        }]
      },
      items: [],
      itemsEnded: false,
      error: undefined,
      loading: true,
      scrollPos: 0
    };
  },

  computed: {},
  watch: {},
  created: function created() {
    // console.log('created TopSection.vue')
  },
  mounted: function mounted() {
    // console.log('mounted TopSection.vue')
    // window.GA('send', 'pageview')

    // on event resize
    this.isDesktop = window.innerWidth >= 768;
    window.addEventListener('resize', function (event) {
      // console.log('on viewport change')
      this.isDesktop = event.target.innerWidth >= 768;
    }.bind(this));

    this.refresh();
  },

  methods: {
    onScrollTo: function (name) {
      this.$scrollTo('#' + name);
    }.bind(this),

    next: function next() {
      if (this.$refs.slick) {
        this.$refs.slick.next();
      }
    },
    prev: function prev() {
      if (this.$refs.slick) {
        this.$refs.slick.prev();
      }
    },
    reInit: function reInit() {
      if (this.$refs.slick) {
        this.$refs.slick.reSlick();
      }
    },

    loadItems: function loadItems() {
      this.loading = true;
      this.error = undefined;
      this.items = [{
        image: {
          // path: SampleImage
        },
        image_mobile: {
          path: '' // SampleImageMobile
        }
      }];
      this.$nextTick(function () {
        this.reInit();
      });
      this.reInit();
      this.loading = false;
      // Site.carousel()
      // .then((data) => {
      //   console.log('items', data)
      //   this.items = data
      //   this.$nextTick(function () {
      //     this.reInit()
      //   })
      //   this.reInit()
      //   this.loading = false
      // })
      // .catch((error) => {
      //   this.error = error
      //   this.error = 'Unable to load, please kindly refresh the page.'
      //   this.loading = false
      // })
    },
    refresh: function refresh() {
      this.loadItems();
    },
    renderYtSubscribeButton: function renderYtSubscribeButton(channel) {
      /* global gapi */
      var container = document.getElementById('yt-button-container-render');
      var options = {
        'channel': channel,
        'layout': 'full'
      };
      gapi.ytsubscribe.render(container, options);
    }
  }
});

/***/ }),

/***/ 510:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_markdown__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_markdown___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_markdown__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__controllers_EventBus__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__apis_Site__ = __webpack_require__(15);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'page-about',
  components: {
    Markdown: __WEBPACK_IMPORTED_MODULE_2_vue_markdown___default.a
  },
  data: function data() {
    return {
      isDesktop: true,
      about: undefined,
      note: undefined
    };
  },

  computed: {},
  watch: {},
  created: function created() {},
  mounted: function mounted() {
    // on event resize
    this.isDesktop = __WEBPACK_IMPORTED_MODULE_3__controllers_EventBus__["a" /* default */]._isDesktop;
    __WEBPACK_IMPORTED_MODULE_3__controllers_EventBus__["a" /* default */].$on('isDesktopChanged', function () {
      this.isDesktop = __WEBPACK_IMPORTED_MODULE_3__controllers_EventBus__["a" /* default */]._isDesktop;
    }.bind(this));

    this.getAbout();
    this.getNote();
  },

  methods: {
    getAbout: function getAbout() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var data;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                data = void 0;
                // about

                _this.about = undefined;
                _context.next = 5;
                return __WEBPACK_IMPORTED_MODULE_4__apis_Site__["a" /* default */].aboutNamed('about');

              case 5:
                data = _context.sent;

                if (data && data[0]) {
                  data = data[0];
                  _this.about = data;
                }
                _context.next = 12;
                break;

              case 9:
                _context.prev = 9;
                _context.t0 = _context['catch'](0);

                console.log('about error', _context.t0);

              case 12:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[0, 9]]);
      }))();
    },
    getNote: function getNote() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var data;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                data = void 0;
                // note

                _this2.note = undefined;
                _context2.next = 5;
                return __WEBPACK_IMPORTED_MODULE_4__apis_Site__["a" /* default */].aboutNamed('about-note');

              case 5:
                data = _context2.sent;

                if (data && data[0]) {
                  data = data[0];
                  _this2.note = data;
                }
                _context2.next = 12;
                break;

              case 9:
                _context2.prev = 9;
                _context2.t0 = _context2['catch'](0);

                console.log('about error', _context2.t0);

              case 12:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2, [[0, 9]]);
      }))();
    }
  }
});

/***/ }),

/***/ 511:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_markdown__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_markdown___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_markdown__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__controllers_EventBus__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__apis_Site__ = __webpack_require__(15);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'page-faq',
  components: {
    Markdown: __WEBPACK_IMPORTED_MODULE_2_vue_markdown___default.a
  },
  data: function data() {
    return {
      isDesktop: true,
      faqdata: undefined,
      faqs: undefined
    };
  },

  computed: {},
  watch: {},
  created: function created() {},
  mounted: function mounted() {
    // on event resize
    this.isDesktop = __WEBPACK_IMPORTED_MODULE_3__controllers_EventBus__["a" /* default */]._isDesktop;
    __WEBPACK_IMPORTED_MODULE_3__controllers_EventBus__["a" /* default */].$on('isDesktopChanged', function () {
      this.isDesktop = __WEBPACK_IMPORTED_MODULE_3__controllers_EventBus__["a" /* default */]._isDesktop;
    }.bind(this));

    this.getFaqData();
    this.getFaqs();
  },

  methods: {
    getFaqData: function getFaqData() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var data;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                data = void 0;
                // faq data

                _this.faqdata = undefined;
                _context.next = 5;
                return __WEBPACK_IMPORTED_MODULE_4__apis_Site__["a" /* default */].aboutNamed('faq');

              case 5:
                data = _context.sent;

                if (data && data[0]) {
                  data = data[0];
                  _this.faqdata = data;
                }
                _context.next = 12;
                break;

              case 9:
                _context.prev = 9;
                _context.t0 = _context['catch'](0);

                console.log('faq error', _context.t0);

              case 12:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[0, 9]]);
      }))();
    },
    getFaqs: function getFaqs() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var data;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                data = void 0;
                // faq

                _this2.faqs = undefined;
                _context2.next = 5;
                return __WEBPACK_IMPORTED_MODULE_4__apis_Site__["a" /* default */].faqs();

              case 5:
                data = _context2.sent;

                if (data) {
                  _this2.faqs = data;
                }
                _context2.next = 12;
                break;

              case 9:
                _context2.prev = 9;
                _context2.t0 = _context2['catch'](0);

                console.log('faq error', _context2.t0);

              case 12:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2, [[0, 9]]);
      }))();
    }
  }
});

/***/ }),

/***/ 512:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_slick__ = __webpack_require__(413);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_markdown__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_markdown___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_markdown__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__controllers_EventBus__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_MasonryYoutube_vue__ = __webpack_require__(943);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_MasonryYoutube_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_MasonryYoutube_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_AboutSection_vue__ = __webpack_require__(936);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_AboutSection_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_AboutSection_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_ShowSection_vue__ = __webpack_require__(947);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_ShowSection_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_ShowSection_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_NewsletterSection_vue__ = __webpack_require__(945);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_NewsletterSection_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_NewsletterSection_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_InstagramSection_vue__ = __webpack_require__(941);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_InstagramSection_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_InstagramSection_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_ContactSection_vue__ = __webpack_require__(937);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_ContactSection_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_ContactSection_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_MainDialog_vue__ = __webpack_require__(942);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_MainDialog_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__components_MainDialog_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__apis_Site__ = __webpack_require__(15);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//















/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'landing',
  components: {
    MasonryYoutube: __WEBPACK_IMPORTED_MODULE_5__components_MasonryYoutube_vue___default.a,
    AboutSection: __WEBPACK_IMPORTED_MODULE_6__components_AboutSection_vue___default.a,
    ShowSection: __WEBPACK_IMPORTED_MODULE_7__components_ShowSection_vue___default.a,
    NewsletterSection: __WEBPACK_IMPORTED_MODULE_8__components_NewsletterSection_vue___default.a,
    InstagramSection: __WEBPACK_IMPORTED_MODULE_9__components_InstagramSection_vue___default.a,
    ContactSection: __WEBPACK_IMPORTED_MODULE_10__components_ContactSection_vue___default.a,
    Slick: __WEBPACK_IMPORTED_MODULE_2_vue_slick__["a" /* default */],
    Markdown: __WEBPACK_IMPORTED_MODULE_3_vue_markdown___default.a,
    MainDialog: __WEBPACK_IMPORTED_MODULE_11__components_MainDialog_vue___default.a
  },
  data: function data() {
    return {
      isDesktop: true,
      loading: false,
      error: undefined,
      scrollPos: 0,
      slickOptions: {
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
        dots: true,
        fade: false,
        speed: 1000,
        swipe: false,
        swipeToSlide: false,
        touchMove: false,
        autoplay: true,
        autoplaySpeed: 4000,
        pauseOnHover: false,
        pauseOnFocus: false,
        pauseOnDotsHover: false,
        focusOnSelect: false,
        responsive: [{
          breakpoint: 1008,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: true,
            dots: true
          }
        }, {
          // 768 = tablet (not break yet)
          breakpoint: 769,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: false,
            dots: true
          }
        }, {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: false,
            dots: true
          }
        }]
      },
      banner: undefined,
      statement: undefined,
      contacts: undefined,
      note: undefined,
      hotlinks: undefined,
      testimonials: undefined,
      message: undefined,
      dialogVisible: true
    };
  },

  computed: {},
  watch: {},
  created: function created() {
    // console.log('created Landing.vue')
  },
  mounted: function mounted() {
    // console.log('mounted Landing.vue')
    // window.GA('send', 'pageview')

    if (this.$route.query && this.$route.query.anchor) {
      console.log('automatic scroll to...: ' + this.$route.query.anchor);
      setTimeout(function () {
        this.$scrollTo('#' + this.$route.query.anchor);
      }.bind(this), 1000);
    }

    // on event resize
    this.isDesktop = __WEBPACK_IMPORTED_MODULE_4__controllers_EventBus__["a" /* default */]._isDesktop;
    __WEBPACK_IMPORTED_MODULE_4__controllers_EventBus__["a" /* default */].$on('isDesktopChanged', function () {
      this.isDesktop = __WEBPACK_IMPORTED_MODULE_4__controllers_EventBus__["a" /* default */]._isDesktop;
    }.bind(this));

    this.getBanner();
    this.getStatement();
    this.getContacts();
    this.getNote();
    this.getHotlinks();
    this.getTestimonials();
    this.getMessage();
  },

  methods: {
    getBanner: function getBanner() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var data;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                data = void 0;
                // banner

                _this.banner = undefined;
                _context.next = 5;
                return __WEBPACK_IMPORTED_MODULE_12__apis_Site__["a" /* default */].infoNamed('landing-banner');

              case 5:
                data = _context.sent;

                if (!(data && data[0])) {
                  _context.next = 17;
                  break;
                }

                data = data[0];

                if (!(data.image && data.image.path)) {
                  _context.next = 12;
                  break;
                }

                _context.next = 11;
                return __WEBPACK_IMPORTED_MODULE_4__controllers_EventBus__["a" /* default */].loadImage(data.image.path);

              case 11:
                data.img = _context.sent;

              case 12:
                if (!(data.image_mobile && data.image_mobile.path)) {
                  _context.next = 16;
                  break;
                }

                _context.next = 15;
                return __WEBPACK_IMPORTED_MODULE_4__controllers_EventBus__["a" /* default */].loadImage(data.image_mobile.path);

              case 15:
                data.imgMobile = _context.sent;

              case 16:
                _this.banner = data;

              case 17:
                _context.next = 22;
                break;

              case 19:
                _context.prev = 19;
                _context.t0 = _context['catch'](0);

                console.log('info error', _context.t0);

              case 22:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[0, 19]]);
      }))();
    },
    getStatement: function getStatement() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var data;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                data = void 0;
                // statement

                _this2.statement = undefined;
                _context2.next = 5;
                return __WEBPACK_IMPORTED_MODULE_12__apis_Site__["a" /* default */].infoNamed('landing-statement');

              case 5:
                data = _context2.sent;

                if (data && data[0]) {
                  data = data[0];
                  _this2.statement = data;
                }
                _context2.next = 12;
                break;

              case 9:
                _context2.prev = 9;
                _context2.t0 = _context2['catch'](0);

                console.log('info error', _context2.t0);

              case 12:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2, [[0, 9]]);
      }))();
    },
    getContacts: function getContacts() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var data;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;
                data = void 0;
                // contacts

                _this3.contacts = undefined;
                _context3.next = 5;
                return __WEBPACK_IMPORTED_MODULE_12__apis_Site__["a" /* default */].infoNamed('landing-contacts');

              case 5:
                data = _context3.sent;

                if (data && data[0]) {
                  data = data[0];
                  _this3.contacts = data;
                }
                _context3.next = 12;
                break;

              case 9:
                _context3.prev = 9;
                _context3.t0 = _context3['catch'](0);

                console.log('info error', _context3.t0);

              case 12:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this3, [[0, 9]]);
      }))();
    },
    getNote: function getNote() {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var data;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.prev = 0;
                data = void 0;
                // note

                _this4.note = undefined;
                _context4.next = 5;
                return __WEBPACK_IMPORTED_MODULE_12__apis_Site__["a" /* default */].infoNamed('landing-note');

              case 5:
                data = _context4.sent;

                if (data && data[0]) {
                  data = data[0];
                  _this4.note = data;
                }
                _context4.next = 12;
                break;

              case 9:
                _context4.prev = 9;
                _context4.t0 = _context4['catch'](0);

                console.log('info error', _context4.t0);

              case 12:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this4, [[0, 9]]);
      }))();
    },
    getHotlinks: function getHotlinks() {
      var _this5 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5() {
        var data;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.prev = 0;
                data = void 0;
                // hotlinks

                _this5.hotlinks = undefined;
                _context5.next = 5;
                return __WEBPACK_IMPORTED_MODULE_12__apis_Site__["a" /* default */].hotlinkNameLike('hotlink-');

              case 5:
                data = _context5.sent;

                if (data && data.length > 0) {
                  _this5.hotlinks = data;
                }
                _context5.next = 12;
                break;

              case 9:
                _context5.prev = 9;
                _context5.t0 = _context5['catch'](0);

                console.log('info error', _context5.t0);

              case 12:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, _this5, [[0, 9]]);
      }))();
    },
    getTestimonials: function getTestimonials() {
      var _this6 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6() {
        var data;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.prev = 0;
                data = void 0;
                // testimonials (service table in october db)

                _this6.testimonials = undefined;
                _context6.next = 5;
                return __WEBPACK_IMPORTED_MODULE_12__apis_Site__["a" /* default */].services();

              case 5:
                data = _context6.sent;

                if (data && data.length > 0) {
                  _this6.testimonials = data;
                }
                _context6.next = 12;
                break;

              case 9:
                _context6.prev = 9;
                _context6.t0 = _context6['catch'](0);

                console.log('info error', _context6.t0);

              case 12:
              case 'end':
                return _context6.stop();
            }
          }
        }, _callee6, _this6, [[0, 9]]);
      }))();
    },
    getMessage: function getMessage() {
      var _this7 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee7() {
        var data;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.prev = 0;
                data = void 0;
                // message

                _this7.message = undefined;
                _context7.next = 5;
                return __WEBPACK_IMPORTED_MODULE_12__apis_Site__["a" /* default */].infoNamed('message');

              case 5:
                data = _context7.sent;

                if (data != null && data.length > 0 && Array.isArray) {
                  data = data[0];
                }
                if (data) {
                  _this7.message = data;
                  _this7.$nextTick(function () {
                    _this7.dialogVisible = true;
                  });
                }
                _context7.next = 13;
                break;

              case 10:
                _context7.prev = 10;
                _context7.t0 = _context7['catch'](0);

                console.log('info error', _context7.t0);

              case 13:
              case 'end':
                return _context7.stop();
            }
          }
        }, _callee7, _this7, [[0, 10]]);
      }))();
    },
    onScrollTo: function onScrollTo(name, target) {
      if (this.$route.name !== name) {
        this.$router.replace({ name: name, query: { anchor: target } });
      } else {
        this.$scrollTo('#' + target, { offset: -30 });
      }
    },
    next: function next() {
      if (this.$refs.slick) {
        this.$refs.slick.next();
      }
    },
    prev: function prev() {
      if (this.$refs.slick) {
        this.$refs.slick.prev();
      }
    },
    reInit: function reInit() {
      if (this.$refs.slick) {
        this.$refs.slick.reSlick();
      }
    },


    onCloseDialog: function onCloseDialog() {
      this.dialogVisible = false;
    }
  }
});

/***/ }),

/***/ 513:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_markdown__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_markdown___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_markdown__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__controllers_EventBus__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__apis_Site__ = __webpack_require__(15);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'page-links',
  components: {
    Markdown: __WEBPACK_IMPORTED_MODULE_2_vue_markdown___default.a
  },
  data: function data() {
    return {
      isDesktop: true,
      linksdata: undefined,
      links: undefined
    };
  },

  computed: {},
  watch: {},
  created: function created() {},
  mounted: function mounted() {
    // on event resize
    this.isDesktop = __WEBPACK_IMPORTED_MODULE_3__controllers_EventBus__["a" /* default */]._isDesktop;
    __WEBPACK_IMPORTED_MODULE_3__controllers_EventBus__["a" /* default */].$on('isDesktopChanged', function () {
      this.isDesktop = __WEBPACK_IMPORTED_MODULE_3__controllers_EventBus__["a" /* default */]._isDesktop;
    }.bind(this));

    this.getLinksData();
    this.getLinks();
  },

  methods: {
    getLinksData: function getLinksData() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var data;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                data = void 0;
                // linksdata

                _this.linksdata = undefined;
                _context.next = 5;
                return __WEBPACK_IMPORTED_MODULE_4__apis_Site__["a" /* default */].aboutNamed('links');

              case 5:
                data = _context.sent;

                if (data && data[0]) {
                  data = data[0];
                  _this.linksdata = data;
                }
                _context.next = 12;
                break;

              case 9:
                _context.prev = 9;
                _context.t0 = _context['catch'](0);

                console.log('links error', _context.t0);

              case 12:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[0, 9]]);
      }))();
    },
    getLinks: function getLinks() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var data;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                data = void 0;
                // links

                _this2.links = undefined;
                _context2.next = 5;
                return __WEBPACK_IMPORTED_MODULE_4__apis_Site__["a" /* default */].hotlinkNameLike('external-link');

              case 5:
                data = _context2.sent;

                if (data) {
                  _this2.links = data;
                }
                _context2.next = 12;
                break;

              case 9:
                _context2.prev = 9;
                _context2.t0 = _context2['catch'](0);

                console.log('links error', _context2.t0);

              case 12:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2, [[0, 9]]);
      }))();
    }
  }
});

/***/ }),

/***/ 514:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'notfound',
  components: {}
});

/***/ }),

/***/ 515:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_markdown__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_markdown___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_markdown__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__controllers_EventBus__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__apis_Site__ = __webpack_require__(15);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'page-services',
  components: {
    Markdown: __WEBPACK_IMPORTED_MODULE_2_vue_markdown___default.a
  },
  data: function data() {
    return {
      isDesktop: true,
      services: undefined,
      note: undefined
    };
  },

  computed: {},
  watch: {},
  created: function created() {},
  mounted: function mounted() {
    // on event resize
    this.isDesktop = __WEBPACK_IMPORTED_MODULE_3__controllers_EventBus__["a" /* default */]._isDesktop;
    __WEBPACK_IMPORTED_MODULE_3__controllers_EventBus__["a" /* default */].$on('isDesktopChanged', function () {
      this.isDesktop = __WEBPACK_IMPORTED_MODULE_3__controllers_EventBus__["a" /* default */]._isDesktop;
    }.bind(this));

    this.getServices();
    this.getNote();
  },

  methods: {
    getServices: function getServices() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var data;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                data = void 0;
                // services

                _this.services = undefined;
                _context.next = 5;
                return __WEBPACK_IMPORTED_MODULE_4__apis_Site__["a" /* default */].aboutNamed('services');

              case 5:
                data = _context.sent;

                if (data && data[0]) {
                  data = data[0];
                  _this.services = data;
                }
                _context.next = 12;
                break;

              case 9:
                _context.prev = 9;
                _context.t0 = _context['catch'](0);

                console.log('services error', _context.t0);

              case 12:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[0, 9]]);
      }))();
    },
    getNote: function getNote() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var data;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                data = void 0;
                // note

                _this2.note = undefined;
                _context2.next = 5;
                return __WEBPACK_IMPORTED_MODULE_4__apis_Site__["a" /* default */].aboutNamed('services-note');

              case 5:
                data = _context2.sent;

                if (data && data[0]) {
                  data = data[0];
                  _this2.note = data;
                }
                _context2.next = 12;
                break;

              case 9:
                _context2.prev = 9;
                _context2.t0 = _context2['catch'](0);

                console.log('services error', _context2.t0);

              case 12:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2, [[0, 9]]);
      }))();
    }
  }
});

/***/ }),

/***/ 516:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_markdown__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_markdown___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_markdown__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__controllers_EventBus__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__apis_Site__ = __webpack_require__(15);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'page-contact',
  components: {
    Markdown: __WEBPACK_IMPORTED_MODULE_2_vue_markdown___default.a
  },
  data: function data() {
    return {
      isDesktop: true,
      contact: undefined,
      contact1: undefined,
      contact2: undefined,
      note: undefined
    };
  },

  computed: {},
  watch: {},
  created: function created() {},
  mounted: function mounted() {
    // on event resize
    this.isDesktop = __WEBPACK_IMPORTED_MODULE_3__controllers_EventBus__["a" /* default */]._isDesktop;
    __WEBPACK_IMPORTED_MODULE_3__controllers_EventBus__["a" /* default */].$on('isDesktopChanged', function () {
      this.isDesktop = __WEBPACK_IMPORTED_MODULE_3__controllers_EventBus__["a" /* default */]._isDesktop;
    }.bind(this));

    this.getContact();
    this.getContact1();
    this.getContact2();
    this.getNote();
  },

  methods: {
    getContact: function getContact() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var data;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                data = void 0;
                // contact

                _this.contact = undefined;
                _context.next = 5;
                return __WEBPACK_IMPORTED_MODULE_4__apis_Site__["a" /* default */].aboutNamed('contact');

              case 5:
                data = _context.sent;

                if (data && data[0]) {
                  data = data[0];
                  _this.contact = data;
                }
                _context.next = 12;
                break;

              case 9:
                _context.prev = 9;
                _context.t0 = _context['catch'](0);

                console.log('contact error', _context.t0);

              case 12:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[0, 9]]);
      }))();
    },
    getContact1: function getContact1() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var data;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                data = void 0;
                // contact 1

                _this2.contact1 = undefined;
                _context2.next = 5;
                return __WEBPACK_IMPORTED_MODULE_4__apis_Site__["a" /* default */].aboutNamed('contact-section-1');

              case 5:
                data = _context2.sent;

                if (data && data[0]) {
                  data = data[0];
                  _this2.contact1 = data;
                }
                _context2.next = 12;
                break;

              case 9:
                _context2.prev = 9;
                _context2.t0 = _context2['catch'](0);

                console.log('contact error', _context2.t0);

              case 12:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2, [[0, 9]]);
      }))();
    },
    getContact2: function getContact2() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var data;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;
                data = void 0;
                // contact 2

                _this3.contact2 = undefined;
                _context3.next = 5;
                return __WEBPACK_IMPORTED_MODULE_4__apis_Site__["a" /* default */].aboutNamed('contact-section-2');

              case 5:
                data = _context3.sent;

                if (data && data[0]) {
                  data = data[0];
                  _this3.contact2 = data;
                }
                _context3.next = 12;
                break;

              case 9:
                _context3.prev = 9;
                _context3.t0 = _context3['catch'](0);

                console.log('contact error', _context3.t0);

              case 12:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this3, [[0, 9]]);
      }))();
    },
    getNote: function getNote() {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var data;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.prev = 0;
                data = void 0;
                // note

                _this4.note = undefined;
                _context4.next = 5;
                return __WEBPACK_IMPORTED_MODULE_4__apis_Site__["a" /* default */].aboutNamed('contact-note');

              case 5:
                data = _context4.sent;

                if (data && data[0]) {
                  data = data[0];
                  _this4.note = data;
                }
                _context4.next = 12;
                break;

              case 9:
                _context4.prev = 9;
                _context4.t0 = _context4['catch'](0);

                console.log('contact error', _context4.t0);

              case 12:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this4, [[0, 9]]);
      }))();
    }
  }
});

/***/ }),

/***/ 517:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_markdown__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_markdown___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_markdown__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__controllers_EventBus__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__apis_Site__ = __webpack_require__(15);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'page-payment',
  components: {
    Markdown: __WEBPACK_IMPORTED_MODULE_2_vue_markdown___default.a
  },
  data: function data() {
    return {
      isDesktop: true,
      dataPayment: undefined
    };
  },

  computed: {},
  watch: {},
  created: function created() {},
  mounted: function mounted() {
    // on event resize
    this.isDesktop = __WEBPACK_IMPORTED_MODULE_3__controllers_EventBus__["a" /* default */]._isDesktop;
    __WEBPACK_IMPORTED_MODULE_3__controllers_EventBus__["a" /* default */].$on('isDesktopChanged', function () {
      this.isDesktop = __WEBPACK_IMPORTED_MODULE_3__controllers_EventBus__["a" /* default */]._isDesktop;
    }.bind(this));

    this.getPayment();
  },

  methods: {
    getPayment: function getPayment() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var data, replace;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                data = void 0;

                _this.dataPayment = undefined;

                replace = '';
                _context.next = 6;
                return __WEBPACK_IMPORTED_MODULE_4__apis_Site__["a" /* default */].hotlinkNameLike('reference-payment');

              case 6:
                data = _context.sent;

                if (data && data[0]) {
                  data = data[0];
                  if (data.content && data.link) {
                    replace = '<a href="' + data.link + '" target="_blank" class="button" style="margin-top:15px;margin-bottom:8px;min-width:100px;padding-left:52px;padding-right:52px;">' + data.content + '</a>';
                  }
                }

                // dataPayment
                _context.next = 10;
                return __WEBPACK_IMPORTED_MODULE_4__apis_Site__["a" /* default */].aboutNamed('payment');

              case 10:
                data = _context.sent;

                if (data && data[0]) {
                  data = data[0];
                  if (data.content) {
                    data.content = data.content.replace('{%payment%}', replace);
                  }
                  _this.dataPayment = data;
                }
                _context.next = 17;
                break;

              case 14:
                _context.prev = 14;
                _context.t0 = _context['catch'](0);

                console.log('payment error', _context.t0);

              case 17:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[0, 14]]);
      }))();
    }
  }
});

/***/ }),

/***/ 518:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_markdown__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_markdown___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_markdown__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__controllers_EventBus__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__apis_Site__ = __webpack_require__(15);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'page-reports',
  components: {
    Markdown: __WEBPACK_IMPORTED_MODULE_2_vue_markdown___default.a
  },
  data: function data() {
    return {
      isDesktop: true,
      dataReports: undefined,
      dataExisting: undefined,
      dataRegister: undefined,
      dataRegisterHow: undefined,
      dataSurvey: undefined
    };
  },

  computed: {},
  watch: {},
  created: function created() {},
  mounted: function mounted() {
    // on event resize
    this.isDesktop = __WEBPACK_IMPORTED_MODULE_3__controllers_EventBus__["a" /* default */]._isDesktop;
    __WEBPACK_IMPORTED_MODULE_3__controllers_EventBus__["a" /* default */].$on('isDesktopChanged', function () {
      this.isDesktop = __WEBPACK_IMPORTED_MODULE_3__controllers_EventBus__["a" /* default */]._isDesktop;
    }.bind(this));

    this.getDataReports();
    this.getDataExisting();
    this.getDataRegister();
    this.getDataRegisterHow();
    this.getDataSurvey();
  },

  methods: {
    getDataReports: function getDataReports() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var data;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                data = void 0;
                // dataReports

                _this.dataReports = undefined;
                _context.next = 5;
                return __WEBPACK_IMPORTED_MODULE_4__apis_Site__["a" /* default */].aboutNamed('reports');

              case 5:
                data = _context.sent;

                if (data && data[0]) {
                  data = data[0];
                  _this.dataReports = data;
                }
                _context.next = 12;
                break;

              case 9:
                _context.prev = 9;
                _context.t0 = _context['catch'](0);

                console.log('faq error', _context.t0);

              case 12:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[0, 9]]);
      }))();
    },
    getDataExisting: function getDataExisting() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var data;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                data = void 0;
                // dataExisting

                _this2.dataExisting = undefined;
                _context2.next = 5;
                return __WEBPACK_IMPORTED_MODULE_4__apis_Site__["a" /* default */].hotlinkNameLike('reference-reports-existing');

              case 5:
                data = _context2.sent;

                if (data && data[0]) {
                  data = data[0];
                  _this2.dataExisting = data;
                }
                _context2.next = 12;
                break;

              case 9:
                _context2.prev = 9;
                _context2.t0 = _context2['catch'](0);

                console.log('info error', _context2.t0);

              case 12:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2, [[0, 9]]);
      }))();
    },
    getDataRegister: function getDataRegister() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var data;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;
                data = void 0;
                // dataRegister

                _this3.dataRegister = undefined;
                _context3.next = 5;
                return __WEBPACK_IMPORTED_MODULE_4__apis_Site__["a" /* default */].hotlinkNameLike('reference-reports-register');

              case 5:
                data = _context3.sent;

                if (data && data[0]) {
                  data = data[0];
                  _this3.dataRegister = data;
                }
                _context3.next = 12;
                break;

              case 9:
                _context3.prev = 9;
                _context3.t0 = _context3['catch'](0);

                console.log('info error', _context3.t0);

              case 12:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this3, [[0, 9]]);
      }))();
    },
    getDataRegisterHow: function getDataRegisterHow() {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var data;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.prev = 0;
                data = void 0;
                // dataRegisterHow

                _this4.dataRegisterHow = undefined;
                _context4.next = 5;
                return __WEBPACK_IMPORTED_MODULE_4__apis_Site__["a" /* default */].hotlinkNameLike('reference-reports-register-how');

              case 5:
                data = _context4.sent;

                if (data && data[0]) {
                  data = data[0];
                  _this4.dataRegisterHow = data;
                }
                _context4.next = 12;
                break;

              case 9:
                _context4.prev = 9;
                _context4.t0 = _context4['catch'](0);

                console.log('info error', _context4.t0);

              case 12:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this4, [[0, 9]]);
      }))();
    },
    getDataSurvey: function getDataSurvey() {
      var _this5 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5() {
        var data;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.prev = 0;
                data = void 0;
                // dataSurvey

                _this5.dataSurvey = undefined;
                _context5.next = 5;
                return __WEBPACK_IMPORTED_MODULE_4__apis_Site__["a" /* default */].hotlinkNameLike('reference-reports-survey');

              case 5:
                data = _context5.sent;

                if (data && data[0]) {
                  data = data[0];
                  _this5.dataSurvey = data;
                }
                _context5.next = 12;
                break;

              case 9:
                _context5.prev = 9;
                _context5.t0 = _context5['catch'](0);

                console.log('info error', _context5.t0);

              case 12:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, _this5, [[0, 9]]);
      }))();
    }
  }
});

/***/ }),

/***/ 519:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray__ = __webpack_require__(526);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__controllers_EventBus__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_DivContainer__ = __webpack_require__(184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_DivContainer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_DivContainer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_DivColumns__ = __webpack_require__(938);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_DivColumns___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_DivColumns__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_PageSubheader__ = __webpack_require__(946);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_PageSubheader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_PageSubheader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_FormDynamix__ = __webpack_require__(940);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_FormDynamix___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_FormDynamix__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_FormInput__ = __webpack_require__(188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_FormInput___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_FormInput__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vuelidate__ = __webpack_require__(185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vuelidate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_vuelidate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vuelidate_lib_validators__ = __webpack_require__(186);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_vuelidate_lib_validators__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__apis_Site__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__utils_auth__ = __webpack_require__(488);




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import _ from 'lodash'







// import { required, numeric, email, between, minLength, maxLength } from 'vuelidate/lib/validators'



// import imageMap from '@/assets/map.png'


// function validateArrayRequired (values) {
//   if (values && values.length > 0) {
//     var isChecked = false
//     for (var i = 0; i < values.length; i++) {
//       var value = values[i]
//       isChecked |= value
//     }
//     return isChecked
//   }
//   return false
// }

// function validateEitherOr (value1, value2) {
//   // console.log('-- validate either or --')
//   // console.log(value1)
//   // console.log(value2)
//   if (value1 && !value2) {
//     return true
//   } else if (!value1 && value2) {
//     return true
//   }
//   return false
// }

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'section-sign-up-team',
  mixins: [__WEBPACK_IMPORTED_MODULE_10_vuelidate__["validationMixin"]],
  components: {
    DivContainer: __WEBPACK_IMPORTED_MODULE_5__components_DivContainer___default.a,
    DivColumns: __WEBPACK_IMPORTED_MODULE_6__components_DivColumns___default.a,
    PageSubheader: __WEBPACK_IMPORTED_MODULE_7__components_PageSubheader___default.a,
    FormDynamix: __WEBPACK_IMPORTED_MODULE_8__components_FormDynamix___default.a,
    FormInput: __WEBPACK_IMPORTED_MODULE_9__components_FormInput___default.a
  },
  props: ['is-print'],
  watch: {
    'isPrint': {
      handler: function handler(value, _oldValue) {
        var isPrint = value;
        if (isPrint) {
          this.models.signAt = '';
        } else {
          this.models.signAt = __WEBPACK_IMPORTED_MODULE_13_moment___default()(new Date()).format();
        }
      }
    },
    'models.competition': {
      handler: function handler(value, oldValue) {
        var disabled = value !== 1;
        this.attributes.volunteer.disabled = disabled;
        if (disabled) {
          this.models.volunteer = undefined;
        }
        // if (value[2] !== oldValue[2]) {
        // var changed = value.filter(function (p, idx) {
        //   return Object.keys(p).some(function (prop) {
        //     return p[prop] !== oldValue[idx][prop]
        //   })
        // })
        // console.log('changed-value...')
        // console.log(changed)

        if (value !== oldValue && value === 1) {
          this.models.competition2 = false;
        }
      },
      deep: true
    },
    'models.competition2': {
      handler: function handler(value, oldValue) {
        if (value !== oldValue && value === 2) {
          this.models.competition = false;
        }
      }
    },
    'models.members': {
      handler: function handler(value, oldValue) {
        console.log('member change: ' + value);
      }
    }
  },
  computed: {
    // isDesktop: function () {
    //   return EventBus.isDesktop
    // }
  },
  data: function data() {
    return {
      isDesktop: true,
      isIE: __WEBPACK_IMPORTED_MODULE_4__controllers_EventBus__["a" /* default */].detectIE(),
      isPrintPdf: '/static/team-application.pdf',
      isSurveyError: '...',
      isSurveyState: undefined,
      surveyCode: '',
      surveyCodeConfirm: undefined,
      surveyError: [],
      // captcha: '',
      // captchaImage: undefined,
      // session: '',
      feedback: false,
      submitted: false,
      loading: false,
      items: [],
      names: [
      // form
      'term', 'officer', 'isExplained', 'labelCheck', // label
      'isRespectful', 'isAnswered', 'isTreated', 'labelNote', // label
      'note', 'name'],
      models: {
        // form
        recaptcha: undefined,
        term: '',
        officer: '',
        isExplained: undefined,
        isRespectful: undefined,
        isAnswered: undefined,
        isTreated: undefined,
        note: '',
        name: ''
      },
      attributes: {
        // form
        term: {
          title: 'How long was your probation term?',
          column: 'is-12'
        },
        officer: {
          title: '1. Who was your probation officer at the time the case was closed?',
          column: 'is-12'
        },
        isExplained: {
          type: 'radio',
          title: '2. During your first appointment, were your supervision requirements explained to you so you could understand them.',
          column: 'is-12',
          options: [{
            value: 'yes',
            title: 'YES'
          }, {
            value: 'no',
            title: 'NO'
          }],
          onChecked: function onChecked(value) {
            console.log(value);
          }
        },
        labelCheck: {
          type: 'label',
          title: 'Please answer these questions about your assigned probation officer at the time the case was closed.',
          style: {
            fontStyle: 'italic'
          }
        },
        isRespectful: {
          type: 'radio',
          title: '3. Was your probation officer respectful and courteous to you?',
          column: 'is-12',
          options: [{
            value: 'always',
            title: 'Always'
          }, {
            value: 'usually',
            title: 'Usually'
          }, {
            value: 'sometimes',
            title: 'Sometimes'
          }, {
            value: 'rarely',
            title: 'Rarely'
          }, {
            value: 'never',
            title: 'Never'
          }]
        },
        isAnswered: {
          type: 'radio',
          title: '4. Were questions about your case conditions answered during office visits?',
          column: 'is-12',
          options: [{
            value: 'always',
            title: 'Always'
          }, {
            value: 'usually',
            title: 'Usually'
          }, {
            value: 'sometimes',
            title: 'Sometimes'
          }, {
            value: 'rarely',
            title: 'Rarely'
          }, {
            value: 'never',
            title: 'Never'
          }]
        },
        isTreated: {
          type: 'radio',
          title: '5. Did you feel you were treated as an individual and not just "a number".',
          column: 'is-12',
          options: [{
            value: 'yes',
            title: 'YES'
          }, {
            value: 'no',
            title: 'NO'
          }]
        },
        labelNote: {
          type: 'label',
          title: 'If we have earned a good review, would you please take a moment to leave a 5 star review on Google @ Client Management Probation.  If we did not meet expectations, please use the space below to make any further comments about your experience that could help us improve.',
          style: {
            fontWeight: 'bold'
          }
        },
        note: {
          type: 'textarea',
          title: '',
          curLength: 0,
          maxLength: 500
        },
        name: {
          title: 'Name (optional)',
          column: 'is-12'
          // signature: {
          //   title: 'Team Leader\'s Name',
          //   column: 'is-6'
          //   // note: '* By typing your name, you agree to the above.<br />' +
          //   // `* By typing your name and submitting this Team A pplication, you agree to the above and agree to follow all of the COVID-19 restrictions & regulations stated in the “Emergency Addendum to KCBS Sanctioning Agreement” attached above.`
          // },
          // signAt: {
          //   title: 'Date',
          //   column: 'is-6',
          //   disabled: true
          // },
          // signNote: {
          //   null: true,
          //   title: 'Note',
          //   column: 'is-12',
          //   note: '* By typing your name, you agree to the above.<br />' +
          //   `* By typing your name and submitting this Team Application, you agree to the above and agree to follow all of the COVID-19 restrictions & regulations enforced locally as well as any KCBS guidelines/addendums that may arise.`
          // }
        } },
      navEmail: __WEBPACK_IMPORTED_MODULE_4__controllers_EventBus__["a" /* default */]._data._navEmail
    };
  },
  validations: {
    models: {
      // form
      recaptcha: { required: __WEBPACK_IMPORTED_MODULE_11_vuelidate_lib_validators__["required"] },
      term: { required: __WEBPACK_IMPORTED_MODULE_11_vuelidate_lib_validators__["required"] },
      officer: { required: __WEBPACK_IMPORTED_MODULE_11_vuelidate_lib_validators__["required"] },
      isExplained: { required: __WEBPACK_IMPORTED_MODULE_11_vuelidate_lib_validators__["required"] },
      labelCheck: {}, // label
      isRespectful: { required: __WEBPACK_IMPORTED_MODULE_11_vuelidate_lib_validators__["required"] },
      isAnswered: { required: __WEBPACK_IMPORTED_MODULE_11_vuelidate_lib_validators__["required"] },
      isTreated: { required: __WEBPACK_IMPORTED_MODULE_11_vuelidate_lib_validators__["required"] },
      labelNote: {}, // label
      note: { required: __WEBPACK_IMPORTED_MODULE_11_vuelidate_lib_validators__["required"] },
      name: {}
    }
  },
  created: function created() {
    // console.log('-- creating... --')
    // console.log(this.$v)
    // console.log(this.models)
    this.init();
  },
  mounted: function mounted() {
    // console.log('-- mounted... --')
    // on event resize
    this.isDesktop = __WEBPACK_IMPORTED_MODULE_4__controllers_EventBus__["a" /* default */]._isDesktop;
    __WEBPACK_IMPORTED_MODULE_4__controllers_EventBus__["a" /* default */].$on('isDesktopChanged', function () {
      this.isDesktop = __WEBPACK_IMPORTED_MODULE_4__controllers_EventBus__["a" /* default */]._isDesktop;
    }.bind(this));

    // this.onRecaptcha(data => {
    //   // console.log('recaptcha data!')
    //   this.captchaImage = data.data
    //   this.session = data.id
    // })

    if (this.isPrint) {
      this.models.signAt = '';
    } else {
      this.models.signAt = __WEBPACK_IMPORTED_MODULE_13_moment___default()(new Date()).format();
    }

    // console.log('-- mounting... --')
    // console.log(this.$v)
    this.onLoad();
  },
  methods: {
    init: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var promises, _ref2, _ref3, code, status;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;

                this.loading = true;
                promises = [];

                promises.push(this.getSurveyCode());
                promises.push(this.getSurveyStatus());
                _context.next = 7;
                return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.all(promises);

              case 7:
                _ref2 = _context.sent;
                _ref3 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default()(_ref2, 2);
                code = _ref3[0];
                status = _ref3[1];

                if (!(code != null && code.length <= 0)) {
                  _context.next = 15;
                  break;
                }

                this.isSurveyError = 'Invalid survey code';
                this.loading = false;
                return _context.abrupt('return');

              case 15:
                this.surveyCodeConfirm = code;

                if (!(status === 'submitted')) {
                  _context.next = 20;
                  break;
                }

                this.isSurveyError = 'You have already completed the exit survey previously. Thank you for your response.';
                this.loading = false;
                return _context.abrupt('return');

              case 20:
                if (!(status !== 'ready')) {
                  _context.next = 24;
                  break;
                }

                this.isSurveyError = 'Invalid survey';
                this.loading = false;
                return _context.abrupt('return');

              case 24:
                this.isSurveyState = 'code';
                this.loading = false;
                _context.next = 32;
                break;

              case 28:
                _context.prev = 28;
                _context.t0 = _context['catch'](0);

                console.log(_context.t0);
                this.loading = false;

              case 32:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this, [[0, 28]]);
      }));

      function init() {
        return _ref.apply(this, arguments);
      }

      return init;
    }(),

    onLoad: function onLoad() {},

    getSurveyCode: function () {
      var _ref4 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var response, metaString, meta, code;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return __WEBPACK_IMPORTED_MODULE_12__apis_Site__["a" /* default */].infoNamed('survey-code');

              case 2:
                response = _context2.sent;
                metaString = response && response[0] && response[0].meta;
                meta = JSON.parse(metaString);
                code = meta && meta.code;
                return _context2.abrupt('return', code);

              case 7:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function getSurveyCode() {
        return _ref4.apply(this, arguments);
      }

      return getSurveyCode;
    }(),

    getSurveyStatus: function () {
      var _ref5 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return __WEBPACK_IMPORTED_MODULE_14__utils_auth__["a" /* default */].getSurveyStatus();

              case 2:
                _context3.t0 = _context3.sent;

                if (_context3.t0) {
                  _context3.next = 5;
                  break;
                }

                _context3.t0 = 'ready';

              case 5:
                return _context3.abrupt('return', _context3.t0);

              case 6:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function getSurveyStatus() {
        return _ref5.apply(this, arguments);
      }

      return getSurveyStatus;
    }(),

    onRecaptcha: function onRecaptcha(info) {
      if (info && info.status) {
        this.models.recaptcha = info.status === 'ok' ? info.response : undefined;
        if (info.status !== 'ok') {
          console.log('FormDynamix:recaptcha():' + info.status);
        }
      }
    },

    onClear: function onClear() {
      // this.models.recaptcha = undefined
      // form
      this.models.term = '';
      this.models.officer = '';
      this.models.isExplained = undefined;
      this.models.isRespectful = undefined;
      this.models.isAnswered = undefined;
      this.models.isTreated = undefined;
      this.models.note = '';
      this.models.name = '';
    },

    onSurveyInput: function onSurveyInput(info) {
      this.surveyCode = info && info.value;
    },

    onSurveyCode: function onSurveyCode(surveyCode) {
      this.surveyError.splice(0, this.surveyError.length);
      if (surveyCode == null || surveyCode.length <= 0) {
        this.surveyError.splice(0, this.surveyError.length, 'required');
        return;
      }
      if (surveyCode !== this.surveyCodeConfirm) {
        this.surveyError.splice(0, this.surveyError.length, 'invalid');
        return;
      }
      this.isSurveyState = 'survey';
      // this.surveyCode = surveyCode
    },

    onSendDisabled: function onSendDisabled() {
      var _self = this;
      _self.feedback = 'We are sorry, team application is not open yet.';
      return;
    },

    onSend: function onSend(formInfo) {
      var _this = this;

      // $v.models.$touch()
      var _self = this;
      console.log('SignUpTeamSection:onSend(): $v / models');
      console.log(formInfo);

      // var models = formInfo.models
      if (formInfo.vuelidate.$invalid) {
        _self.feedback = 'Form contains errors, please recheck.';
        // _self.$toast.open({
        //   duration: 5000,
        //   message: 'Please fill in all fields to proceed.',
        //   position: 'is-bottom',
        //   type: 'is-warning'
        // })
        return;
      }

      // if (this.$route.params.code == null || this.$route.params.code.length <= 0) {
      //   _self.feedback = 'Invalid survey code, please check again.'
      //   return
      // }
      // let code = this.$route.params.code

      if (!this.models.recaptcha) {
        _self.feedback = 'Invalid recaptcha, please validate again.';
        return;
      }
      _self.feedback = false;

      var models = formInfo.models;

      console.log('-- send form --');
      console.log(models);
      // console.log(models.name)
      // console.log(models.leader)
      // console.log(models.members)
      // console.log(competition)
      // console.log(models.freeStrawberry)
      // console.log(models.freeKingOfWing)
      // console.log(models.signature)
      // console.log(models.signAt)
      // console.log(models.amount)

      // if (formInfo) {
      //   return
      // }

      _self.loading = true;
      __WEBPACK_IMPORTED_MODULE_12__apis_Site__["a" /* default */].surveySubmit(models).then(function (data) {
        _self.loading = false;

        // invalid captcha
        if (data && data.status === 'invalid_session') {
          _self.feedback = 'Invalid session, please kindly refresh and try again.';
          return;
        }

        // invalid captcha
        if (data && data.status === 'invalid_captcha') {
          _self.feedback = 'Invalid captcha, please re-type again.';
          return;
        }

        if (data && data.status !== 'ok') {
          _self.feedback = 'Oops. Something went wrong. Please email us directly at ' + _self.navEmail;
          return;
        }

        _this.$v.models.$reset();
        _this.onClear();

        // _self.captcha = ''
        // _self.session = '' // open up to maintain session

        // _self.$toast.open({
        //   message: 'We will be contacting you via email or phone. Thanks!',
        //   position: 'is-bottom',
        //   type: 'is-success'
        // })
        _self.submitted = true;
        _self.feedback = 'Your application has been successfully submitted.';
        __WEBPACK_IMPORTED_MODULE_14__utils_auth__["a" /* default */].setSurveyStatus('submitted');
      }).catch(function (error) {
        console.log('invalid email', error);
        // this.error = error.error
        console.log(error);
        // _self.captcha = ''

        // invalid captcha
        if (error && error.status === 'invalid_session') {
          _self.feedback = 'Invalid session, please kindly refresh and try again.';
          _self.loading = false;
          return;
        }

        // invalid captcha
        if (error && error.status === 'invalid_captcha') {
          _self.feedback = 'Invalid captcha, please retype again.';
          _self.loading = false;
          return;
        }

        // _self.$toast.open({
        //   duration: 5000,
        //   message: 'Oops. Something went wrong. Please email us directly at ' + _self.navEmail,
        //   position: 'is-bottom',
        //   type: 'is-warning'
        // })
        _self.feedback = 'Oops. Something went wrong. Please email us directly at ' + _self.navEmail;
        _self.loading = false;
        return _self.init();
      }).then(function (data) {
        _this.isSurveyState = undefined;
        _this.isSurveyError = 'Survey has been submitted successfully. Thank you for your response.';
        console.log('submit/success');
      });
    }
  }
});

/***/ }),

/***/ 795:
/***/ (function(module, exports) {

module.exports = {"Aacute":"Á","aacute":"á","Abreve":"Ă","abreve":"ă","ac":"∾","acd":"∿","acE":"∾̳","Acirc":"Â","acirc":"â","acute":"´","Acy":"А","acy":"а","AElig":"Æ","aelig":"æ","af":"⁡","Afr":"𝔄","afr":"𝔞","Agrave":"À","agrave":"à","alefsym":"ℵ","aleph":"ℵ","Alpha":"Α","alpha":"α","Amacr":"Ā","amacr":"ā","amalg":"⨿","amp":"&","AMP":"&","andand":"⩕","And":"⩓","and":"∧","andd":"⩜","andslope":"⩘","andv":"⩚","ang":"∠","ange":"⦤","angle":"∠","angmsdaa":"⦨","angmsdab":"⦩","angmsdac":"⦪","angmsdad":"⦫","angmsdae":"⦬","angmsdaf":"⦭","angmsdag":"⦮","angmsdah":"⦯","angmsd":"∡","angrt":"∟","angrtvb":"⊾","angrtvbd":"⦝","angsph":"∢","angst":"Å","angzarr":"⍼","Aogon":"Ą","aogon":"ą","Aopf":"𝔸","aopf":"𝕒","apacir":"⩯","ap":"≈","apE":"⩰","ape":"≊","apid":"≋","apos":"'","ApplyFunction":"⁡","approx":"≈","approxeq":"≊","Aring":"Å","aring":"å","Ascr":"𝒜","ascr":"𝒶","Assign":"≔","ast":"*","asymp":"≈","asympeq":"≍","Atilde":"Ã","atilde":"ã","Auml":"Ä","auml":"ä","awconint":"∳","awint":"⨑","backcong":"≌","backepsilon":"϶","backprime":"‵","backsim":"∽","backsimeq":"⋍","Backslash":"∖","Barv":"⫧","barvee":"⊽","barwed":"⌅","Barwed":"⌆","barwedge":"⌅","bbrk":"⎵","bbrktbrk":"⎶","bcong":"≌","Bcy":"Б","bcy":"б","bdquo":"„","becaus":"∵","because":"∵","Because":"∵","bemptyv":"⦰","bepsi":"϶","bernou":"ℬ","Bernoullis":"ℬ","Beta":"Β","beta":"β","beth":"ℶ","between":"≬","Bfr":"𝔅","bfr":"𝔟","bigcap":"⋂","bigcirc":"◯","bigcup":"⋃","bigodot":"⨀","bigoplus":"⨁","bigotimes":"⨂","bigsqcup":"⨆","bigstar":"★","bigtriangledown":"▽","bigtriangleup":"△","biguplus":"⨄","bigvee":"⋁","bigwedge":"⋀","bkarow":"⤍","blacklozenge":"⧫","blacksquare":"▪","blacktriangle":"▴","blacktriangledown":"▾","blacktriangleleft":"◂","blacktriangleright":"▸","blank":"␣","blk12":"▒","blk14":"░","blk34":"▓","block":"█","bne":"=⃥","bnequiv":"≡⃥","bNot":"⫭","bnot":"⌐","Bopf":"𝔹","bopf":"𝕓","bot":"⊥","bottom":"⊥","bowtie":"⋈","boxbox":"⧉","boxdl":"┐","boxdL":"╕","boxDl":"╖","boxDL":"╗","boxdr":"┌","boxdR":"╒","boxDr":"╓","boxDR":"╔","boxh":"─","boxH":"═","boxhd":"┬","boxHd":"╤","boxhD":"╥","boxHD":"╦","boxhu":"┴","boxHu":"╧","boxhU":"╨","boxHU":"╩","boxminus":"⊟","boxplus":"⊞","boxtimes":"⊠","boxul":"┘","boxuL":"╛","boxUl":"╜","boxUL":"╝","boxur":"└","boxuR":"╘","boxUr":"╙","boxUR":"╚","boxv":"│","boxV":"║","boxvh":"┼","boxvH":"╪","boxVh":"╫","boxVH":"╬","boxvl":"┤","boxvL":"╡","boxVl":"╢","boxVL":"╣","boxvr":"├","boxvR":"╞","boxVr":"╟","boxVR":"╠","bprime":"‵","breve":"˘","Breve":"˘","brvbar":"¦","bscr":"𝒷","Bscr":"ℬ","bsemi":"⁏","bsim":"∽","bsime":"⋍","bsolb":"⧅","bsol":"\\","bsolhsub":"⟈","bull":"•","bullet":"•","bump":"≎","bumpE":"⪮","bumpe":"≏","Bumpeq":"≎","bumpeq":"≏","Cacute":"Ć","cacute":"ć","capand":"⩄","capbrcup":"⩉","capcap":"⩋","cap":"∩","Cap":"⋒","capcup":"⩇","capdot":"⩀","CapitalDifferentialD":"ⅅ","caps":"∩︀","caret":"⁁","caron":"ˇ","Cayleys":"ℭ","ccaps":"⩍","Ccaron":"Č","ccaron":"č","Ccedil":"Ç","ccedil":"ç","Ccirc":"Ĉ","ccirc":"ĉ","Cconint":"∰","ccups":"⩌","ccupssm":"⩐","Cdot":"Ċ","cdot":"ċ","cedil":"¸","Cedilla":"¸","cemptyv":"⦲","cent":"¢","centerdot":"·","CenterDot":"·","cfr":"𝔠","Cfr":"ℭ","CHcy":"Ч","chcy":"ч","check":"✓","checkmark":"✓","Chi":"Χ","chi":"χ","circ":"ˆ","circeq":"≗","circlearrowleft":"↺","circlearrowright":"↻","circledast":"⊛","circledcirc":"⊚","circleddash":"⊝","CircleDot":"⊙","circledR":"®","circledS":"Ⓢ","CircleMinus":"⊖","CirclePlus":"⊕","CircleTimes":"⊗","cir":"○","cirE":"⧃","cire":"≗","cirfnint":"⨐","cirmid":"⫯","cirscir":"⧂","ClockwiseContourIntegral":"∲","CloseCurlyDoubleQuote":"”","CloseCurlyQuote":"’","clubs":"♣","clubsuit":"♣","colon":":","Colon":"∷","Colone":"⩴","colone":"≔","coloneq":"≔","comma":",","commat":"@","comp":"∁","compfn":"∘","complement":"∁","complexes":"ℂ","cong":"≅","congdot":"⩭","Congruent":"≡","conint":"∮","Conint":"∯","ContourIntegral":"∮","copf":"𝕔","Copf":"ℂ","coprod":"∐","Coproduct":"∐","copy":"©","COPY":"©","copysr":"℗","CounterClockwiseContourIntegral":"∳","crarr":"↵","cross":"✗","Cross":"⨯","Cscr":"𝒞","cscr":"𝒸","csub":"⫏","csube":"⫑","csup":"⫐","csupe":"⫒","ctdot":"⋯","cudarrl":"⤸","cudarrr":"⤵","cuepr":"⋞","cuesc":"⋟","cularr":"↶","cularrp":"⤽","cupbrcap":"⩈","cupcap":"⩆","CupCap":"≍","cup":"∪","Cup":"⋓","cupcup":"⩊","cupdot":"⊍","cupor":"⩅","cups":"∪︀","curarr":"↷","curarrm":"⤼","curlyeqprec":"⋞","curlyeqsucc":"⋟","curlyvee":"⋎","curlywedge":"⋏","curren":"¤","curvearrowleft":"↶","curvearrowright":"↷","cuvee":"⋎","cuwed":"⋏","cwconint":"∲","cwint":"∱","cylcty":"⌭","dagger":"†","Dagger":"‡","daleth":"ℸ","darr":"↓","Darr":"↡","dArr":"⇓","dash":"‐","Dashv":"⫤","dashv":"⊣","dbkarow":"⤏","dblac":"˝","Dcaron":"Ď","dcaron":"ď","Dcy":"Д","dcy":"д","ddagger":"‡","ddarr":"⇊","DD":"ⅅ","dd":"ⅆ","DDotrahd":"⤑","ddotseq":"⩷","deg":"°","Del":"∇","Delta":"Δ","delta":"δ","demptyv":"⦱","dfisht":"⥿","Dfr":"𝔇","dfr":"𝔡","dHar":"⥥","dharl":"⇃","dharr":"⇂","DiacriticalAcute":"´","DiacriticalDot":"˙","DiacriticalDoubleAcute":"˝","DiacriticalGrave":"`","DiacriticalTilde":"˜","diam":"⋄","diamond":"⋄","Diamond":"⋄","diamondsuit":"♦","diams":"♦","die":"¨","DifferentialD":"ⅆ","digamma":"ϝ","disin":"⋲","div":"÷","divide":"÷","divideontimes":"⋇","divonx":"⋇","DJcy":"Ђ","djcy":"ђ","dlcorn":"⌞","dlcrop":"⌍","dollar":"$","Dopf":"𝔻","dopf":"𝕕","Dot":"¨","dot":"˙","DotDot":"⃜","doteq":"≐","doteqdot":"≑","DotEqual":"≐","dotminus":"∸","dotplus":"∔","dotsquare":"⊡","doublebarwedge":"⌆","DoubleContourIntegral":"∯","DoubleDot":"¨","DoubleDownArrow":"⇓","DoubleLeftArrow":"⇐","DoubleLeftRightArrow":"⇔","DoubleLeftTee":"⫤","DoubleLongLeftArrow":"⟸","DoubleLongLeftRightArrow":"⟺","DoubleLongRightArrow":"⟹","DoubleRightArrow":"⇒","DoubleRightTee":"⊨","DoubleUpArrow":"⇑","DoubleUpDownArrow":"⇕","DoubleVerticalBar":"∥","DownArrowBar":"⤓","downarrow":"↓","DownArrow":"↓","Downarrow":"⇓","DownArrowUpArrow":"⇵","DownBreve":"̑","downdownarrows":"⇊","downharpoonleft":"⇃","downharpoonright":"⇂","DownLeftRightVector":"⥐","DownLeftTeeVector":"⥞","DownLeftVectorBar":"⥖","DownLeftVector":"↽","DownRightTeeVector":"⥟","DownRightVectorBar":"⥗","DownRightVector":"⇁","DownTeeArrow":"↧","DownTee":"⊤","drbkarow":"⤐","drcorn":"⌟","drcrop":"⌌","Dscr":"𝒟","dscr":"𝒹","DScy":"Ѕ","dscy":"ѕ","dsol":"⧶","Dstrok":"Đ","dstrok":"đ","dtdot":"⋱","dtri":"▿","dtrif":"▾","duarr":"⇵","duhar":"⥯","dwangle":"⦦","DZcy":"Џ","dzcy":"џ","dzigrarr":"⟿","Eacute":"É","eacute":"é","easter":"⩮","Ecaron":"Ě","ecaron":"ě","Ecirc":"Ê","ecirc":"ê","ecir":"≖","ecolon":"≕","Ecy":"Э","ecy":"э","eDDot":"⩷","Edot":"Ė","edot":"ė","eDot":"≑","ee":"ⅇ","efDot":"≒","Efr":"𝔈","efr":"𝔢","eg":"⪚","Egrave":"È","egrave":"è","egs":"⪖","egsdot":"⪘","el":"⪙","Element":"∈","elinters":"⏧","ell":"ℓ","els":"⪕","elsdot":"⪗","Emacr":"Ē","emacr":"ē","empty":"∅","emptyset":"∅","EmptySmallSquare":"◻","emptyv":"∅","EmptyVerySmallSquare":"▫","emsp13":" ","emsp14":" ","emsp":" ","ENG":"Ŋ","eng":"ŋ","ensp":" ","Eogon":"Ę","eogon":"ę","Eopf":"𝔼","eopf":"𝕖","epar":"⋕","eparsl":"⧣","eplus":"⩱","epsi":"ε","Epsilon":"Ε","epsilon":"ε","epsiv":"ϵ","eqcirc":"≖","eqcolon":"≕","eqsim":"≂","eqslantgtr":"⪖","eqslantless":"⪕","Equal":"⩵","equals":"=","EqualTilde":"≂","equest":"≟","Equilibrium":"⇌","equiv":"≡","equivDD":"⩸","eqvparsl":"⧥","erarr":"⥱","erDot":"≓","escr":"ℯ","Escr":"ℰ","esdot":"≐","Esim":"⩳","esim":"≂","Eta":"Η","eta":"η","ETH":"Ð","eth":"ð","Euml":"Ë","euml":"ë","euro":"€","excl":"!","exist":"∃","Exists":"∃","expectation":"ℰ","exponentiale":"ⅇ","ExponentialE":"ⅇ","fallingdotseq":"≒","Fcy":"Ф","fcy":"ф","female":"♀","ffilig":"ﬃ","fflig":"ﬀ","ffllig":"ﬄ","Ffr":"𝔉","ffr":"𝔣","filig":"ﬁ","FilledSmallSquare":"◼","FilledVerySmallSquare":"▪","fjlig":"fj","flat":"♭","fllig":"ﬂ","fltns":"▱","fnof":"ƒ","Fopf":"𝔽","fopf":"𝕗","forall":"∀","ForAll":"∀","fork":"⋔","forkv":"⫙","Fouriertrf":"ℱ","fpartint":"⨍","frac12":"½","frac13":"⅓","frac14":"¼","frac15":"⅕","frac16":"⅙","frac18":"⅛","frac23":"⅔","frac25":"⅖","frac34":"¾","frac35":"⅗","frac38":"⅜","frac45":"⅘","frac56":"⅚","frac58":"⅝","frac78":"⅞","frasl":"⁄","frown":"⌢","fscr":"𝒻","Fscr":"ℱ","gacute":"ǵ","Gamma":"Γ","gamma":"γ","Gammad":"Ϝ","gammad":"ϝ","gap":"⪆","Gbreve":"Ğ","gbreve":"ğ","Gcedil":"Ģ","Gcirc":"Ĝ","gcirc":"ĝ","Gcy":"Г","gcy":"г","Gdot":"Ġ","gdot":"ġ","ge":"≥","gE":"≧","gEl":"⪌","gel":"⋛","geq":"≥","geqq":"≧","geqslant":"⩾","gescc":"⪩","ges":"⩾","gesdot":"⪀","gesdoto":"⪂","gesdotol":"⪄","gesl":"⋛︀","gesles":"⪔","Gfr":"𝔊","gfr":"𝔤","gg":"≫","Gg":"⋙","ggg":"⋙","gimel":"ℷ","GJcy":"Ѓ","gjcy":"ѓ","gla":"⪥","gl":"≷","glE":"⪒","glj":"⪤","gnap":"⪊","gnapprox":"⪊","gne":"⪈","gnE":"≩","gneq":"⪈","gneqq":"≩","gnsim":"⋧","Gopf":"𝔾","gopf":"𝕘","grave":"`","GreaterEqual":"≥","GreaterEqualLess":"⋛","GreaterFullEqual":"≧","GreaterGreater":"⪢","GreaterLess":"≷","GreaterSlantEqual":"⩾","GreaterTilde":"≳","Gscr":"𝒢","gscr":"ℊ","gsim":"≳","gsime":"⪎","gsiml":"⪐","gtcc":"⪧","gtcir":"⩺","gt":">","GT":">","Gt":"≫","gtdot":"⋗","gtlPar":"⦕","gtquest":"⩼","gtrapprox":"⪆","gtrarr":"⥸","gtrdot":"⋗","gtreqless":"⋛","gtreqqless":"⪌","gtrless":"≷","gtrsim":"≳","gvertneqq":"≩︀","gvnE":"≩︀","Hacek":"ˇ","hairsp":" ","half":"½","hamilt":"ℋ","HARDcy":"Ъ","hardcy":"ъ","harrcir":"⥈","harr":"↔","hArr":"⇔","harrw":"↭","Hat":"^","hbar":"ℏ","Hcirc":"Ĥ","hcirc":"ĥ","hearts":"♥","heartsuit":"♥","hellip":"…","hercon":"⊹","hfr":"𝔥","Hfr":"ℌ","HilbertSpace":"ℋ","hksearow":"⤥","hkswarow":"⤦","hoarr":"⇿","homtht":"∻","hookleftarrow":"↩","hookrightarrow":"↪","hopf":"𝕙","Hopf":"ℍ","horbar":"―","HorizontalLine":"─","hscr":"𝒽","Hscr":"ℋ","hslash":"ℏ","Hstrok":"Ħ","hstrok":"ħ","HumpDownHump":"≎","HumpEqual":"≏","hybull":"⁃","hyphen":"‐","Iacute":"Í","iacute":"í","ic":"⁣","Icirc":"Î","icirc":"î","Icy":"И","icy":"и","Idot":"İ","IEcy":"Е","iecy":"е","iexcl":"¡","iff":"⇔","ifr":"𝔦","Ifr":"ℑ","Igrave":"Ì","igrave":"ì","ii":"ⅈ","iiiint":"⨌","iiint":"∭","iinfin":"⧜","iiota":"℩","IJlig":"Ĳ","ijlig":"ĳ","Imacr":"Ī","imacr":"ī","image":"ℑ","ImaginaryI":"ⅈ","imagline":"ℐ","imagpart":"ℑ","imath":"ı","Im":"ℑ","imof":"⊷","imped":"Ƶ","Implies":"⇒","incare":"℅","in":"∈","infin":"∞","infintie":"⧝","inodot":"ı","intcal":"⊺","int":"∫","Int":"∬","integers":"ℤ","Integral":"∫","intercal":"⊺","Intersection":"⋂","intlarhk":"⨗","intprod":"⨼","InvisibleComma":"⁣","InvisibleTimes":"⁢","IOcy":"Ё","iocy":"ё","Iogon":"Į","iogon":"į","Iopf":"𝕀","iopf":"𝕚","Iota":"Ι","iota":"ι","iprod":"⨼","iquest":"¿","iscr":"𝒾","Iscr":"ℐ","isin":"∈","isindot":"⋵","isinE":"⋹","isins":"⋴","isinsv":"⋳","isinv":"∈","it":"⁢","Itilde":"Ĩ","itilde":"ĩ","Iukcy":"І","iukcy":"і","Iuml":"Ï","iuml":"ï","Jcirc":"Ĵ","jcirc":"ĵ","Jcy":"Й","jcy":"й","Jfr":"𝔍","jfr":"𝔧","jmath":"ȷ","Jopf":"𝕁","jopf":"𝕛","Jscr":"𝒥","jscr":"𝒿","Jsercy":"Ј","jsercy":"ј","Jukcy":"Є","jukcy":"є","Kappa":"Κ","kappa":"κ","kappav":"ϰ","Kcedil":"Ķ","kcedil":"ķ","Kcy":"К","kcy":"к","Kfr":"𝔎","kfr":"𝔨","kgreen":"ĸ","KHcy":"Х","khcy":"х","KJcy":"Ќ","kjcy":"ќ","Kopf":"𝕂","kopf":"𝕜","Kscr":"𝒦","kscr":"𝓀","lAarr":"⇚","Lacute":"Ĺ","lacute":"ĺ","laemptyv":"⦴","lagran":"ℒ","Lambda":"Λ","lambda":"λ","lang":"⟨","Lang":"⟪","langd":"⦑","langle":"⟨","lap":"⪅","Laplacetrf":"ℒ","laquo":"«","larrb":"⇤","larrbfs":"⤟","larr":"←","Larr":"↞","lArr":"⇐","larrfs":"⤝","larrhk":"↩","larrlp":"↫","larrpl":"⤹","larrsim":"⥳","larrtl":"↢","latail":"⤙","lAtail":"⤛","lat":"⪫","late":"⪭","lates":"⪭︀","lbarr":"⤌","lBarr":"⤎","lbbrk":"❲","lbrace":"{","lbrack":"[","lbrke":"⦋","lbrksld":"⦏","lbrkslu":"⦍","Lcaron":"Ľ","lcaron":"ľ","Lcedil":"Ļ","lcedil":"ļ","lceil":"⌈","lcub":"{","Lcy":"Л","lcy":"л","ldca":"⤶","ldquo":"“","ldquor":"„","ldrdhar":"⥧","ldrushar":"⥋","ldsh":"↲","le":"≤","lE":"≦","LeftAngleBracket":"⟨","LeftArrowBar":"⇤","leftarrow":"←","LeftArrow":"←","Leftarrow":"⇐","LeftArrowRightArrow":"⇆","leftarrowtail":"↢","LeftCeiling":"⌈","LeftDoubleBracket":"⟦","LeftDownTeeVector":"⥡","LeftDownVectorBar":"⥙","LeftDownVector":"⇃","LeftFloor":"⌊","leftharpoondown":"↽","leftharpoonup":"↼","leftleftarrows":"⇇","leftrightarrow":"↔","LeftRightArrow":"↔","Leftrightarrow":"⇔","leftrightarrows":"⇆","leftrightharpoons":"⇋","leftrightsquigarrow":"↭","LeftRightVector":"⥎","LeftTeeArrow":"↤","LeftTee":"⊣","LeftTeeVector":"⥚","leftthreetimes":"⋋","LeftTriangleBar":"⧏","LeftTriangle":"⊲","LeftTriangleEqual":"⊴","LeftUpDownVector":"⥑","LeftUpTeeVector":"⥠","LeftUpVectorBar":"⥘","LeftUpVector":"↿","LeftVectorBar":"⥒","LeftVector":"↼","lEg":"⪋","leg":"⋚","leq":"≤","leqq":"≦","leqslant":"⩽","lescc":"⪨","les":"⩽","lesdot":"⩿","lesdoto":"⪁","lesdotor":"⪃","lesg":"⋚︀","lesges":"⪓","lessapprox":"⪅","lessdot":"⋖","lesseqgtr":"⋚","lesseqqgtr":"⪋","LessEqualGreater":"⋚","LessFullEqual":"≦","LessGreater":"≶","lessgtr":"≶","LessLess":"⪡","lesssim":"≲","LessSlantEqual":"⩽","LessTilde":"≲","lfisht":"⥼","lfloor":"⌊","Lfr":"𝔏","lfr":"𝔩","lg":"≶","lgE":"⪑","lHar":"⥢","lhard":"↽","lharu":"↼","lharul":"⥪","lhblk":"▄","LJcy":"Љ","ljcy":"љ","llarr":"⇇","ll":"≪","Ll":"⋘","llcorner":"⌞","Lleftarrow":"⇚","llhard":"⥫","lltri":"◺","Lmidot":"Ŀ","lmidot":"ŀ","lmoustache":"⎰","lmoust":"⎰","lnap":"⪉","lnapprox":"⪉","lne":"⪇","lnE":"≨","lneq":"⪇","lneqq":"≨","lnsim":"⋦","loang":"⟬","loarr":"⇽","lobrk":"⟦","longleftarrow":"⟵","LongLeftArrow":"⟵","Longleftarrow":"⟸","longleftrightarrow":"⟷","LongLeftRightArrow":"⟷","Longleftrightarrow":"⟺","longmapsto":"⟼","longrightarrow":"⟶","LongRightArrow":"⟶","Longrightarrow":"⟹","looparrowleft":"↫","looparrowright":"↬","lopar":"⦅","Lopf":"𝕃","lopf":"𝕝","loplus":"⨭","lotimes":"⨴","lowast":"∗","lowbar":"_","LowerLeftArrow":"↙","LowerRightArrow":"↘","loz":"◊","lozenge":"◊","lozf":"⧫","lpar":"(","lparlt":"⦓","lrarr":"⇆","lrcorner":"⌟","lrhar":"⇋","lrhard":"⥭","lrm":"‎","lrtri":"⊿","lsaquo":"‹","lscr":"𝓁","Lscr":"ℒ","lsh":"↰","Lsh":"↰","lsim":"≲","lsime":"⪍","lsimg":"⪏","lsqb":"[","lsquo":"‘","lsquor":"‚","Lstrok":"Ł","lstrok":"ł","ltcc":"⪦","ltcir":"⩹","lt":"<","LT":"<","Lt":"≪","ltdot":"⋖","lthree":"⋋","ltimes":"⋉","ltlarr":"⥶","ltquest":"⩻","ltri":"◃","ltrie":"⊴","ltrif":"◂","ltrPar":"⦖","lurdshar":"⥊","luruhar":"⥦","lvertneqq":"≨︀","lvnE":"≨︀","macr":"¯","male":"♂","malt":"✠","maltese":"✠","Map":"⤅","map":"↦","mapsto":"↦","mapstodown":"↧","mapstoleft":"↤","mapstoup":"↥","marker":"▮","mcomma":"⨩","Mcy":"М","mcy":"м","mdash":"—","mDDot":"∺","measuredangle":"∡","MediumSpace":" ","Mellintrf":"ℳ","Mfr":"𝔐","mfr":"𝔪","mho":"℧","micro":"µ","midast":"*","midcir":"⫰","mid":"∣","middot":"·","minusb":"⊟","minus":"−","minusd":"∸","minusdu":"⨪","MinusPlus":"∓","mlcp":"⫛","mldr":"…","mnplus":"∓","models":"⊧","Mopf":"𝕄","mopf":"𝕞","mp":"∓","mscr":"𝓂","Mscr":"ℳ","mstpos":"∾","Mu":"Μ","mu":"μ","multimap":"⊸","mumap":"⊸","nabla":"∇","Nacute":"Ń","nacute":"ń","nang":"∠⃒","nap":"≉","napE":"⩰̸","napid":"≋̸","napos":"ŉ","napprox":"≉","natural":"♮","naturals":"ℕ","natur":"♮","nbsp":" ","nbump":"≎̸","nbumpe":"≏̸","ncap":"⩃","Ncaron":"Ň","ncaron":"ň","Ncedil":"Ņ","ncedil":"ņ","ncong":"≇","ncongdot":"⩭̸","ncup":"⩂","Ncy":"Н","ncy":"н","ndash":"–","nearhk":"⤤","nearr":"↗","neArr":"⇗","nearrow":"↗","ne":"≠","nedot":"≐̸","NegativeMediumSpace":"​","NegativeThickSpace":"​","NegativeThinSpace":"​","NegativeVeryThinSpace":"​","nequiv":"≢","nesear":"⤨","nesim":"≂̸","NestedGreaterGreater":"≫","NestedLessLess":"≪","NewLine":"\n","nexist":"∄","nexists":"∄","Nfr":"𝔑","nfr":"𝔫","ngE":"≧̸","nge":"≱","ngeq":"≱","ngeqq":"≧̸","ngeqslant":"⩾̸","nges":"⩾̸","nGg":"⋙̸","ngsim":"≵","nGt":"≫⃒","ngt":"≯","ngtr":"≯","nGtv":"≫̸","nharr":"↮","nhArr":"⇎","nhpar":"⫲","ni":"∋","nis":"⋼","nisd":"⋺","niv":"∋","NJcy":"Њ","njcy":"њ","nlarr":"↚","nlArr":"⇍","nldr":"‥","nlE":"≦̸","nle":"≰","nleftarrow":"↚","nLeftarrow":"⇍","nleftrightarrow":"↮","nLeftrightarrow":"⇎","nleq":"≰","nleqq":"≦̸","nleqslant":"⩽̸","nles":"⩽̸","nless":"≮","nLl":"⋘̸","nlsim":"≴","nLt":"≪⃒","nlt":"≮","nltri":"⋪","nltrie":"⋬","nLtv":"≪̸","nmid":"∤","NoBreak":"⁠","NonBreakingSpace":" ","nopf":"𝕟","Nopf":"ℕ","Not":"⫬","not":"¬","NotCongruent":"≢","NotCupCap":"≭","NotDoubleVerticalBar":"∦","NotElement":"∉","NotEqual":"≠","NotEqualTilde":"≂̸","NotExists":"∄","NotGreater":"≯","NotGreaterEqual":"≱","NotGreaterFullEqual":"≧̸","NotGreaterGreater":"≫̸","NotGreaterLess":"≹","NotGreaterSlantEqual":"⩾̸","NotGreaterTilde":"≵","NotHumpDownHump":"≎̸","NotHumpEqual":"≏̸","notin":"∉","notindot":"⋵̸","notinE":"⋹̸","notinva":"∉","notinvb":"⋷","notinvc":"⋶","NotLeftTriangleBar":"⧏̸","NotLeftTriangle":"⋪","NotLeftTriangleEqual":"⋬","NotLess":"≮","NotLessEqual":"≰","NotLessGreater":"≸","NotLessLess":"≪̸","NotLessSlantEqual":"⩽̸","NotLessTilde":"≴","NotNestedGreaterGreater":"⪢̸","NotNestedLessLess":"⪡̸","notni":"∌","notniva":"∌","notnivb":"⋾","notnivc":"⋽","NotPrecedes":"⊀","NotPrecedesEqual":"⪯̸","NotPrecedesSlantEqual":"⋠","NotReverseElement":"∌","NotRightTriangleBar":"⧐̸","NotRightTriangle":"⋫","NotRightTriangleEqual":"⋭","NotSquareSubset":"⊏̸","NotSquareSubsetEqual":"⋢","NotSquareSuperset":"⊐̸","NotSquareSupersetEqual":"⋣","NotSubset":"⊂⃒","NotSubsetEqual":"⊈","NotSucceeds":"⊁","NotSucceedsEqual":"⪰̸","NotSucceedsSlantEqual":"⋡","NotSucceedsTilde":"≿̸","NotSuperset":"⊃⃒","NotSupersetEqual":"⊉","NotTilde":"≁","NotTildeEqual":"≄","NotTildeFullEqual":"≇","NotTildeTilde":"≉","NotVerticalBar":"∤","nparallel":"∦","npar":"∦","nparsl":"⫽⃥","npart":"∂̸","npolint":"⨔","npr":"⊀","nprcue":"⋠","nprec":"⊀","npreceq":"⪯̸","npre":"⪯̸","nrarrc":"⤳̸","nrarr":"↛","nrArr":"⇏","nrarrw":"↝̸","nrightarrow":"↛","nRightarrow":"⇏","nrtri":"⋫","nrtrie":"⋭","nsc":"⊁","nsccue":"⋡","nsce":"⪰̸","Nscr":"𝒩","nscr":"𝓃","nshortmid":"∤","nshortparallel":"∦","nsim":"≁","nsime":"≄","nsimeq":"≄","nsmid":"∤","nspar":"∦","nsqsube":"⋢","nsqsupe":"⋣","nsub":"⊄","nsubE":"⫅̸","nsube":"⊈","nsubset":"⊂⃒","nsubseteq":"⊈","nsubseteqq":"⫅̸","nsucc":"⊁","nsucceq":"⪰̸","nsup":"⊅","nsupE":"⫆̸","nsupe":"⊉","nsupset":"⊃⃒","nsupseteq":"⊉","nsupseteqq":"⫆̸","ntgl":"≹","Ntilde":"Ñ","ntilde":"ñ","ntlg":"≸","ntriangleleft":"⋪","ntrianglelefteq":"⋬","ntriangleright":"⋫","ntrianglerighteq":"⋭","Nu":"Ν","nu":"ν","num":"#","numero":"№","numsp":" ","nvap":"≍⃒","nvdash":"⊬","nvDash":"⊭","nVdash":"⊮","nVDash":"⊯","nvge":"≥⃒","nvgt":">⃒","nvHarr":"⤄","nvinfin":"⧞","nvlArr":"⤂","nvle":"≤⃒","nvlt":"<⃒","nvltrie":"⊴⃒","nvrArr":"⤃","nvrtrie":"⊵⃒","nvsim":"∼⃒","nwarhk":"⤣","nwarr":"↖","nwArr":"⇖","nwarrow":"↖","nwnear":"⤧","Oacute":"Ó","oacute":"ó","oast":"⊛","Ocirc":"Ô","ocirc":"ô","ocir":"⊚","Ocy":"О","ocy":"о","odash":"⊝","Odblac":"Ő","odblac":"ő","odiv":"⨸","odot":"⊙","odsold":"⦼","OElig":"Œ","oelig":"œ","ofcir":"⦿","Ofr":"𝔒","ofr":"𝔬","ogon":"˛","Ograve":"Ò","ograve":"ò","ogt":"⧁","ohbar":"⦵","ohm":"Ω","oint":"∮","olarr":"↺","olcir":"⦾","olcross":"⦻","oline":"‾","olt":"⧀","Omacr":"Ō","omacr":"ō","Omega":"Ω","omega":"ω","Omicron":"Ο","omicron":"ο","omid":"⦶","ominus":"⊖","Oopf":"𝕆","oopf":"𝕠","opar":"⦷","OpenCurlyDoubleQuote":"“","OpenCurlyQuote":"‘","operp":"⦹","oplus":"⊕","orarr":"↻","Or":"⩔","or":"∨","ord":"⩝","order":"ℴ","orderof":"ℴ","ordf":"ª","ordm":"º","origof":"⊶","oror":"⩖","orslope":"⩗","orv":"⩛","oS":"Ⓢ","Oscr":"𝒪","oscr":"ℴ","Oslash":"Ø","oslash":"ø","osol":"⊘","Otilde":"Õ","otilde":"õ","otimesas":"⨶","Otimes":"⨷","otimes":"⊗","Ouml":"Ö","ouml":"ö","ovbar":"⌽","OverBar":"‾","OverBrace":"⏞","OverBracket":"⎴","OverParenthesis":"⏜","para":"¶","parallel":"∥","par":"∥","parsim":"⫳","parsl":"⫽","part":"∂","PartialD":"∂","Pcy":"П","pcy":"п","percnt":"%","period":".","permil":"‰","perp":"⊥","pertenk":"‱","Pfr":"𝔓","pfr":"𝔭","Phi":"Φ","phi":"φ","phiv":"ϕ","phmmat":"ℳ","phone":"☎","Pi":"Π","pi":"π","pitchfork":"⋔","piv":"ϖ","planck":"ℏ","planckh":"ℎ","plankv":"ℏ","plusacir":"⨣","plusb":"⊞","pluscir":"⨢","plus":"+","plusdo":"∔","plusdu":"⨥","pluse":"⩲","PlusMinus":"±","plusmn":"±","plussim":"⨦","plustwo":"⨧","pm":"±","Poincareplane":"ℌ","pointint":"⨕","popf":"𝕡","Popf":"ℙ","pound":"£","prap":"⪷","Pr":"⪻","pr":"≺","prcue":"≼","precapprox":"⪷","prec":"≺","preccurlyeq":"≼","Precedes":"≺","PrecedesEqual":"⪯","PrecedesSlantEqual":"≼","PrecedesTilde":"≾","preceq":"⪯","precnapprox":"⪹","precneqq":"⪵","precnsim":"⋨","pre":"⪯","prE":"⪳","precsim":"≾","prime":"′","Prime":"″","primes":"ℙ","prnap":"⪹","prnE":"⪵","prnsim":"⋨","prod":"∏","Product":"∏","profalar":"⌮","profline":"⌒","profsurf":"⌓","prop":"∝","Proportional":"∝","Proportion":"∷","propto":"∝","prsim":"≾","prurel":"⊰","Pscr":"𝒫","pscr":"𝓅","Psi":"Ψ","psi":"ψ","puncsp":" ","Qfr":"𝔔","qfr":"𝔮","qint":"⨌","qopf":"𝕢","Qopf":"ℚ","qprime":"⁗","Qscr":"𝒬","qscr":"𝓆","quaternions":"ℍ","quatint":"⨖","quest":"?","questeq":"≟","quot":"\"","QUOT":"\"","rAarr":"⇛","race":"∽̱","Racute":"Ŕ","racute":"ŕ","radic":"√","raemptyv":"⦳","rang":"⟩","Rang":"⟫","rangd":"⦒","range":"⦥","rangle":"⟩","raquo":"»","rarrap":"⥵","rarrb":"⇥","rarrbfs":"⤠","rarrc":"⤳","rarr":"→","Rarr":"↠","rArr":"⇒","rarrfs":"⤞","rarrhk":"↪","rarrlp":"↬","rarrpl":"⥅","rarrsim":"⥴","Rarrtl":"⤖","rarrtl":"↣","rarrw":"↝","ratail":"⤚","rAtail":"⤜","ratio":"∶","rationals":"ℚ","rbarr":"⤍","rBarr":"⤏","RBarr":"⤐","rbbrk":"❳","rbrace":"}","rbrack":"]","rbrke":"⦌","rbrksld":"⦎","rbrkslu":"⦐","Rcaron":"Ř","rcaron":"ř","Rcedil":"Ŗ","rcedil":"ŗ","rceil":"⌉","rcub":"}","Rcy":"Р","rcy":"р","rdca":"⤷","rdldhar":"⥩","rdquo":"”","rdquor":"”","rdsh":"↳","real":"ℜ","realine":"ℛ","realpart":"ℜ","reals":"ℝ","Re":"ℜ","rect":"▭","reg":"®","REG":"®","ReverseElement":"∋","ReverseEquilibrium":"⇋","ReverseUpEquilibrium":"⥯","rfisht":"⥽","rfloor":"⌋","rfr":"𝔯","Rfr":"ℜ","rHar":"⥤","rhard":"⇁","rharu":"⇀","rharul":"⥬","Rho":"Ρ","rho":"ρ","rhov":"ϱ","RightAngleBracket":"⟩","RightArrowBar":"⇥","rightarrow":"→","RightArrow":"→","Rightarrow":"⇒","RightArrowLeftArrow":"⇄","rightarrowtail":"↣","RightCeiling":"⌉","RightDoubleBracket":"⟧","RightDownTeeVector":"⥝","RightDownVectorBar":"⥕","RightDownVector":"⇂","RightFloor":"⌋","rightharpoondown":"⇁","rightharpoonup":"⇀","rightleftarrows":"⇄","rightleftharpoons":"⇌","rightrightarrows":"⇉","rightsquigarrow":"↝","RightTeeArrow":"↦","RightTee":"⊢","RightTeeVector":"⥛","rightthreetimes":"⋌","RightTriangleBar":"⧐","RightTriangle":"⊳","RightTriangleEqual":"⊵","RightUpDownVector":"⥏","RightUpTeeVector":"⥜","RightUpVectorBar":"⥔","RightUpVector":"↾","RightVectorBar":"⥓","RightVector":"⇀","ring":"˚","risingdotseq":"≓","rlarr":"⇄","rlhar":"⇌","rlm":"‏","rmoustache":"⎱","rmoust":"⎱","rnmid":"⫮","roang":"⟭","roarr":"⇾","robrk":"⟧","ropar":"⦆","ropf":"𝕣","Ropf":"ℝ","roplus":"⨮","rotimes":"⨵","RoundImplies":"⥰","rpar":")","rpargt":"⦔","rppolint":"⨒","rrarr":"⇉","Rrightarrow":"⇛","rsaquo":"›","rscr":"𝓇","Rscr":"ℛ","rsh":"↱","Rsh":"↱","rsqb":"]","rsquo":"’","rsquor":"’","rthree":"⋌","rtimes":"⋊","rtri":"▹","rtrie":"⊵","rtrif":"▸","rtriltri":"⧎","RuleDelayed":"⧴","ruluhar":"⥨","rx":"℞","Sacute":"Ś","sacute":"ś","sbquo":"‚","scap":"⪸","Scaron":"Š","scaron":"š","Sc":"⪼","sc":"≻","sccue":"≽","sce":"⪰","scE":"⪴","Scedil":"Ş","scedil":"ş","Scirc":"Ŝ","scirc":"ŝ","scnap":"⪺","scnE":"⪶","scnsim":"⋩","scpolint":"⨓","scsim":"≿","Scy":"С","scy":"с","sdotb":"⊡","sdot":"⋅","sdote":"⩦","searhk":"⤥","searr":"↘","seArr":"⇘","searrow":"↘","sect":"§","semi":";","seswar":"⤩","setminus":"∖","setmn":"∖","sext":"✶","Sfr":"𝔖","sfr":"𝔰","sfrown":"⌢","sharp":"♯","SHCHcy":"Щ","shchcy":"щ","SHcy":"Ш","shcy":"ш","ShortDownArrow":"↓","ShortLeftArrow":"←","shortmid":"∣","shortparallel":"∥","ShortRightArrow":"→","ShortUpArrow":"↑","shy":"­","Sigma":"Σ","sigma":"σ","sigmaf":"ς","sigmav":"ς","sim":"∼","simdot":"⩪","sime":"≃","simeq":"≃","simg":"⪞","simgE":"⪠","siml":"⪝","simlE":"⪟","simne":"≆","simplus":"⨤","simrarr":"⥲","slarr":"←","SmallCircle":"∘","smallsetminus":"∖","smashp":"⨳","smeparsl":"⧤","smid":"∣","smile":"⌣","smt":"⪪","smte":"⪬","smtes":"⪬︀","SOFTcy":"Ь","softcy":"ь","solbar":"⌿","solb":"⧄","sol":"/","Sopf":"𝕊","sopf":"𝕤","spades":"♠","spadesuit":"♠","spar":"∥","sqcap":"⊓","sqcaps":"⊓︀","sqcup":"⊔","sqcups":"⊔︀","Sqrt":"√","sqsub":"⊏","sqsube":"⊑","sqsubset":"⊏","sqsubseteq":"⊑","sqsup":"⊐","sqsupe":"⊒","sqsupset":"⊐","sqsupseteq":"⊒","square":"□","Square":"□","SquareIntersection":"⊓","SquareSubset":"⊏","SquareSubsetEqual":"⊑","SquareSuperset":"⊐","SquareSupersetEqual":"⊒","SquareUnion":"⊔","squarf":"▪","squ":"□","squf":"▪","srarr":"→","Sscr":"𝒮","sscr":"𝓈","ssetmn":"∖","ssmile":"⌣","sstarf":"⋆","Star":"⋆","star":"☆","starf":"★","straightepsilon":"ϵ","straightphi":"ϕ","strns":"¯","sub":"⊂","Sub":"⋐","subdot":"⪽","subE":"⫅","sube":"⊆","subedot":"⫃","submult":"⫁","subnE":"⫋","subne":"⊊","subplus":"⪿","subrarr":"⥹","subset":"⊂","Subset":"⋐","subseteq":"⊆","subseteqq":"⫅","SubsetEqual":"⊆","subsetneq":"⊊","subsetneqq":"⫋","subsim":"⫇","subsub":"⫕","subsup":"⫓","succapprox":"⪸","succ":"≻","succcurlyeq":"≽","Succeeds":"≻","SucceedsEqual":"⪰","SucceedsSlantEqual":"≽","SucceedsTilde":"≿","succeq":"⪰","succnapprox":"⪺","succneqq":"⪶","succnsim":"⋩","succsim":"≿","SuchThat":"∋","sum":"∑","Sum":"∑","sung":"♪","sup1":"¹","sup2":"²","sup3":"³","sup":"⊃","Sup":"⋑","supdot":"⪾","supdsub":"⫘","supE":"⫆","supe":"⊇","supedot":"⫄","Superset":"⊃","SupersetEqual":"⊇","suphsol":"⟉","suphsub":"⫗","suplarr":"⥻","supmult":"⫂","supnE":"⫌","supne":"⊋","supplus":"⫀","supset":"⊃","Supset":"⋑","supseteq":"⊇","supseteqq":"⫆","supsetneq":"⊋","supsetneqq":"⫌","supsim":"⫈","supsub":"⫔","supsup":"⫖","swarhk":"⤦","swarr":"↙","swArr":"⇙","swarrow":"↙","swnwar":"⤪","szlig":"ß","Tab":"\t","target":"⌖","Tau":"Τ","tau":"τ","tbrk":"⎴","Tcaron":"Ť","tcaron":"ť","Tcedil":"Ţ","tcedil":"ţ","Tcy":"Т","tcy":"т","tdot":"⃛","telrec":"⌕","Tfr":"𝔗","tfr":"𝔱","there4":"∴","therefore":"∴","Therefore":"∴","Theta":"Θ","theta":"θ","thetasym":"ϑ","thetav":"ϑ","thickapprox":"≈","thicksim":"∼","ThickSpace":"  ","ThinSpace":" ","thinsp":" ","thkap":"≈","thksim":"∼","THORN":"Þ","thorn":"þ","tilde":"˜","Tilde":"∼","TildeEqual":"≃","TildeFullEqual":"≅","TildeTilde":"≈","timesbar":"⨱","timesb":"⊠","times":"×","timesd":"⨰","tint":"∭","toea":"⤨","topbot":"⌶","topcir":"⫱","top":"⊤","Topf":"𝕋","topf":"𝕥","topfork":"⫚","tosa":"⤩","tprime":"‴","trade":"™","TRADE":"™","triangle":"▵","triangledown":"▿","triangleleft":"◃","trianglelefteq":"⊴","triangleq":"≜","triangleright":"▹","trianglerighteq":"⊵","tridot":"◬","trie":"≜","triminus":"⨺","TripleDot":"⃛","triplus":"⨹","trisb":"⧍","tritime":"⨻","trpezium":"⏢","Tscr":"𝒯","tscr":"𝓉","TScy":"Ц","tscy":"ц","TSHcy":"Ћ","tshcy":"ћ","Tstrok":"Ŧ","tstrok":"ŧ","twixt":"≬","twoheadleftarrow":"↞","twoheadrightarrow":"↠","Uacute":"Ú","uacute":"ú","uarr":"↑","Uarr":"↟","uArr":"⇑","Uarrocir":"⥉","Ubrcy":"Ў","ubrcy":"ў","Ubreve":"Ŭ","ubreve":"ŭ","Ucirc":"Û","ucirc":"û","Ucy":"У","ucy":"у","udarr":"⇅","Udblac":"Ű","udblac":"ű","udhar":"⥮","ufisht":"⥾","Ufr":"𝔘","ufr":"𝔲","Ugrave":"Ù","ugrave":"ù","uHar":"⥣","uharl":"↿","uharr":"↾","uhblk":"▀","ulcorn":"⌜","ulcorner":"⌜","ulcrop":"⌏","ultri":"◸","Umacr":"Ū","umacr":"ū","uml":"¨","UnderBar":"_","UnderBrace":"⏟","UnderBracket":"⎵","UnderParenthesis":"⏝","Union":"⋃","UnionPlus":"⊎","Uogon":"Ų","uogon":"ų","Uopf":"𝕌","uopf":"𝕦","UpArrowBar":"⤒","uparrow":"↑","UpArrow":"↑","Uparrow":"⇑","UpArrowDownArrow":"⇅","updownarrow":"↕","UpDownArrow":"↕","Updownarrow":"⇕","UpEquilibrium":"⥮","upharpoonleft":"↿","upharpoonright":"↾","uplus":"⊎","UpperLeftArrow":"↖","UpperRightArrow":"↗","upsi":"υ","Upsi":"ϒ","upsih":"ϒ","Upsilon":"Υ","upsilon":"υ","UpTeeArrow":"↥","UpTee":"⊥","upuparrows":"⇈","urcorn":"⌝","urcorner":"⌝","urcrop":"⌎","Uring":"Ů","uring":"ů","urtri":"◹","Uscr":"𝒰","uscr":"𝓊","utdot":"⋰","Utilde":"Ũ","utilde":"ũ","utri":"▵","utrif":"▴","uuarr":"⇈","Uuml":"Ü","uuml":"ü","uwangle":"⦧","vangrt":"⦜","varepsilon":"ϵ","varkappa":"ϰ","varnothing":"∅","varphi":"ϕ","varpi":"ϖ","varpropto":"∝","varr":"↕","vArr":"⇕","varrho":"ϱ","varsigma":"ς","varsubsetneq":"⊊︀","varsubsetneqq":"⫋︀","varsupsetneq":"⊋︀","varsupsetneqq":"⫌︀","vartheta":"ϑ","vartriangleleft":"⊲","vartriangleright":"⊳","vBar":"⫨","Vbar":"⫫","vBarv":"⫩","Vcy":"В","vcy":"в","vdash":"⊢","vDash":"⊨","Vdash":"⊩","VDash":"⊫","Vdashl":"⫦","veebar":"⊻","vee":"∨","Vee":"⋁","veeeq":"≚","vellip":"⋮","verbar":"|","Verbar":"‖","vert":"|","Vert":"‖","VerticalBar":"∣","VerticalLine":"|","VerticalSeparator":"❘","VerticalTilde":"≀","VeryThinSpace":" ","Vfr":"𝔙","vfr":"𝔳","vltri":"⊲","vnsub":"⊂⃒","vnsup":"⊃⃒","Vopf":"𝕍","vopf":"𝕧","vprop":"∝","vrtri":"⊳","Vscr":"𝒱","vscr":"𝓋","vsubnE":"⫋︀","vsubne":"⊊︀","vsupnE":"⫌︀","vsupne":"⊋︀","Vvdash":"⊪","vzigzag":"⦚","Wcirc":"Ŵ","wcirc":"ŵ","wedbar":"⩟","wedge":"∧","Wedge":"⋀","wedgeq":"≙","weierp":"℘","Wfr":"𝔚","wfr":"𝔴","Wopf":"𝕎","wopf":"𝕨","wp":"℘","wr":"≀","wreath":"≀","Wscr":"𝒲","wscr":"𝓌","xcap":"⋂","xcirc":"◯","xcup":"⋃","xdtri":"▽","Xfr":"𝔛","xfr":"𝔵","xharr":"⟷","xhArr":"⟺","Xi":"Ξ","xi":"ξ","xlarr":"⟵","xlArr":"⟸","xmap":"⟼","xnis":"⋻","xodot":"⨀","Xopf":"𝕏","xopf":"𝕩","xoplus":"⨁","xotime":"⨂","xrarr":"⟶","xrArr":"⟹","Xscr":"𝒳","xscr":"𝓍","xsqcup":"⨆","xuplus":"⨄","xutri":"△","xvee":"⋁","xwedge":"⋀","Yacute":"Ý","yacute":"ý","YAcy":"Я","yacy":"я","Ycirc":"Ŷ","ycirc":"ŷ","Ycy":"Ы","ycy":"ы","yen":"¥","Yfr":"𝔜","yfr":"𝔶","YIcy":"Ї","yicy":"ї","Yopf":"𝕐","yopf":"𝕪","Yscr":"𝒴","yscr":"𝓎","YUcy":"Ю","yucy":"ю","yuml":"ÿ","Yuml":"Ÿ","Zacute":"Ź","zacute":"ź","Zcaron":"Ž","zcaron":"ž","Zcy":"З","zcy":"з","Zdot":"Ż","zdot":"ż","zeetrf":"ℨ","ZeroWidthSpace":"​","Zeta":"Ζ","zeta":"ζ","zfr":"𝔷","Zfr":"ℨ","ZHcy":"Ж","zhcy":"ж","zigrarr":"⇝","zopf":"𝕫","Zopf":"ℤ","Zscr":"𝒵","zscr":"𝓏","zwj":"‍","zwnj":"‌"}

/***/ }),

/***/ 797:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 798:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 799:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 800:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 801:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 802:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 803:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 804:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 805:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 806:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 807:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 808:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 809:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 810:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 811:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 812:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 813:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 814:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 815:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 816:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 817:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 818:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 819:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 820:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 821:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 822:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 823:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 824:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 825:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 826:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 850:
/***/ (function(module, exports) {

module.exports = {"100":"💯","1234":"🔢","grinning":"😀","smiley":"😃","smile":"😄","grin":"😁","laughing":"😆","satisfied":"😆","sweat_smile":"😅","joy":"😂","rofl":"🤣","relaxed":"☺️","blush":"😊","innocent":"😇","slightly_smiling_face":"🙂","upside_down_face":"🙃","wink":"😉","relieved":"😌","heart_eyes":"😍","kissing_heart":"😘","kissing":"😗","kissing_smiling_eyes":"😙","kissing_closed_eyes":"😚","yum":"😋","stuck_out_tongue_winking_eye":"😜","stuck_out_tongue_closed_eyes":"😝","stuck_out_tongue":"😛","money_mouth_face":"🤑","hugs":"🤗","nerd_face":"🤓","sunglasses":"😎","clown_face":"🤡","cowboy_hat_face":"🤠","smirk":"😏","unamused":"😒","disappointed":"😞","pensive":"😔","worried":"😟","confused":"😕","slightly_frowning_face":"🙁","frowning_face":"☹️","persevere":"😣","confounded":"😖","tired_face":"😫","weary":"😩","triumph":"😤","angry":"😠","rage":"😡","pout":"😡","no_mouth":"😶","neutral_face":"😐","expressionless":"😑","hushed":"😯","frowning":"😦","anguished":"😧","open_mouth":"😮","astonished":"😲","dizzy_face":"😵","flushed":"😳","scream":"😱","fearful":"😨","cold_sweat":"😰","cry":"😢","disappointed_relieved":"😥","drooling_face":"🤤","sob":"😭","sweat":"😓","sleepy":"😪","sleeping":"😴","roll_eyes":"🙄","thinking":"🤔","lying_face":"🤥","grimacing":"😬","zipper_mouth_face":"🤐","nauseated_face":"🤢","sneezing_face":"🤧","mask":"😷","face_with_thermometer":"🤒","face_with_head_bandage":"🤕","smiling_imp":"😈","imp":"👿","japanese_ogre":"👹","japanese_goblin":"👺","hankey":"💩","poop":"💩","shit":"💩","ghost":"👻","skull":"💀","skull_and_crossbones":"☠️","alien":"👽","space_invader":"👾","robot":"🤖","jack_o_lantern":"🎃","smiley_cat":"😺","smile_cat":"😸","joy_cat":"😹","heart_eyes_cat":"😻","smirk_cat":"😼","kissing_cat":"😽","scream_cat":"🙀","crying_cat_face":"😿","pouting_cat":"😾","open_hands":"👐","raised_hands":"🙌","clap":"👏","pray":"🙏","handshake":"🤝","+1":"👍","thumbsup":"👍","-1":"👎","thumbsdown":"👎","fist_oncoming":"👊","facepunch":"👊","punch":"👊","fist_raised":"✊","fist":"✊","fist_left":"🤛","fist_right":"🤜","crossed_fingers":"🤞","v":"✌️","metal":"🤘","ok_hand":"👌","point_left":"👈","point_right":"👉","point_up_2":"👆","point_down":"👇","point_up":"☝️","hand":"✋","raised_hand":"✋","raised_back_of_hand":"🤚","raised_hand_with_fingers_splayed":"🖐","vulcan_salute":"🖖","wave":"👋","call_me_hand":"🤙","muscle":"💪","middle_finger":"🖕","fu":"🖕","writing_hand":"✍️","selfie":"🤳","nail_care":"💅","ring":"💍","lipstick":"💄","kiss":"💋","lips":"👄","tongue":"👅","ear":"👂","nose":"👃","footprints":"👣","eye":"👁","eyes":"👀","speaking_head":"🗣","bust_in_silhouette":"👤","busts_in_silhouette":"👥","baby":"👶","boy":"👦","girl":"👧","man":"👨","woman":"👩","blonde_woman":"👱‍♀","blonde_man":"👱","person_with_blond_hair":"👱","older_man":"👴","older_woman":"👵","man_with_gua_pi_mao":"👲","woman_with_turban":"👳‍♀","man_with_turban":"👳","policewoman":"👮‍♀","policeman":"👮","cop":"👮","construction_worker_woman":"👷‍♀","construction_worker_man":"👷","construction_worker":"👷","guardswoman":"💂‍♀","guardsman":"💂","female_detective":"🕵️‍♀️","male_detective":"🕵","detective":"🕵","woman_health_worker":"👩‍⚕","man_health_worker":"👨‍⚕","woman_farmer":"👩‍🌾","man_farmer":"👨‍🌾","woman_cook":"👩‍🍳","man_cook":"👨‍🍳","woman_student":"👩‍🎓","man_student":"👨‍🎓","woman_singer":"👩‍🎤","man_singer":"👨‍🎤","woman_teacher":"👩‍🏫","man_teacher":"👨‍🏫","woman_factory_worker":"👩‍🏭","man_factory_worker":"👨‍🏭","woman_technologist":"👩‍💻","man_technologist":"👨‍💻","woman_office_worker":"👩‍💼","man_office_worker":"👨‍💼","woman_mechanic":"👩‍🔧","man_mechanic":"👨‍🔧","woman_scientist":"👩‍🔬","man_scientist":"👨‍🔬","woman_artist":"👩‍🎨","man_artist":"👨‍🎨","woman_firefighter":"👩‍🚒","man_firefighter":"👨‍🚒","woman_pilot":"👩‍✈","man_pilot":"👨‍✈","woman_astronaut":"👩‍🚀","man_astronaut":"👨‍🚀","woman_judge":"👩‍⚖","man_judge":"👨‍⚖","mrs_claus":"🤶","santa":"🎅","princess":"👸","prince":"🤴","bride_with_veil":"👰","man_in_tuxedo":"🤵","angel":"👼","pregnant_woman":"🤰","bowing_woman":"🙇‍♀","bowing_man":"🙇","bow":"🙇","tipping_hand_woman":"💁","information_desk_person":"💁","sassy_woman":"💁","tipping_hand_man":"💁‍♂","sassy_man":"💁‍♂","no_good_woman":"🙅","no_good":"🙅","ng_woman":"🙅","no_good_man":"🙅‍♂","ng_man":"🙅‍♂","ok_woman":"🙆","ok_man":"🙆‍♂","raising_hand_woman":"🙋","raising_hand":"🙋","raising_hand_man":"🙋‍♂","woman_facepalming":"🤦‍♀","man_facepalming":"🤦‍♂","woman_shrugging":"🤷‍♀","man_shrugging":"🤷‍♂","pouting_woman":"🙎","person_with_pouting_face":"🙎","pouting_man":"🙎‍♂","frowning_woman":"🙍","person_frowning":"🙍","frowning_man":"🙍‍♂","haircut_woman":"💇","haircut":"💇","haircut_man":"💇‍♂","massage_woman":"💆","massage":"💆","massage_man":"💆‍♂","business_suit_levitating":"🕴","dancer":"💃","man_dancing":"🕺","dancing_women":"👯","dancers":"👯","dancing_men":"👯‍♂","walking_woman":"🚶‍♀","walking_man":"🚶","walking":"🚶","running_woman":"🏃‍♀","running_man":"🏃","runner":"🏃","running":"🏃","couple":"👫","two_women_holding_hands":"👭","two_men_holding_hands":"👬","couple_with_heart_woman_man":"💑","couple_with_heart":"💑","couple_with_heart_woman_woman":"👩‍❤️‍👩","couple_with_heart_man_man":"👨‍❤️‍👨","couplekiss_man_woman":"💏","couplekiss_woman_woman":"👩‍❤️‍💋‍👩","couplekiss_man_man":"👨‍❤️‍💋‍👨","family_man_woman_boy":"👪","family":"👪","family_man_woman_girl":"👨‍👩‍👧","family_man_woman_girl_boy":"👨‍👩‍👧‍👦","family_man_woman_boy_boy":"👨‍👩‍👦‍👦","family_man_woman_girl_girl":"👨‍👩‍👧‍👧","family_woman_woman_boy":"👩‍👩‍👦","family_woman_woman_girl":"👩‍👩‍👧","family_woman_woman_girl_boy":"👩‍👩‍👧‍👦","family_woman_woman_boy_boy":"👩‍👩‍👦‍👦","family_woman_woman_girl_girl":"👩‍👩‍👧‍👧","family_man_man_boy":"👨‍👨‍👦","family_man_man_girl":"👨‍👨‍👧","family_man_man_girl_boy":"👨‍👨‍👧‍👦","family_man_man_boy_boy":"👨‍👨‍👦‍👦","family_man_man_girl_girl":"👨‍👨‍👧‍👧","family_woman_boy":"👩‍👦","family_woman_girl":"👩‍👧","family_woman_girl_boy":"👩‍👧‍👦","family_woman_boy_boy":"👩‍👦‍👦","family_woman_girl_girl":"👩‍👧‍👧","family_man_boy":"👨‍👦","family_man_girl":"👨‍👧","family_man_girl_boy":"👨‍👧‍👦","family_man_boy_boy":"👨‍👦‍👦","family_man_girl_girl":"👨‍👧‍👧","womans_clothes":"👚","shirt":"👕","tshirt":"👕","jeans":"👖","necktie":"👔","dress":"👗","bikini":"👙","kimono":"👘","high_heel":"👠","sandal":"👡","boot":"👢","mans_shoe":"👞","shoe":"👞","athletic_shoe":"👟","womans_hat":"👒","tophat":"🎩","mortar_board":"🎓","crown":"👑","rescue_worker_helmet":"⛑","school_satchel":"🎒","pouch":"👝","purse":"👛","handbag":"👜","briefcase":"💼","eyeglasses":"👓","dark_sunglasses":"🕶","closed_umbrella":"🌂","open_umbrella":"☂️","dog":"🐶","cat":"🐱","mouse":"🐭","hamster":"🐹","rabbit":"🐰","fox_face":"🦊","bear":"🐻","panda_face":"🐼","koala":"🐨","tiger":"🐯","lion":"🦁","cow":"🐮","pig":"🐷","pig_nose":"🐽","frog":"🐸","monkey_face":"🐵","see_no_evil":"🙈","hear_no_evil":"🙉","speak_no_evil":"🙊","monkey":"🐒","chicken":"🐔","penguin":"🐧","bird":"🐦","baby_chick":"🐤","hatching_chick":"🐣","hatched_chick":"🐥","duck":"🦆","eagle":"🦅","owl":"🦉","bat":"🦇","wolf":"🐺","boar":"🐗","horse":"🐴","unicorn":"🦄","bee":"🐝","honeybee":"🐝","bug":"🐛","butterfly":"🦋","snail":"🐌","shell":"🐚","beetle":"🐞","ant":"🐜","spider":"🕷","spider_web":"🕸","turtle":"🐢","snake":"🐍","lizard":"🦎","scorpion":"🦂","crab":"🦀","squid":"🦑","octopus":"🐙","shrimp":"🦐","tropical_fish":"🐠","fish":"🐟","blowfish":"🐡","dolphin":"🐬","flipper":"🐬","shark":"🦈","whale":"🐳","whale2":"🐋","crocodile":"🐊","leopard":"🐆","tiger2":"🐅","water_buffalo":"🐃","ox":"🐂","cow2":"🐄","deer":"🦌","dromedary_camel":"🐪","camel":"🐫","elephant":"🐘","rhinoceros":"🦏","gorilla":"🦍","racehorse":"🐎","pig2":"🐖","goat":"🐐","ram":"🐏","sheep":"🐑","dog2":"🐕","poodle":"🐩","cat2":"🐈","rooster":"🐓","turkey":"🦃","dove":"🕊","rabbit2":"🐇","mouse2":"🐁","rat":"🐀","chipmunk":"🐿","feet":"🐾","paw_prints":"🐾","dragon":"🐉","dragon_face":"🐲","cactus":"🌵","christmas_tree":"🎄","evergreen_tree":"🌲","deciduous_tree":"🌳","palm_tree":"🌴","seedling":"🌱","herb":"🌿","shamrock":"☘️","four_leaf_clover":"🍀","bamboo":"🎍","tanabata_tree":"🎋","leaves":"🍃","fallen_leaf":"🍂","maple_leaf":"🍁","mushroom":"🍄","ear_of_rice":"🌾","bouquet":"💐","tulip":"🌷","rose":"🌹","wilted_flower":"🥀","sunflower":"🌻","blossom":"🌼","cherry_blossom":"🌸","hibiscus":"🌺","earth_americas":"🌎","earth_africa":"🌍","earth_asia":"🌏","full_moon":"🌕","waning_gibbous_moon":"🌖","last_quarter_moon":"🌗","waning_crescent_moon":"🌘","new_moon":"🌑","waxing_crescent_moon":"🌒","first_quarter_moon":"🌓","moon":"🌔","waxing_gibbous_moon":"🌔","new_moon_with_face":"🌚","full_moon_with_face":"🌝","sun_with_face":"🌞","first_quarter_moon_with_face":"🌛","last_quarter_moon_with_face":"🌜","crescent_moon":"🌙","dizzy":"💫","star":"⭐️","star2":"🌟","sparkles":"✨","zap":"⚡️","fire":"🔥","boom":"💥","collision":"💥","comet":"☄","sunny":"☀️","sun_behind_small_cloud":"🌤","partly_sunny":"⛅️","sun_behind_large_cloud":"🌥","sun_behind_rain_cloud":"🌦","rainbow":"🌈","cloud":"☁️","cloud_with_rain":"🌧","cloud_with_lightning_and_rain":"⛈","cloud_with_lightning":"🌩","cloud_with_snow":"🌨","snowman_with_snow":"☃️","snowman":"⛄️","snowflake":"❄️","wind_face":"🌬","dash":"💨","tornado":"🌪","fog":"🌫","ocean":"🌊","droplet":"💧","sweat_drops":"💦","umbrella":"☔️","green_apple":"🍏","apple":"🍎","pear":"🍐","tangerine":"🍊","orange":"🍊","mandarin":"🍊","lemon":"🍋","banana":"🍌","watermelon":"🍉","grapes":"🍇","strawberry":"🍓","melon":"🍈","cherries":"🍒","peach":"🍑","pineapple":"🍍","kiwi_fruit":"🥝","avocado":"🥑","tomato":"🍅","eggplant":"🍆","cucumber":"🥒","carrot":"🥕","corn":"🌽","hot_pepper":"🌶","potato":"🥔","sweet_potato":"🍠","chestnut":"🌰","peanuts":"🥜","honey_pot":"🍯","croissant":"🥐","bread":"🍞","baguette_bread":"🥖","cheese":"🧀","egg":"🥚","fried_egg":"🍳","bacon":"🥓","pancakes":"🥞","fried_shrimp":"🍤","poultry_leg":"🍗","meat_on_bone":"🍖","pizza":"🍕","hotdog":"🌭","hamburger":"🍔","fries":"🍟","stuffed_flatbread":"🥙","taco":"🌮","burrito":"🌯","green_salad":"🥗","shallow_pan_of_food":"🥘","spaghetti":"🍝","ramen":"🍜","stew":"🍲","fish_cake":"🍥","sushi":"🍣","bento":"🍱","curry":"🍛","rice":"🍚","rice_ball":"🍙","rice_cracker":"🍘","oden":"🍢","dango":"🍡","shaved_ice":"🍧","ice_cream":"🍨","icecream":"🍦","cake":"🍰","birthday":"🎂","custard":"🍮","lollipop":"🍭","candy":"🍬","chocolate_bar":"🍫","popcorn":"🍿","doughnut":"🍩","cookie":"🍪","milk_glass":"🥛","baby_bottle":"🍼","coffee":"☕️","tea":"🍵","sake":"🍶","beer":"🍺","beers":"🍻","clinking_glasses":"🥂","wine_glass":"🍷","tumbler_glass":"🥃","cocktail":"🍸","tropical_drink":"🍹","champagne":"🍾","spoon":"🥄","fork_and_knife":"🍴","plate_with_cutlery":"🍽","soccer":"⚽️","basketball":"🏀","football":"🏈","baseball":"⚾️","tennis":"🎾","volleyball":"🏐","rugby_football":"🏉","8ball":"🎱","ping_pong":"🏓","badminton":"🏸","goal_net":"🥅","ice_hockey":"🏒","field_hockey":"🏑","cricket":"🏏","golf":"⛳️","bow_and_arrow":"🏹","fishing_pole_and_fish":"🎣","boxing_glove":"🥊","martial_arts_uniform":"🥋","ice_skate":"⛸","ski":"🎿","skier":"⛷","snowboarder":"🏂","weight_lifting_woman":"🏋️‍♀️","weight_lifting_man":"🏋","person_fencing":"🤺","women_wrestling":"🤼‍♀","men_wrestling":"🤼‍♂","woman_cartwheeling":"🤸‍♀","man_cartwheeling":"🤸‍♂","basketball_woman":"⛹️‍♀️","basketball_man":"⛹","woman_playing_handball":"🤾‍♀","man_playing_handball":"🤾‍♂","golfing_woman":"🏌️‍♀️","golfing_man":"🏌","surfing_woman":"🏄‍♀","surfing_man":"🏄","surfer":"🏄","swimming_woman":"🏊‍♀","swimming_man":"🏊","swimmer":"🏊","woman_playing_water_polo":"🤽‍♀","man_playing_water_polo":"🤽‍♂","rowing_woman":"🚣‍♀","rowing_man":"🚣","rowboat":"🚣","horse_racing":"🏇","biking_woman":"🚴‍♀","biking_man":"🚴","bicyclist":"🚴","mountain_biking_woman":"🚵‍♀","mountain_biking_man":"🚵","mountain_bicyclist":"🚵","running_shirt_with_sash":"🎽","medal_sports":"🏅","medal_military":"🎖","1st_place_medal":"🥇","2nd_place_medal":"🥈","3rd_place_medal":"🥉","trophy":"🏆","rosette":"🏵","reminder_ribbon":"🎗","ticket":"🎫","tickets":"🎟","circus_tent":"🎪","woman_juggling":"🤹‍♀","man_juggling":"🤹‍♂","performing_arts":"🎭","art":"🎨","clapper":"🎬","microphone":"🎤","headphones":"🎧","musical_score":"🎼","musical_keyboard":"🎹","drum":"🥁","saxophone":"🎷","trumpet":"🎺","guitar":"🎸","violin":"🎻","game_die":"🎲","dart":"🎯","bowling":"🎳","video_game":"🎮","slot_machine":"🎰","car":"🚗","red_car":"🚗","taxi":"🚕","blue_car":"🚙","bus":"🚌","trolleybus":"🚎","racing_car":"🏎","police_car":"🚓","ambulance":"🚑","fire_engine":"🚒","minibus":"🚐","truck":"🚚","articulated_lorry":"🚛","tractor":"🚜","kick_scooter":"🛴","bike":"🚲","motor_scooter":"🛵","motorcycle":"🏍","rotating_light":"🚨","oncoming_police_car":"🚔","oncoming_bus":"🚍","oncoming_automobile":"🚘","oncoming_taxi":"🚖","aerial_tramway":"🚡","mountain_cableway":"🚠","suspension_railway":"🚟","railway_car":"🚃","train":"🚋","mountain_railway":"🚞","monorail":"🚝","bullettrain_side":"🚄","bullettrain_front":"🚅","light_rail":"🚈","steam_locomotive":"🚂","train2":"🚆","metro":"🚇","tram":"🚊","station":"🚉","helicopter":"🚁","small_airplane":"🛩","airplane":"✈️","flight_departure":"🛫","flight_arrival":"🛬","rocket":"🚀","artificial_satellite":"🛰","seat":"💺","canoe":"🛶","boat":"⛵️","sailboat":"⛵️","motor_boat":"🛥","speedboat":"🚤","passenger_ship":"🛳","ferry":"⛴","ship":"🚢","anchor":"⚓️","construction":"🚧","fuelpump":"⛽️","busstop":"🚏","vertical_traffic_light":"🚦","traffic_light":"🚥","world_map":"🗺","moyai":"🗿","statue_of_liberty":"🗽","fountain":"⛲️","tokyo_tower":"🗼","european_castle":"🏰","japanese_castle":"🏯","stadium":"🏟","ferris_wheel":"🎡","roller_coaster":"🎢","carousel_horse":"🎠","parasol_on_ground":"⛱","beach_umbrella":"🏖","desert_island":"🏝","mountain":"⛰","mountain_snow":"🏔","mount_fuji":"🗻","volcano":"🌋","desert":"🏜","camping":"🏕","tent":"⛺️","railway_track":"🛤","motorway":"🛣","building_construction":"🏗","factory":"🏭","house":"🏠","house_with_garden":"🏡","houses":"🏘","derelict_house":"🏚","office":"🏢","department_store":"🏬","post_office":"🏣","european_post_office":"🏤","hospital":"🏥","bank":"🏦","hotel":"🏨","convenience_store":"🏪","school":"🏫","love_hotel":"🏩","wedding":"💒","classical_building":"🏛","church":"⛪️","mosque":"🕌","synagogue":"🕍","kaaba":"🕋","shinto_shrine":"⛩","japan":"🗾","rice_scene":"🎑","national_park":"🏞","sunrise":"🌅","sunrise_over_mountains":"🌄","stars":"🌠","sparkler":"🎇","fireworks":"🎆","city_sunrise":"🌇","city_sunset":"🌆","cityscape":"🏙","night_with_stars":"🌃","milky_way":"🌌","bridge_at_night":"🌉","foggy":"🌁","watch":"⌚️","iphone":"📱","calling":"📲","computer":"💻","keyboard":"⌨️","desktop_computer":"🖥","printer":"🖨","computer_mouse":"🖱","trackball":"🖲","joystick":"🕹","clamp":"🗜","minidisc":"💽","floppy_disk":"💾","cd":"💿","dvd":"📀","vhs":"📼","camera":"📷","camera_flash":"📸","video_camera":"📹","movie_camera":"🎥","film_projector":"📽","film_strip":"🎞","telephone_receiver":"📞","phone":"☎️","telephone":"☎️","pager":"📟","fax":"📠","tv":"📺","radio":"📻","studio_microphone":"🎙","level_slider":"🎚","control_knobs":"🎛","stopwatch":"⏱","timer_clock":"⏲","alarm_clock":"⏰","mantelpiece_clock":"🕰","hourglass":"⌛️","hourglass_flowing_sand":"⏳","satellite":"📡","battery":"🔋","electric_plug":"🔌","bulb":"💡","flashlight":"🔦","candle":"🕯","wastebasket":"🗑","oil_drum":"🛢","money_with_wings":"💸","dollar":"💵","yen":"💴","euro":"💶","pound":"💷","moneybag":"💰","credit_card":"💳","gem":"💎","balance_scale":"⚖️","wrench":"🔧","hammer":"🔨","hammer_and_pick":"⚒","hammer_and_wrench":"🛠","pick":"⛏","nut_and_bolt":"🔩","gear":"⚙️","chains":"⛓","gun":"🔫","bomb":"💣","hocho":"🔪","knife":"🔪","dagger":"🗡","crossed_swords":"⚔️","shield":"🛡","smoking":"🚬","coffin":"⚰️","funeral_urn":"⚱️","amphora":"🏺","crystal_ball":"🔮","prayer_beads":"📿","barber":"💈","alembic":"⚗️","telescope":"🔭","microscope":"🔬","hole":"🕳","pill":"💊","syringe":"💉","thermometer":"🌡","toilet":"🚽","potable_water":"🚰","shower":"🚿","bathtub":"🛁","bath":"🛀","bellhop_bell":"🛎","key":"🔑","old_key":"🗝","door":"🚪","couch_and_lamp":"🛋","bed":"🛏","sleeping_bed":"🛌","framed_picture":"🖼","shopping":"🛍","shopping_cart":"🛒","gift":"🎁","balloon":"🎈","flags":"🎏","ribbon":"🎀","confetti_ball":"🎊","tada":"🎉","dolls":"🎎","izakaya_lantern":"🏮","lantern":"🏮","wind_chime":"🎐","email":"✉️","envelope":"✉️","envelope_with_arrow":"📩","incoming_envelope":"📨","e-mail":"📧","love_letter":"💌","inbox_tray":"📥","outbox_tray":"📤","package":"📦","label":"🏷","mailbox_closed":"📪","mailbox":"📫","mailbox_with_mail":"📬","mailbox_with_no_mail":"📭","postbox":"📮","postal_horn":"📯","scroll":"📜","page_with_curl":"📃","page_facing_up":"📄","bookmark_tabs":"📑","bar_chart":"📊","chart_with_upwards_trend":"📈","chart_with_downwards_trend":"📉","spiral_notepad":"🗒","spiral_calendar":"🗓","calendar":"📆","date":"📅","card_index":"📇","card_file_box":"🗃","ballot_box":"🗳","file_cabinet":"🗄","clipboard":"📋","file_folder":"📁","open_file_folder":"📂","card_index_dividers":"🗂","newspaper_roll":"🗞","newspaper":"📰","notebook":"📓","notebook_with_decorative_cover":"📔","ledger":"📒","closed_book":"📕","green_book":"📗","blue_book":"📘","orange_book":"📙","books":"📚","book":"📖","open_book":"📖","bookmark":"🔖","link":"🔗","paperclip":"📎","paperclips":"🖇","triangular_ruler":"📐","straight_ruler":"📏","pushpin":"📌","round_pushpin":"📍","scissors":"✂️","pen":"🖊","fountain_pen":"🖋","black_nib":"✒️","paintbrush":"🖌","crayon":"🖍","memo":"📝","pencil":"📝","pencil2":"✏️","mag":"🔍","mag_right":"🔎","lock_with_ink_pen":"🔏","closed_lock_with_key":"🔐","lock":"🔒","unlock":"🔓","heart":"❤️","yellow_heart":"💛","green_heart":"💚","blue_heart":"💙","purple_heart":"💜","black_heart":"🖤","broken_heart":"💔","heavy_heart_exclamation":"❣️","two_hearts":"💕","revolving_hearts":"💞","heartbeat":"💓","heartpulse":"💗","sparkling_heart":"💖","cupid":"💘","gift_heart":"💝","heart_decoration":"💟","peace_symbol":"☮️","latin_cross":"✝️","star_and_crescent":"☪️","om":"🕉","wheel_of_dharma":"☸️","star_of_david":"✡️","six_pointed_star":"🔯","menorah":"🕎","yin_yang":"☯️","orthodox_cross":"☦️","place_of_worship":"🛐","ophiuchus":"⛎","aries":"♈️","taurus":"♉️","gemini":"♊️","cancer":"♋️","leo":"♌️","virgo":"♍️","libra":"♎️","scorpius":"♏️","sagittarius":"♐️","capricorn":"♑️","aquarius":"♒️","pisces":"♓️","id":"🆔","atom_symbol":"⚛️","accept":"🉑","radioactive":"☢️","biohazard":"☣️","mobile_phone_off":"📴","vibration_mode":"📳","eight_pointed_black_star":"✴️","vs":"🆚","white_flower":"💮","ideograph_advantage":"🉐","secret":"㊙️","congratulations":"㊗️","u6e80":"🈵","a":"🅰️","b":"🅱️","ab":"🆎","cl":"🆑","o2":"🅾️","sos":"🆘","x":"❌","o":"⭕️","stop_sign":"🛑","no_entry":"⛔️","name_badge":"📛","no_entry_sign":"🚫","anger":"💢","hotsprings":"♨️","no_pedestrians":"🚷","do_not_litter":"🚯","no_bicycles":"🚳","non-potable_water":"🚱","underage":"🔞","no_mobile_phones":"📵","no_smoking":"🚭","exclamation":"❗️","heavy_exclamation_mark":"❗️","grey_exclamation":"❕","question":"❓","grey_question":"❔","bangbang":"‼️","interrobang":"⁉️","low_brightness":"🔅","high_brightness":"🔆","part_alternation_mark":"〽️","warning":"⚠️","children_crossing":"🚸","trident":"🔱","fleur_de_lis":"⚜️","beginner":"🔰","recycle":"♻️","white_check_mark":"✅","chart":"💹","sparkle":"❇️","eight_spoked_asterisk":"✳️","negative_squared_cross_mark":"❎","globe_with_meridians":"🌐","diamond_shape_with_a_dot_inside":"💠","m":"Ⓜ️","cyclone":"🌀","zzz":"💤","atm":"🏧","wc":"🚾","wheelchair":"♿️","parking":"🅿️","sa":"🈂️","passport_control":"🛂","customs":"🛃","baggage_claim":"🛄","left_luggage":"🛅","mens":"🚹","womens":"🚺","baby_symbol":"🚼","restroom":"🚻","put_litter_in_its_place":"🚮","cinema":"🎦","signal_strength":"📶","koko":"🈁","symbols":"🔣","information_source":"ℹ️","abc":"🔤","abcd":"🔡","capital_abcd":"🔠","ng":"🆖","ok":"🆗","up":"🆙","cool":"🆒","new":"🆕","free":"🆓","zero":"0️⃣","one":"1️⃣","two":"2️⃣","three":"3️⃣","four":"4️⃣","five":"5️⃣","six":"6️⃣","seven":"7️⃣","eight":"8️⃣","nine":"9️⃣","keycap_ten":"🔟","hash":"#️⃣","asterisk":"*️⃣","arrow_forward":"▶️","pause_button":"⏸","play_or_pause_button":"⏯","stop_button":"⏹","record_button":"⏺","next_track_button":"⏭","previous_track_button":"⏮","fast_forward":"⏩","rewind":"⏪","arrow_double_up":"⏫","arrow_double_down":"⏬","arrow_backward":"◀️","arrow_up_small":"🔼","arrow_down_small":"🔽","arrow_right":"➡️","arrow_left":"⬅️","arrow_up":"⬆️","arrow_down":"⬇️","arrow_upper_right":"↗️","arrow_lower_right":"↘️","arrow_lower_left":"↙️","arrow_upper_left":"↖️","arrow_up_down":"↕️","left_right_arrow":"↔️","arrow_right_hook":"↪️","leftwards_arrow_with_hook":"↩️","arrow_heading_up":"⤴️","arrow_heading_down":"⤵️","twisted_rightwards_arrows":"🔀","repeat":"🔁","repeat_one":"🔂","arrows_counterclockwise":"🔄","arrows_clockwise":"🔃","musical_note":"🎵","notes":"🎶","heavy_plus_sign":"➕","heavy_minus_sign":"➖","heavy_division_sign":"➗","heavy_multiplication_x":"✖️","heavy_dollar_sign":"💲","currency_exchange":"💱","tm":"™️","copyright":"©️","registered":"®️","wavy_dash":"〰️","curly_loop":"➰","loop":"➿","end":"🔚","back":"🔙","on":"🔛","top":"🔝","soon":"🔜","heavy_check_mark":"✔️","ballot_box_with_check":"☑️","radio_button":"🔘","white_circle":"⚪️","black_circle":"⚫️","red_circle":"🔴","large_blue_circle":"🔵","small_red_triangle":"🔺","small_red_triangle_down":"🔻","small_orange_diamond":"🔸","small_blue_diamond":"🔹","large_orange_diamond":"🔶","large_blue_diamond":"🔷","white_square_button":"🔳","black_square_button":"🔲","black_small_square":"▪️","white_small_square":"▫️","black_medium_small_square":"◾️","white_medium_small_square":"◽️","black_medium_square":"◼️","white_medium_square":"◻️","black_large_square":"⬛️","white_large_square":"⬜️","speaker":"🔈","mute":"🔇","sound":"🔉","loud_sound":"🔊","bell":"🔔","no_bell":"🔕","mega":"📣","loudspeaker":"📢","eye_speech_bubble":"👁‍🗨","speech_balloon":"💬","thought_balloon":"💭","right_anger_bubble":"🗯","spades":"♠️","clubs":"♣️","hearts":"♥️","diamonds":"♦️","black_joker":"🃏","flower_playing_cards":"🎴","mahjong":"🀄️","clock1":"🕐","clock2":"🕑","clock3":"🕒","clock4":"🕓","clock5":"🕔","clock6":"🕕","clock7":"🕖","clock8":"🕗","clock9":"🕘","clock10":"🕙","clock11":"🕚","clock12":"🕛","clock130":"🕜","clock230":"🕝","clock330":"🕞","clock430":"🕟","clock530":"🕠","clock630":"🕡","clock730":"🕢","clock830":"🕣","clock930":"🕤","clock1030":"🕥","clock1130":"🕦","clock1230":"🕧","white_flag":"🏳️","black_flag":"🏴","checkered_flag":"🏁","triangular_flag_on_post":"🚩","rainbow_flag":"🏳️‍🌈","afghanistan":"🇦🇫","aland_islands":"🇦🇽","albania":"🇦🇱","algeria":"🇩🇿","american_samoa":"🇦🇸","andorra":"🇦🇩","angola":"🇦🇴","anguilla":"🇦🇮","antarctica":"🇦🇶","antigua_barbuda":"🇦🇬","argentina":"🇦🇷","armenia":"🇦🇲","aruba":"🇦🇼","australia":"🇦🇺","austria":"🇦🇹","azerbaijan":"🇦🇿","bahamas":"🇧🇸","bahrain":"🇧🇭","bangladesh":"🇧🇩","barbados":"🇧🇧","belarus":"🇧🇾","belgium":"🇧🇪","belize":"🇧🇿","benin":"🇧🇯","bermuda":"🇧🇲","bhutan":"🇧🇹","bolivia":"🇧🇴","caribbean_netherlands":"🇧🇶","bosnia_herzegovina":"🇧🇦","botswana":"🇧🇼","brazil":"🇧🇷","british_indian_ocean_territory":"🇮🇴","british_virgin_islands":"🇻🇬","brunei":"🇧🇳","bulgaria":"🇧🇬","burkina_faso":"🇧🇫","burundi":"🇧🇮","cape_verde":"🇨🇻","cambodia":"🇰🇭","cameroon":"🇨🇲","canada":"🇨🇦","canary_islands":"🇮🇨","cayman_islands":"🇰🇾","central_african_republic":"🇨🇫","chad":"🇹🇩","chile":"🇨🇱","cn":"🇨🇳","christmas_island":"🇨🇽","cocos_islands":"🇨🇨","colombia":"🇨🇴","comoros":"🇰🇲","congo_brazzaville":"🇨🇬","congo_kinshasa":"🇨🇩","cook_islands":"🇨🇰","costa_rica":"🇨🇷","cote_divoire":"🇨🇮","croatia":"🇭🇷","cuba":"🇨🇺","curacao":"🇨🇼","cyprus":"🇨🇾","czech_republic":"🇨🇿","denmark":"🇩🇰","djibouti":"🇩🇯","dominica":"🇩🇲","dominican_republic":"🇩🇴","ecuador":"🇪🇨","egypt":"🇪🇬","el_salvador":"🇸🇻","equatorial_guinea":"🇬🇶","eritrea":"🇪🇷","estonia":"🇪🇪","ethiopia":"🇪🇹","eu":"🇪🇺","european_union":"🇪🇺","falkland_islands":"🇫🇰","faroe_islands":"🇫🇴","fiji":"🇫🇯","finland":"🇫🇮","fr":"🇫🇷","french_guiana":"🇬🇫","french_polynesia":"🇵🇫","french_southern_territories":"🇹🇫","gabon":"🇬🇦","gambia":"🇬🇲","georgia":"🇬🇪","de":"🇩🇪","ghana":"🇬🇭","gibraltar":"🇬🇮","greece":"🇬🇷","greenland":"🇬🇱","grenada":"🇬🇩","guadeloupe":"🇬🇵","guam":"🇬🇺","guatemala":"🇬🇹","guernsey":"🇬🇬","guinea":"🇬🇳","guinea_bissau":"🇬🇼","guyana":"🇬🇾","haiti":"🇭🇹","honduras":"🇭🇳","hong_kong":"🇭🇰","hungary":"🇭🇺","iceland":"🇮🇸","india":"🇮🇳","indonesia":"🇮🇩","iran":"🇮🇷","iraq":"🇮🇶","ireland":"🇮🇪","isle_of_man":"🇮🇲","israel":"🇮🇱","it":"🇮🇹","jamaica":"🇯🇲","jp":"🇯🇵","crossed_flags":"🎌","jersey":"🇯🇪","jordan":"🇯🇴","kazakhstan":"🇰🇿","kenya":"🇰🇪","kiribati":"🇰🇮","kosovo":"🇽🇰","kuwait":"🇰🇼","kyrgyzstan":"🇰🇬","laos":"🇱🇦","latvia":"🇱🇻","lebanon":"🇱🇧","lesotho":"🇱🇸","liberia":"🇱🇷","libya":"🇱🇾","liechtenstein":"🇱🇮","lithuania":"🇱🇹","luxembourg":"🇱🇺","macau":"🇲🇴","macedonia":"🇲🇰","madagascar":"🇲🇬","malawi":"🇲🇼","malaysia":"🇲🇾","maldives":"🇲🇻","mali":"🇲🇱","malta":"🇲🇹","marshall_islands":"🇲🇭","martinique":"🇲🇶","mauritania":"🇲🇷","mauritius":"🇲🇺","mayotte":"🇾🇹","mexico":"🇲🇽","micronesia":"🇫🇲","moldova":"🇲🇩","monaco":"🇲🇨","mongolia":"🇲🇳","montenegro":"🇲🇪","montserrat":"🇲🇸","morocco":"🇲🇦","mozambique":"🇲🇿","myanmar":"🇲🇲","namibia":"🇳🇦","nauru":"🇳🇷","nepal":"🇳🇵","netherlands":"🇳🇱","new_caledonia":"🇳🇨","new_zealand":"🇳🇿","nicaragua":"🇳🇮","niger":"🇳🇪","nigeria":"🇳🇬","niue":"🇳🇺","norfolk_island":"🇳🇫","northern_mariana_islands":"🇲🇵","north_korea":"🇰🇵","norway":"🇳🇴","oman":"🇴🇲","pakistan":"🇵🇰","palau":"🇵🇼","palestinian_territories":"🇵🇸","panama":"🇵🇦","papua_new_guinea":"🇵🇬","paraguay":"🇵🇾","peru":"🇵🇪","philippines":"🇵🇭","pitcairn_islands":"🇵🇳","poland":"🇵🇱","portugal":"🇵🇹","puerto_rico":"🇵🇷","qatar":"🇶🇦","reunion":"🇷🇪","romania":"🇷🇴","ru":"🇷🇺","rwanda":"🇷🇼","st_barthelemy":"🇧🇱","st_helena":"🇸🇭","st_kitts_nevis":"🇰🇳","st_lucia":"🇱🇨","st_pierre_miquelon":"🇵🇲","st_vincent_grenadines":"🇻🇨","samoa":"🇼🇸","san_marino":"🇸🇲","sao_tome_principe":"🇸🇹","saudi_arabia":"🇸🇦","senegal":"🇸🇳","serbia":"🇷🇸","seychelles":"🇸🇨","sierra_leone":"🇸🇱","singapore":"🇸🇬","sint_maarten":"🇸🇽","slovakia":"🇸🇰","slovenia":"🇸🇮","solomon_islands":"🇸🇧","somalia":"🇸🇴","south_africa":"🇿🇦","south_georgia_south_sandwich_islands":"🇬🇸","kr":"🇰🇷","south_sudan":"🇸🇸","es":"🇪🇸","sri_lanka":"🇱🇰","sudan":"🇸🇩","suriname":"🇸🇷","swaziland":"🇸🇿","sweden":"🇸🇪","switzerland":"🇨🇭","syria":"🇸🇾","taiwan":"🇹🇼","tajikistan":"🇹🇯","tanzania":"🇹🇿","thailand":"🇹🇭","timor_leste":"🇹🇱","togo":"🇹🇬","tokelau":"🇹🇰","tonga":"🇹🇴","trinidad_tobago":"🇹🇹","tunisia":"🇹🇳","tr":"🇹🇷","turkmenistan":"🇹🇲","turks_caicos_islands":"🇹🇨","tuvalu":"🇹🇻","uganda":"🇺🇬","ukraine":"🇺🇦","united_arab_emirates":"🇦🇪","gb":"🇬🇧","uk":"🇬🇧","us":"🇺🇸","us_virgin_islands":"🇻🇮","uruguay":"🇺🇾","uzbekistan":"🇺🇿","vanuatu":"🇻🇺","vatican_city":"🇻🇦","venezuela":"🇻🇪","vietnam":"🇻🇳","wallis_futuna":"🇼🇫","western_sahara":"🇪🇭","yemen":"🇾🇪","zambia":"🇿🇲","zimbabwe":"🇿🇼"}

/***/ }),

/***/ 910:
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 271,
	"./af.js": 271,
	"./ar": 278,
	"./ar-dz": 272,
	"./ar-dz.js": 272,
	"./ar-kw": 273,
	"./ar-kw.js": 273,
	"./ar-ly": 274,
	"./ar-ly.js": 274,
	"./ar-ma": 275,
	"./ar-ma.js": 275,
	"./ar-sa": 276,
	"./ar-sa.js": 276,
	"./ar-tn": 277,
	"./ar-tn.js": 277,
	"./ar.js": 278,
	"./az": 279,
	"./az.js": 279,
	"./be": 280,
	"./be.js": 280,
	"./bg": 281,
	"./bg.js": 281,
	"./bm": 282,
	"./bm.js": 282,
	"./bn": 284,
	"./bn-bd": 283,
	"./bn-bd.js": 283,
	"./bn.js": 284,
	"./bo": 285,
	"./bo.js": 285,
	"./br": 286,
	"./br.js": 286,
	"./bs": 287,
	"./bs.js": 287,
	"./ca": 288,
	"./ca.js": 288,
	"./cs": 289,
	"./cs.js": 289,
	"./cv": 290,
	"./cv.js": 290,
	"./cy": 291,
	"./cy.js": 291,
	"./da": 292,
	"./da.js": 292,
	"./de": 295,
	"./de-at": 293,
	"./de-at.js": 293,
	"./de-ch": 294,
	"./de-ch.js": 294,
	"./de.js": 295,
	"./dv": 296,
	"./dv.js": 296,
	"./el": 297,
	"./el.js": 297,
	"./en-au": 298,
	"./en-au.js": 298,
	"./en-ca": 299,
	"./en-ca.js": 299,
	"./en-gb": 300,
	"./en-gb.js": 300,
	"./en-ie": 301,
	"./en-ie.js": 301,
	"./en-il": 302,
	"./en-il.js": 302,
	"./en-in": 303,
	"./en-in.js": 303,
	"./en-nz": 304,
	"./en-nz.js": 304,
	"./en-sg": 305,
	"./en-sg.js": 305,
	"./eo": 306,
	"./eo.js": 306,
	"./es": 310,
	"./es-do": 307,
	"./es-do.js": 307,
	"./es-mx": 308,
	"./es-mx.js": 308,
	"./es-us": 309,
	"./es-us.js": 309,
	"./es.js": 310,
	"./et": 311,
	"./et.js": 311,
	"./eu": 312,
	"./eu.js": 312,
	"./fa": 313,
	"./fa.js": 313,
	"./fi": 314,
	"./fi.js": 314,
	"./fil": 315,
	"./fil.js": 315,
	"./fo": 316,
	"./fo.js": 316,
	"./fr": 319,
	"./fr-ca": 317,
	"./fr-ca.js": 317,
	"./fr-ch": 318,
	"./fr-ch.js": 318,
	"./fr.js": 319,
	"./fy": 320,
	"./fy.js": 320,
	"./ga": 321,
	"./ga.js": 321,
	"./gd": 322,
	"./gd.js": 322,
	"./gl": 323,
	"./gl.js": 323,
	"./gom-deva": 324,
	"./gom-deva.js": 324,
	"./gom-latn": 325,
	"./gom-latn.js": 325,
	"./gu": 326,
	"./gu.js": 326,
	"./he": 327,
	"./he.js": 327,
	"./hi": 328,
	"./hi.js": 328,
	"./hr": 329,
	"./hr.js": 329,
	"./hu": 330,
	"./hu.js": 330,
	"./hy-am": 331,
	"./hy-am.js": 331,
	"./id": 332,
	"./id.js": 332,
	"./is": 333,
	"./is.js": 333,
	"./it": 335,
	"./it-ch": 334,
	"./it-ch.js": 334,
	"./it.js": 335,
	"./ja": 336,
	"./ja.js": 336,
	"./jv": 337,
	"./jv.js": 337,
	"./ka": 338,
	"./ka.js": 338,
	"./kk": 339,
	"./kk.js": 339,
	"./km": 340,
	"./km.js": 340,
	"./kn": 341,
	"./kn.js": 341,
	"./ko": 342,
	"./ko.js": 342,
	"./ku": 343,
	"./ku.js": 343,
	"./ky": 344,
	"./ky.js": 344,
	"./lb": 345,
	"./lb.js": 345,
	"./lo": 346,
	"./lo.js": 346,
	"./lt": 347,
	"./lt.js": 347,
	"./lv": 348,
	"./lv.js": 348,
	"./me": 349,
	"./me.js": 349,
	"./mi": 350,
	"./mi.js": 350,
	"./mk": 351,
	"./mk.js": 351,
	"./ml": 352,
	"./ml.js": 352,
	"./mn": 353,
	"./mn.js": 353,
	"./mr": 354,
	"./mr.js": 354,
	"./ms": 356,
	"./ms-my": 355,
	"./ms-my.js": 355,
	"./ms.js": 356,
	"./mt": 357,
	"./mt.js": 357,
	"./my": 358,
	"./my.js": 358,
	"./nb": 359,
	"./nb.js": 359,
	"./ne": 360,
	"./ne.js": 360,
	"./nl": 362,
	"./nl-be": 361,
	"./nl-be.js": 361,
	"./nl.js": 362,
	"./nn": 363,
	"./nn.js": 363,
	"./oc-lnc": 364,
	"./oc-lnc.js": 364,
	"./pa-in": 365,
	"./pa-in.js": 365,
	"./pl": 366,
	"./pl.js": 366,
	"./pt": 368,
	"./pt-br": 367,
	"./pt-br.js": 367,
	"./pt.js": 368,
	"./ro": 369,
	"./ro.js": 369,
	"./ru": 370,
	"./ru.js": 370,
	"./sd": 371,
	"./sd.js": 371,
	"./se": 372,
	"./se.js": 372,
	"./si": 373,
	"./si.js": 373,
	"./sk": 374,
	"./sk.js": 374,
	"./sl": 375,
	"./sl.js": 375,
	"./sq": 376,
	"./sq.js": 376,
	"./sr": 378,
	"./sr-cyrl": 377,
	"./sr-cyrl.js": 377,
	"./sr.js": 378,
	"./ss": 379,
	"./ss.js": 379,
	"./sv": 380,
	"./sv.js": 380,
	"./sw": 381,
	"./sw.js": 381,
	"./ta": 382,
	"./ta.js": 382,
	"./te": 383,
	"./te.js": 383,
	"./tet": 384,
	"./tet.js": 384,
	"./tg": 385,
	"./tg.js": 385,
	"./th": 386,
	"./th.js": 386,
	"./tk": 387,
	"./tk.js": 387,
	"./tl-ph": 388,
	"./tl-ph.js": 388,
	"./tlh": 389,
	"./tlh.js": 389,
	"./tr": 390,
	"./tr.js": 390,
	"./tzl": 391,
	"./tzl.js": 391,
	"./tzm": 393,
	"./tzm-latn": 392,
	"./tzm-latn.js": 392,
	"./tzm.js": 393,
	"./ug-cn": 394,
	"./ug-cn.js": 394,
	"./uk": 395,
	"./uk.js": 395,
	"./ur": 396,
	"./ur.js": 396,
	"./uz": 398,
	"./uz-latn": 397,
	"./uz-latn.js": 397,
	"./uz.js": 398,
	"./vi": 399,
	"./vi.js": 399,
	"./x-pseudo": 400,
	"./x-pseudo.js": 400,
	"./yo": 401,
	"./yo.js": 401,
	"./zh-cn": 402,
	"./zh-cn.js": 402,
	"./zh-hk": 403,
	"./zh-hk.js": 403,
	"./zh-mo": 404,
	"./zh-mo.js": 404,
	"./zh-tw": 405,
	"./zh-tw.js": 405
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 910;

/***/ }),

/***/ 936:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(802)
}
var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(492),
  /* template */
  __webpack_require__(966),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 937:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(823)
}
var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(493),
  /* template */
  __webpack_require__(987),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 938:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(825)
}
var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(494),
  /* template */
  __webpack_require__(989),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 939:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(814)
}
var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(496),
  /* template */
  __webpack_require__(978),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 940:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(817)
}
var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(497),
  /* template */
  __webpack_require__(981),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 941:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(805)
}
var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(500),
  /* template */
  __webpack_require__(969),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 942:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(824)
}
var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(501),
  /* template */
  __webpack_require__(988),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 943:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(799)
}
var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(502),
  /* template */
  __webpack_require__(962),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 944:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(819)
}
var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(504),
  /* template */
  __webpack_require__(983),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-7e1ff346",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 945:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(806)
}
var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(505),
  /* template */
  __webpack_require__(970),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 946:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(803)
}
var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(506),
  /* template */
  __webpack_require__(967),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 947:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(812)
}
var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(507),
  /* template */
  __webpack_require__(976),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 948:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(820)
}
var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(509),
  /* template */
  __webpack_require__(984),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 949:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(798)
}
var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(510),
  /* template */
  __webpack_require__(961),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 950:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(807)
}
var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(511),
  /* template */
  __webpack_require__(971),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 951:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(809)
}
var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(512),
  /* template */
  __webpack_require__(973),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 952:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(801)
}
var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(513),
  /* template */
  __webpack_require__(965),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 953:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(808)
}
var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(514),
  /* template */
  __webpack_require__(972),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 954:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(810)
}
var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(515),
  /* template */
  __webpack_require__(974),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 955:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(816)
}
var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(516),
  /* template */
  __webpack_require__(980),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 956:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(815)
}
var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(517),
  /* template */
  __webpack_require__(979),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 957:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(822)
}
var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(518),
  /* template */
  __webpack_require__(986),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 958:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(826)
}
var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(519),
  /* template */
  __webpack_require__(990),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 959:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(813)
}
var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(490),
  /* template */
  __webpack_require__(977),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 960:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "div-container container",
    class: [{
      'is-fluid': _vm.full === 'true'
    }],
    style: ([{
      paddingTop: (_vm.paddingTop ? _vm.paddingTop : undefined),
      paddingBottom: (_vm.paddingBottom ? _vm.paddingBottom : undefined)
    }])
  }, [_c('div', {
    staticClass: "columns is-gapless is-centered is-vcentered"
  }, [_c('div', {
    staticClass: "column",
    class: [{
      'is-10': _vm.full !== 'true' && !_vm.columnNum
    }, _vm.columnNum]
  }, [_vm._t("default")], 2)])])
},staticRenderFns: []}

/***/ }),

/***/ 961:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page page-about container is-fluid"
  }, [_c('div', {
    staticClass: "container container-inner"
  }, [_c('div', {
    staticClass: "columns is-gapless is-multiline"
  }, [(_vm.note && _vm.about) ? _c('div', {
    staticClass: "column content",
    staticStyle: {
      "margin-top": "0",
      "padding-top": "0"
    },
    attrs: {
      "data-aos": "fade-up",
      "data-aos-once": "true"
    }
  }, [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": _vm.about.image ? _vm.about.image.path : ''
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "box note color-gray-lighter-bg is-hidden-mobile"
  }, [(_vm.note.content) ? _c('markdown', {
    attrs: {
      "source": _vm.note.content
    }
  }) : _vm._e()], 1)]) : _vm._e(), _vm._v(" "), (_vm.about) ? _c('div', {
    staticClass: "column content content-main is-left",
    attrs: {
      "data-aos": "fade-up",
      "data-aos-once": "true",
      "data-aos-delay": "300"
    }
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n          " + _vm._s(_vm.about.title) + "\n        ")]), _vm._v(" "), (_vm.about.content) ? _c('markdown', {
    attrs: {
      "source": _vm.about.content
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.note) ? _c('div', {
    staticClass: "column content is-hidden-tablet",
    staticStyle: {
      "margin-bottom": "0"
    },
    attrs: {
      "data-aos": "fade-up",
      "data-aos-once": "true"
    }
  }, [_c('div', {
    staticClass: "box note color-gray-lighter-bg"
  }, [(_vm.note.content) ? _c('markdown', {
    attrs: {
      "source": _vm.note.content
    }
  }) : _vm._e()], 1)]) : _vm._e()])])])
},staticRenderFns: []}

/***/ }),

/***/ 962:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container masonry-youtube",
    attrs: {
      "id": "masonry-youtube"
    }
  }, [_c('div', {
    staticClass: "columns is-gapless is-centered"
  }, [_c('div', {
    staticClass: "column is-10"
  }, [(false) ? _c('h1', {
    staticClass: "title"
  }, [_vm._v("\n        Videos\n      ")]) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "masonry",
      rawName: "v-masonry"
    }, {
      name: "infinite-scroll",
      rawName: "v-infinite-scroll",
      value: (_vm.loadMore),
      expression: "loadMore"
    }],
    staticClass: "masonry-container",
    attrs: {
      "id": "masonry-container",
      "transition-duration": "0.0s",
      "item-selector": ".masonry-item",
      "data-masonry-options": "{ 'isFitWidth': true }",
      "infinite-scroll-disabled": "itemsLoading",
      "infinite-scroll-distance": "10"
    }
  }, _vm._l((_vm.items), function(item, index) {
    return _c('div', {
      directives: [{
        name: "masonry-tile",
        rawName: "v-masonry-tile"
      }],
      staticClass: "masonry-item",
      attrs: {
        "data-aos": "slide-up",
        "data-aos-once": "true",
        "data-aos-duration": "1000",
        "data-aos-offset": "0"
      }
    }, [_c('a', {
      attrs: {
        "href": 'http://www.youtube.com/watch?v=' + item.snippet.resourceId.videoId,
        "target": "_blank"
      }
    }, [_c('div', {
      staticClass: "card"
    }, [_c('div', {
      staticClass: "card-image"
    }, [_c('figure', {
      staticClass: "image",
      staticStyle: {
        "position": "relative"
      }
    }, [_c('img', {
      attrs: {
        "src": _vm.parseInstagramImageLink(item.snippet.thumbnails.high.url),
        "alt": "Image"
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "card-image-cover"
    }, [_c('i', {
      staticClass: "fa fa-4x fa-play"
    }), _vm._v(" "), _c('div', {
      staticClass: "card-image-cover-description"
    }, [_vm._v("\n                      " + _vm._s(item.snippet.title) + "\n                    ")])])])])])])])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "load-more"
  }, [(!_vm.itemsEnded) ? _c('div', {
    staticClass: "button",
    class: {
      'is-loading': _vm.itemsLoading
    },
    on: {
      "click": function($event) {
        return _vm.loadMore()
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.itemsEnded) ? _c('div', {
    staticClass: "ended",
    attrs: {
      "data-aos": "slide-up",
      "data-aos-once": "true",
      "data-aos-duration": "1000"
    }
  }, [_vm._v("More videos:"), _c('br', {
    staticClass: "is-hidden-desktop"
  }), _vm._v("  "), _vm._m(0)]) : _vm._e()]), _vm._v(" "), (_vm.error) ? _c('div', {
    staticClass: "control notification is-danger"
  }, [_c('button', {
    staticClass: "delete",
    on: {
      "click": function($event) {
        _vm.error = undefined
      }
    }
  }), _vm._v("\n        " + _vm._s(_vm.error) + "\n      ")]) : _vm._e()])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "https://www.youtube.com/user/nadeemadamlobo/videos",
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-2x fa-youtube",
    staticStyle: {
      "vertical-align": "middle"
    }
  }), _vm._v(" / ADAMLOBOTV")])
}]}

/***/ }),

/***/ 963:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "field form-input"
  }, [(false) ? _c('label', {
    staticClass: "label"
  }, [_vm._v(_vm._s(_vm.placeholder))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "control has-icon has-icon-right"
  }, [(_vm.type === 'email') ? _c('input', {
    staticClass: "input",
    class: [_vm.name + '-input', {
      'is-danger': _vm.error && _vm.error.length > 0
    }],
    attrs: {
      "type": "email",
      "name": _vm.name,
      "placeholder": _vm.placeholder,
      "required": _vm.required,
      "disabled": _vm.disabled,
      "autofocus": _vm.autofocus
    },
    domProps: {
      "value": _vm.value
    },
    on: {
      "input": _vm.onInput
    }
  }) : (_vm.type === 'password') ? _c('input', {
    staticClass: "input",
    class: [_vm.name + '-input', {
      'is-danger': _vm.error && _vm.error.length > 0
    }],
    attrs: {
      "type": "password",
      "name": _vm.name,
      "placeholder": _vm.placeholder,
      "required": _vm.required,
      "disabled": _vm.disabled,
      "autofocus": _vm.autofocus
    },
    domProps: {
      "value": _vm.value
    },
    on: {
      "input": _vm.onInput
    }
  }) : _c('input', {
    staticClass: "input",
    class: [_vm.name + '-input', {
      'is-danger': _vm.error && _vm.error.length > 0
    }],
    attrs: {
      "type": "text",
      "name": _vm.name,
      "placeholder": _vm.placeholder,
      "required": _vm.required,
      "disabled": _vm.disabled,
      "autofocus": _vm.autofocus
    },
    domProps: {
      "value": _vm.value
    },
    on: {
      "input": _vm.onInput
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "icon"
  }, [(false) ? _c('i', {
    staticClass: "fa",
    class: ['fa-' + _vm.fa],
    attrs: {
      "name": _vm.fa
    }
  }) : _vm._e(), _vm._v(" "), (_vm.mdi !== undefined) ? _c('i', {
    staticClass: "material-icons"
  }, [_vm._v(_vm._s(_vm.mdi))]) : _vm._e()]), _vm._v(" "), (_vm.error && _vm.error.length > 0) ? _c('form-error', {
    attrs: {
      "error": _vm.error
    }
  }) : _vm._e()], 1)])
},staticRenderFns: []}

/***/ }),

/***/ 964:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "disqus_thread"
    }
  })
},staticRenderFns: []}

/***/ }),

/***/ 965:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page page-links container is-fluid"
  }, [_c('div', {
    staticClass: "container container-inner"
  }, [_c('div', {
    staticClass: "columns is-gapless is-multiline"
  }, [(_vm.linksdata) ? _c('div', {
    staticClass: "column content is-hidden-tablet",
    staticStyle: {
      "margin-top": "0",
      "padding-top": "0"
    },
    attrs: {
      "data-aos": "fade-up",
      "data-aos-once": "true"
    }
  }, [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": _vm.linksdata.image ? _vm.linksdata.image.path : ''
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.linksdata) ? _c('div', {
    staticClass: "column content content-main is-right",
    attrs: {
      "data-aos": "fade-up",
      "data-aos-once": "true",
      "data-aos-delay": "300"
    }
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n          " + _vm._s(_vm.linksdata.title) + "\n        ")]), _vm._v(" "), (_vm.linksdata.content) ? _c('markdown', {
    staticStyle: {
      "margin-bottom": "30px"
    },
    attrs: {
      "source": _vm.linksdata.content
    }
  }) : _vm._e(), _vm._v(" "), _vm._l((_vm.links), function(link, index) {
    return _c('p', {
      key: ("" + index)
    }, [_c('a', {
      attrs: {
        "href": link.link,
        "target": "_blank"
      }
    }, [_vm._v("\n            " + _vm._s(link.title) + " "), _c('i', {
      staticClass: "fa fa-external-link"
    })])])
  })], 2) : _vm._e(), _vm._v(" "), (_vm.linksdata) ? _c('div', {
    staticClass: "column content",
    staticStyle: {
      "margin-top": "0",
      "padding-top": "0"
    },
    attrs: {
      "data-aos": "fade-up",
      "data-aos-once": "true"
    }
  }, [_c('img', {
    staticClass: "img-responsive is-hidden-mobile",
    attrs: {
      "src": _vm.linksdata.image ? _vm.linksdata.image.path : ''
    }
  })]) : _vm._e()])])])
},staticRenderFns: []}

/***/ }),

/***/ 966:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container section-about",
    attrs: {
      "id": "section-about",
      "data-aos": "fade-up",
      "data-aos-once": "true"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "columns is-gapless is-centered"
  }, [_c('div', {
    staticClass: "column is-7 has-text-centered",
    domProps: {
      "innerHTML": _vm._s(_vm.paragraph.content)
    }
  })])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "columns is-gapless is-centered"
  }, [_c('div', {
    staticClass: "column has-text-centered"
  }, [_c('img', {
    staticStyle: {
      "width": "50px"
    },
    attrs: {
      "src": __webpack_require__(124),
      "width": "50"
    }
  })])])
}]}

/***/ }),

/***/ 967:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-subheader",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('div-container', {
    staticClass: "has-text-centered",
    attrs: {
      "padding-top": "0rem",
      "padding-bottom": "0rem"
    }
  }, [_c('div', {
    staticClass: "columns is-gapless is-centered is-flex-mobile is-vcentered"
  }, [_c('div', {
    staticClass: "column is-11 wrapper",
    class: [{
      'has-text-left': !_vm.textAlign || _vm.textAlign === 'left',
      'has-text-centered': _vm.textAlign === 'center',
      'has-text-right': _vm.textAlign === 'right'
    }]
  }, [_c('h1', {
    style: (_vm.titleStyle)
  }, [_vm._v(_vm._s(_vm.title))])])])])], 1)
},staticRenderFns: []}

/***/ }),

/***/ 968:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "navbar-wrapper",
    class: [_vm.$route.name !== 'landing' ? 'not-landing' : ''],
    attrs: {
      "id": "navse",
      "data-aos": "fade-in",
      "data-aos-once": "true"
    }
  }, [(_vm.phone && _vm.fax && _vm.address) ? _c('div', {
    staticClass: "container navbar-row first is-fluid",
    staticStyle: {
      "margin-left": "0",
      "margin-right": "0"
    },
    attrs: {
      "data-aos": "fade-in",
      "data-aos-once": "true"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "columns navbar-full first is-gapless is-mobile"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "column column-link is-hidden-mobile has-text-right"
  }, [(_vm.phone && _vm.fax) ? _c('div', {
    staticClass: "call font-bold",
    staticStyle: {
      "font-size": "1.2em"
    }
  }, [_vm._v("\n            Call: " + _vm._s(_vm.phone) + "   Fax: " + _vm._s(_vm.fax) + "\n          ")]) : _vm._e(), _vm._v(" "), (_vm.address) ? _c('div', {
    staticClass: "address"
  }, [_vm._v("\n            " + _vm._s(_vm.address) + "\n          ")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "column is-narrow navbar-menu",
    attrs: {
      "data-aos": "zoom-in",
      "data-aos-once": "true"
    },
    on: {
      "click": function($event) {
        return _vm.onToggle()
      }
    }
  }, [_c('div', {
    staticClass: "control-menu",
    class: {
      active: _vm.showNav
    }
  }, [_c('span')])])])])]) : _c('div', {
    staticStyle: {
      "height": "120px"
    }
  }, [_vm._v("\n     \n  ")]), _vm._v(" "), _c('div', {
    staticClass: "container navbar-row second is-fluid",
    staticStyle: {
      "margin-left": "0",
      "margin-right": "0"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "columns navbar-full second is-gapless is-mobile is-hidden-mobile",
    staticStyle: {
      "overflow": "hidden"
    }
  }, _vm._l((_vm.navItems), function(nav, index) {
    return _c('div', {
      key: nav.name,
      staticClass: "column column-link is-hidden-mobile",
      class: {
        /* 'has-text-left': index === 0, */
        'has-text-centered': true, // index !== 0 && index !== (navItems.length - 1),
        /* 'has-text-right': index === (navItems.length - 1), */
        'is-active': _vm.$route.name === nav.name
      }
    }, [_c('a', {
      attrs: {
        "href": ("" + (nav.path))
      }
    }, [_vm._v("\n            " + _vm._s(nav.label) + "\n          ")])])
  }), 0)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "column navbar-brand",
    attrs: {
      "align": "left"
    }
  }, [_c('a', {
    staticClass: "navbar-logo",
    attrs: {
      "href": "/"
    }
  }, [_c('img', {
    staticClass: "img-responsive logo-1",
    attrs: {
      "src": __webpack_require__(124),
      "width": "85"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "img-responsive logo-2 is-hidden-mobile",
    attrs: {
      "src": __webpack_require__(183),
      "width": "360"
    }
  })])])
}]}

/***/ }),

/***/ 969:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gallery-container",
    attrs: {
      "id": "gallery-container"
    }
  }, [_c('div', {
    directives: [{
      name: "infinite-scroll",
      rawName: "v-infinite-scroll",
      value: (_vm.loadMore),
      expression: "loadMore"
    }],
    staticClass: "masonry-container columns is-gapless is-centered is-multiline is-flex-mobile",
    attrs: {
      "id": "masonry-container",
      "infinite-scroll-disabled": "itemsLoading",
      "infinite-scroll-distance": "-1"
    }
  }, _vm._l((_vm.items), function(image, index) {
    return (index !== 8 || _vm.isDesktop) ? _c('div', {
      staticClass: "column is-4 is-6-mobile",
      attrs: {
        "data-aos": "fade-up",
        "data-aos-once": "true"
      }
    }, [_c('a', {
      attrs: {
        "href": image.link,
        "target": "_blank"
      }
    }, [_c('div', {
      staticClass: "focus-image-wrapper"
    }, [_c('figure', {
      staticClass: "image square",
      style: ([{
        'background-image': 'url(' + image.images.standard_resolution.url + ')'
      }])
    })])])]) : _vm._e()
  }), 0), _vm._v(" "), (_vm.error) ? _c('div', {
    staticClass: "control notification is-danger"
  }, [_c('button', {
    staticClass: "delete",
    on: {
      "click": function($event) {
        _vm.error = undefined
      }
    }
  }), _vm._v(" "), _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.error)
    }
  })]) : _vm._e()])
},staticRenderFns: []}

/***/ }),

/***/ 970:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "section-newsletter",
    attrs: {
      "id": "section-newsletter"
    }
  }, [_c('div', {
    staticClass: "columns is-gapless is-flex-mobile is-centered"
  }, [_c('div', {
    staticClass: "column is-8 is-11-mobile"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "columns is-gapless is-multiline"
  }, [_c('div', {
    staticClass: "column is-6"
  }, [_c('div', {
    staticClass: "cont-form cont-form-info",
    attrs: {
      "data-aos": "fade-up",
      "data-aos-once": "true"
    }
  }, [_c('b-field', [_c('b-input', {
    attrs: {
      "value": "",
      "placeholder": "NAME"
    },
    on: {
      "input": function($event) {
        return _vm.$v.name.$touch()
      }
    },
    model: {
      value: (_vm.name),
      callback: function($$v) {
        _vm.name = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "name"
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "column is-6"
  }, [_c('div', {
    staticClass: "cont-form cont-form-message",
    attrs: {
      "data-aos": "fade-up",
      "data-aos-once": "true"
    }
  }, [_c('b-field', [_c('b-input', {
    attrs: {
      "value": "",
      "placeholder": "EMAIL"
    },
    on: {
      "input": function($event) {
        return _vm.$v.email.$touch()
      }
    },
    model: {
      value: (_vm.email),
      callback: function($$v) {
        _vm.email = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "email"
    }
  })], 1), _vm._v(" "), _c('button', {
    staticClass: "button submit is-outlined",
    class: {
      'is-loading': _vm.loading
    },
    on: {
      "click": function($event) {
        return _vm.onSend(_vm.$v)
      }
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.loading ? ' ' : 'SUBSCRIBE'))])]), _vm._v(" "), (_vm.feedback) ? _c('p', [_vm._v(_vm._s(_vm.feedback))]) : _vm._e()], 1)])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "columns is-gapless is-centered is-multiline"
  }, [_c('div', {
    staticClass: "column is-6 has-text-centered"
  }, [_c('div', {
    staticClass: "cont-desc",
    attrs: {
      "data-aos": "fade-up",
      "data-aos-once": "true"
    }
  }, [_c('img', {
    staticClass: "img-responsive",
    staticStyle: {
      "width": "50px"
    },
    attrs: {
      "src": __webpack_require__(124),
      "width": "50"
    }
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "columns is-gapless is-centered is-multiline"
  }, [_c('div', {
    staticClass: "column is-6 has-text-centered"
  }, [_c('div', {
    staticClass: "cont-desc",
    attrs: {
      "data-aos": "fade-up",
      "data-aos-once": "true"
    }
  }, [_c('h3', {
    staticClass: "title",
    staticStyle: {
      "font-size": "1.8em"
    }
  }, [_vm._v("Mailing List")]), _vm._v(" "), _c('span', [_vm._v("Stay up to date! Never miss an unforgettable 'Live In Concert' experience by RKOK Live. Subscribe to receive emails on our next big show.")])])])])
}]}

/***/ }),

/***/ 971:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page page-faq container is-fluid"
  }, [_c('div', {
    staticClass: "container container-inner"
  }, [_c('div', {
    staticClass: "columns is-gapless is-multiline"
  }, [(_vm.faqdata) ? _c('div', {
    staticClass: "column content content-main is-right",
    attrs: {
      "data-aos": "fade-up",
      "data-aos-once": "true",
      "data-aos-delay": "300"
    }
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n          " + _vm._s(_vm.faqdata.title) + "\n        ")]), _vm._v(" "), _c('ul', {
    staticClass: "list",
    staticStyle: {
      "list-style": "none",
      "margin-left": "0",
      "margin-top": "45px"
    }
  }, _vm._l((_vm.faqs), function(faq, index) {
    return _c('li', {
      key: ("" + index)
    }, [_c('div', {
      staticClass: "subtitle minimal-margin"
    }, [_vm._v("\n              " + _vm._s(faq.title) + "\n            ")]), _vm._v(" "), (faq.content) ? _c('markdown', {
      attrs: {
        "source": faq.content
      }
    }) : _vm._e()], 1)
  }), 0)]) : _vm._e()])])])
},staticRenderFns: []}

/***/ }),

/***/ 972:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container page-notfound"
  }, [_c('div', {
    staticClass: "hero is-medium is-primary"
  }, [_c('div', {
    staticClass: "hero-body content"
  }, [_c('div', {
    staticStyle: {
      "padding": "30px"
    }
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v("\n          Uh oh\n        ")]), _vm._v(" "), _c('h2', {
    staticClass: "subtitle"
  }, [_vm._v("\n          Page Not Found\n        ")])])])])])
}]}

/***/ }),

/***/ 973:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "scroll-spy",
      rawName: "v-scroll-spy",
      value: (_vm.scrollPos),
      expression: "scrollPos"
    }],
    staticClass: "page page-landing"
  }, [(_vm.banner) ? _c('div', {
    staticClass: "columns is-gapless is-multiline",
    attrs: {
      "data-aos": "fade-up",
      "data-aos-once": "true"
    }
  }, [_c('div', {
    staticClass: "column is-12"
  }, [_c('div', {
    staticClass: "top-image-wrapper is-hidden-mobile",
    style: ({
      backgroundImage: ("url(" + (_vm.banner.image ? _vm.banner.image.path : '') + ")")
    })
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "vcentered banner",
    attrs: {
      "data-aos": "fade-right",
      "data-aos-once": "true"
    }
  }, [(_vm.banner.content) ? _c('markdown', {
    attrs: {
      "source": _vm.banner.content
    }
  }) : _vm._e()], 1)])]), _vm._v(" "), _c('img', {
    staticClass: "img-responsive is-hidden-tablet",
    staticStyle: {
      "display": "block"
    },
    attrs: {
      "src": _vm.banner.image_mobile && _vm.banner.image_mobile.path
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "top-image-wrapper is-hidden-tablet"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "vcentered banner",
    attrs: {
      "data-aos": "fade-right",
      "data-aos-once": "true"
    }
  }, [(_vm.banner && _vm.banner.content) ? _c('markdown', {
    attrs: {
      "source": _vm.banner.content
    }
  }) : _vm._e()], 1)])])])]) : _vm._e(), _vm._v(" "), (_vm.statement && _vm.contacts) ? _c('div', {
    staticClass: "container",
    attrs: {
      "data-aos": "fade-up",
      "data-aos-once": "true",
      "data-aos-delay": "300"
    }
  }, [_c('div', {
    staticClass: "columns is-gapless content"
  }, [_c('div', {
    staticClass: "column is-12 extra-padded"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-6"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n              " + _vm._s(_vm.statement.title) + "\n            ")]), _vm._v(" "), (_vm.statement.content) ? _c('markdown', {
    attrs: {
      "source": _vm.statement.content
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "column is-6"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n              " + _vm._s(_vm.contacts.title) + "\n            ")]), _vm._v(" "), (_vm.contacts.content) ? _c('markdown', {
    attrs: {
      "source": _vm.contacts.content
    }
  }) : _vm._e()], 1)])])])]) : _vm._e(), _vm._v(" "), (_vm.note) ? _c('div', {
    staticClass: "container note color-blue color-yellow-bg",
    staticStyle: {
      "margin-top": "30px",
      "margin-bottom": "50px"
    },
    attrs: {
      "data-aos": "fade-right",
      "data-aos-once": "true"
    }
  }, [_c('div', {
    staticClass: "columns is-gapless"
  }, [_c('div', {
    staticClass: "column is-12 smessage",
    staticStyle: {
      "padding": "30px"
    }
  }, [(_vm.note.content) ? _c('markdown', {
    attrs: {
      "source": _vm.note.content
    }
  }) : _vm._e()], 1)])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "container is-fluid color-gray-lighter-bg",
    staticStyle: {
      "padding-top": "15px",
      "padding-bottom": "45px",
      "margin-left": "0",
      "margin-right": "0"
    }
  }, [_c('div', {
    staticClass: "container content"
  }, [_c('div', {
    staticClass: "columns has-text-centered"
  }, _vm._l((_vm.hotlinks), function(hotlink, index) {
    return _c('div', {
      key: ("" + (hotlink.id)),
      staticClass: "column is-4",
      attrs: {
        "data-aos": "fade-up",
        "data-aos-once": "true",
        "data-aos-delay": (index + 1) * 200
      }
    }, [_c('a', {
      attrs: {
        "href": ("" + (hotlink.route))
      }
    }, [_c('img', {
      staticClass: "img-responsive",
      attrs: {
        "src": hotlink.image ? hotlink.image.path : ''
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "title tight margin-top"
    }, [_vm._v("\n              " + _vm._s(hotlink.title) + "\n            ")]), _vm._v(" "), _c('div', {
      staticClass: "text tight margin-top"
    }, [_vm._v("\n              " + _vm._s(hotlink.content) + "\n            ")])])])
  }), 0)])]), _vm._v(" "), (_vm.testimonials) ? _c('div', {
    staticClass: "slick-wrapper",
    attrs: {
      "data-aos": "fade-in",
      "data-aos-once": "true"
    }
  }, [_c('slick', {
    ref: "slick",
    attrs: {
      "options": _vm.slickOptions
    }
  }, _vm._l((_vm.testimonials), function(item, index) {
    return _c('div', {
      key: ("" + (item.id)),
      staticClass: "item-wrapper",
      attrs: {
        "caption": item.title
      }
    }, [_c('div', {
      staticClass: "container is-fluid",
      staticStyle: {
        "padding-top": "30px",
        "padding-bottom": "30px",
        "margin-left": "0",
        "margin-right": "0"
      }
    }, [_c('div', {
      staticClass: "container content"
    }, [_c('div', {
      staticClass: "columns is-centered has-text-centered"
    }, [_c('div', {
      staticClass: "column is-7"
    }, [_c('div', {
      staticClass: "title tight margin-top"
    }, [_vm._v("\n                  " + _vm._s(item.title) + "\n                ")]), _vm._v(" "), _c('div', {
      staticClass: "text tight margin-top"
    }, [_vm._v("\n                  " + _vm._s(item.content) + "\n                ")]), _vm._v(" "), _c('div', {
      staticClass: "subtitle margin-top"
    }, [_vm._v("\n                  " + _vm._s(item.link) + "\n                ")])])])])])])
  }), 0)], 1) : _vm._e(), _vm._v(" "), _c('main-dialog', {
    attrs: {
      "visible": _vm.dialogVisible,
      "data": _vm.message || {}
    },
    on: {
      "onClose": _vm.onCloseDialog
    }
  }), _vm._v(" "), (false) ? _c('vm-back-top', {
    attrs: {
      "bottom": 45,
      "right": 25,
      "duration": 1000,
      "timing": 'ease'
    }
  }, [_c('div', {
    staticClass: "top"
  }, [_c('span')])]) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),

/***/ 974:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page page-services container is-fluid"
  }, [_c('div', {
    staticClass: "container container-inner"
  }, [_c('div', {
    staticClass: "columns is-gapless is-multiline"
  }, [(_vm.services) ? _c('div', {
    staticClass: "column content is-hidden-tablet",
    staticStyle: {
      "margin-top": "0",
      "padding-top": "0"
    },
    attrs: {
      "data-aos": "fade-up",
      "data-aos-once": "true"
    }
  }, [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": _vm.services.image ? _vm.services.image.path : ''
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.services) ? _c('div', {
    staticClass: "column content content-main is-right",
    attrs: {
      "data-aos": "fade-up",
      "data-aos-once": "true",
      "data-aos-delay": "300"
    }
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n          " + _vm._s(_vm.services.title) + "\n        ")]), _vm._v(" "), (_vm.services.content) ? _c('markdown', {
    attrs: {
      "source": _vm.services.content
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.services && _vm.note) ? _c('div', {
    staticClass: "column content",
    staticStyle: {
      "margin-top": "0",
      "padding-top": "0"
    },
    attrs: {
      "data-aos": "fade-up",
      "data-aos-once": "true"
    }
  }, [_c('img', {
    staticClass: "img-responsive is-hidden-mobile",
    attrs: {
      "src": _vm.services.image ? _vm.services.image.path : ''
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "box color-gray-lighter-bg"
  }, [(_vm.note.content) ? _c('markdown', {
    attrs: {
      "source": _vm.note.content
    }
  }) : _vm._e()], 1)]) : _vm._e()])])])
},staticRenderFns: []}

/***/ }),

/***/ 975:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "side-bar"
  }, [_c('aside', {
    staticClass: "menu"
  }, [_c('p', {
    staticClass: "menu-label"
  }, [_vm._v("\n      Admin\n    ")]), _vm._v(" "), _c('ul', {
    staticClass: "menu-list"
  }, [_c('li', [_c('router-link', {
    class: {
      'is-active': _vm.$route.name === 'dashboard'
    },
    attrs: {
      "to": "dashboard"
    }
  }, [_vm._v("Dashboard")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    class: {
      'is-active': _vm.$route.name === 'users'
    },
    attrs: {
      "to": "users"
    }
  }, [_vm._v("Users")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    class: {
      'is-active': _vm.$route.name === 'projects'
    },
    attrs: {
      "to": "projects"
    }
  }, [_vm._v("Projects")])], 1)]), _vm._v(" "), _c('p', {
    staticClass: "menu-label"
  }, [_vm._v("\n      Debug\n    ")]), _vm._v(" "), _c('ul', {
    staticClass: "menu-list"
  }, [_c('li', [_c('router-link', {
    class: {
      'is-active': _vm.$route.name === 'blogs'
    },
    attrs: {
      "to": "blogs"
    }
  }, [_vm._v("Blogs")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    class: {
      'is-active': _vm.$route.name === 'components'
    },
    attrs: {
      "to": "components"
    }
  }, [_vm._v("Components")])], 1)])])])
},staticRenderFns: []}

/***/ }),

/***/ 976:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.shows && _vm.shows.length > 0) ? _c('div', {
    staticClass: "container-fluid section-show"
  }, [_c('div', {
    staticClass: "columns show-wrapper-outer is-gapless is-flex-mobile is-multiline",
    class: [{
      'is-centered': (_vm.shows && _vm.shows.length == 1)
    }]
  }, _vm._l((_vm.shows), function(show, index) {
    return _c('div', {
      staticClass: "column show-wrapper has-text-centered",
      class: {
        'is-6': _vm.split === 2,
        'is-4': _vm.split === 3,
        'is-half-mobile': _vm.type === 'previous',
        'is-half-mobile': _vm.type === 'upcoming'
      },
      attrs: {
        "data-aos": "fade-up",
        "data-aos-once": "true",
        "data-aos-delay": ((index % (_vm.isDesktop ? _vm.split : 2)) * 300)
      }
    }, [(!show.isMore) ? _c('div', {
      staticClass: "show-content"
    }, [_c('div', {
      staticClass: "focus-image-wrapper show-image-wrapper"
    }, [_c('a', {
      staticStyle: {
        "cursor": "auto"
      },
      attrs: {
        "href": ''
      },
      on: {
        "click": function($event) {
          return $event.preventDefault()
        }
      }
    }, [_c('img', {
      staticClass: "image square img-responsive",
      style: ([{
        'background-image': 'url(' + show.image.path + ')'
      }])
    }), _vm._v(" "), _c('div', {
      staticClass: "show-text-overlay"
    }, [_c('div', {
      staticClass: "show-text-wrapper"
    }, [_c('span', {
      staticClass: "title"
    }, [_vm._v(_vm._s(show.title))]), _c('br'), _vm._v(" "), _c('span', {
      staticClass: "subtitle"
    }, [_vm._v(_vm._s(show.subtitle))]), _c('br')])])])])]) : _c('div', {
      staticClass: "show-content"
    }, [_c('div', {
      staticClass: "focus-image-wrapper show-image-wrapper"
    }, [_c('a', {
      attrs: {
        "href": 'mailto:info@clientmanagementprobation.com?subject=Message from CMS',
        "target": "_blank"
      }
    }, [_c('img', {
      staticClass: "image square img-responsive",
      style: ([{
        'background-image': 'url(' + show.image.path + ')'
      }])
    }), _vm._v(" "), _vm._m(0, true)])])])])
  }), 0)]) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "show-text-overlay visible"
  }, [_c('div', {
    staticClass: "show-text-wrapper"
  }, [_c('span', {
    staticClass: "title"
  }, [_vm._v("Looking For Representation?")]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "subtitle"
  }, [_vm._v("EMAIL US")])])])
}]}

/***/ }),

/***/ 977:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "v-spinner"
  }, [_c('div', {
    staticClass: "v-pulse v-pulse1",
    style: ([_vm.spinnerStyle, _vm.spinnerDelay1])
  }), _c('div', {
    staticClass: "v-pulse v-pulse2",
    style: ([_vm.spinnerStyle, _vm.spinnerDelay2])
  }), _c('div', {
    staticClass: "v-pulse v-pulse3",
    style: ([_vm.spinnerStyle, _vm.spinnerDelay3])
  })])
},staticRenderFns: []}

/***/ }),

/***/ 978:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', [(_vm.footer1 && _vm.footer2) ? _c('div', {
    staticClass: "container",
    attrs: {
      "data-aos": "fade-in",
      "data-aos-once": "true",
      "data-aos-offset": "-100"
    }
  }, [_c('div', {
    staticClass: "columns content is-centered is-gapless is-multiline",
    staticStyle: {
      "margin-top": "10px",
      "margin-bottom": "10px"
    }
  }, [_c('p', {
    staticClass: "column is-8 has-text-left is-hidden-mobile",
    staticStyle: {
      "color": "white"
    }
  }, [(_vm.footer1) ? _c('markdown', {
    attrs: {
      "source": _vm.footer1
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('p', {
    staticClass: "column is-4 has-text-right is-hidden-mobile",
    staticStyle: {
      "color": "white"
    }
  }, [(_vm.footer2) ? _c('markdown', {
    attrs: {
      "source": _vm.footer2
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('p', {
    staticClass: "column is-12 has-text-centered is-hidden-tablet",
    staticStyle: {
      "color": "white"
    }
  }, [(_vm.footer2) ? _c('markdown', {
    attrs: {
      "source": _vm.footer2
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('p', {
    staticClass: "column is-12 has-text-centered is-hidden-tablet",
    staticStyle: {
      "color": "white",
      "margin-top": "20px"
    }
  }, [(_vm.footer1) ? _c('markdown', {
    attrs: {
      "source": _vm.footer1
    }
  }) : _vm._e()], 1)])]) : _c('div', {
    staticStyle: {
      "height": "80px"
    }
  }, [_vm._v("\n     \n  ")])])
},staticRenderFns: []}

/***/ }),

/***/ 979:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page page-payment container is-fluid"
  }, [_c('div', {
    staticClass: "container container-inner"
  }, [_c('div', {
    staticClass: "columns is-gapless is-multiline"
  }, [(_vm.dataPayment) ? _c('div', {
    staticClass: "column content content-main is-right",
    attrs: {
      "data-aos": "fade-up",
      "data-aos-once": "true",
      "data-aos-delay": "300"
    }
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n          " + _vm._s(_vm.dataPayment.title) + "\n        ")]), _vm._v(" "), (_vm.dataPayment.content) ? _c('markdown', {
    staticStyle: {
      "margin-top": "45px"
    },
    attrs: {
      "source": _vm.dataPayment.content
    }
  }) : _vm._e()], 1) : _vm._e()])])])
},staticRenderFns: []}

/***/ }),

/***/ 980:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page page-contact container is-fluid"
  }, [_c('div', {
    staticClass: "container container-inner"
  }, [_c('div', {
    staticClass: "columns is-gapless is-multiline"
  }, [(_vm.contact) ? _c('div', {
    staticClass: "column content content-main is-right",
    attrs: {
      "data-aos": "fade-up",
      "data-aos-once": "true",
      "data-aos-delay": "300"
    }
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n          " + _vm._s(_vm.contact.title) + "\n        ")]), _vm._v(" "), (_vm.contact.content) ? _c('markdown', {
    attrs: {
      "source": _vm.contact.content
    }
  }) : _vm._e()], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "columns is-gapless is-multiline"
  }, [(_vm.contact1) ? _c('div', {
    staticClass: "column content content-sub",
    attrs: {
      "data-aos": "fade-up",
      "data-aos-once": "true",
      "data-aos-delay": "300"
    }
  }, [(_vm.contact1.content) ? _c('markdown', {
    attrs: {
      "source": _vm.contact1.content
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.contact2) ? _c('div', {
    staticClass: "column content content-sub",
    attrs: {
      "data-aos": "fade-up",
      "data-aos-once": "true",
      "data-aos-delay": "300"
    }
  }, [(_vm.contact2.content) ? _c('markdown', {
    attrs: {
      "source": _vm.contact2.content
    }
  }) : _vm._e()], 1) : _vm._e()]), _vm._v(" "), (_vm.note) ? _c('div', {
    staticClass: "columns is-gapless content",
    attrs: {
      "data-aos": "fade-up",
      "data-aos-once": "true",
      "data-aos-delay": "300"
    }
  }, [_c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "box color-gray-lighter-bg"
  }, [(_vm.note.content) ? _c('markdown', {
    attrs: {
      "source": _vm.note.content
    }
  }) : _vm._e()], 1)])]) : _vm._e()])])
},staticRenderFns: []}

/***/ }),

/***/ 981:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "form-dynamix"
  }, [_c('div', {
    staticClass: "columns is-gapless is-centered is-multiline",
    staticStyle: {
      "margin-bottom": "0"
    }
  }, _vm._l((_vm.items), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "column",
      class: [{
        'is-12': !item.attributes.column
      }, item.attributes.column]
    }, [_c('div', {
      staticClass: "field"
    }, [_c('div', {
      staticClass: "control has-icons-right"
    }, [((item.attributes.type === 'checkbox' || item.attributes.type === 'radio')) ? _c('p', {
      staticClass: "label"
    }, [(item.attributes.title && !item.attributes.withDefault && !item.attributes.titleHidden) ? _c('span', [_vm._v("\n              " + _vm._s(item.attributes.title + (_vm.vuelidate.models[item.name].$params.hasOwnProperty('required') || _vm.vuelidate.models[item.name].$params.hasOwnProperty('required_custom') ? ' *' : '')) + "\n            ")]) : _vm._e(), _vm._v(" "), (item.attributes.type === 'checkbox' && item.attributes.withDefault === true) ? _c('label', {
      staticClass: "label default",
      class: [item.attributes.type]
    }, [(!item.attributes.withDefaultHideInput) ? _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.models[item.name]),
        expression: "models[item.name]"
      }],
      attrs: {
        "type": "checkbox",
        "name": [item.name]
      },
      domProps: {
        "checked": Array.isArray(_vm.models[item.name]) ? _vm._i(_vm.models[item.name], null) > -1 : (_vm.models[item.name])
      },
      on: {
        "clicked": function($event) {
          return item.attributes.onChecked()
        },
        "change": function($event) {
          var $$a = _vm.models[item.name],
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(_vm.models, item.name, $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(_vm.models, item.name, $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(_vm.models, item.name, $$c)
          }
        }
      }
    }) : _vm._e(), _vm._v("\n              " + _vm._s(item.attributes.title + (_vm.vuelidate.models[item.name].$params.required ? ' *' : '')) + "\n            ")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (item.attributes.type === 'dropdown') ? _c('div', {
      staticStyle: {
        "margin-bottom": "8px"
      }
    }, [_c('label', {
      class: [item.attributes.type],
      attrs: {
        "for": item.name
      }
    }, [_c('span', {
      staticClass: "label"
    }, [_vm._v(_vm._s(item.attributes.title + (_vm.vuelidate.models[item.name].$params.required ? ' *' : '')))])])]) : _vm._e(), _vm._v(" "), (item.attributes.type === 'dropdown') ? _c('div', {
      staticClass: "select"
    }, [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.models[item.name]),
        expression: "models[item.name]"
      }],
      class: [{
        'is-danger': _vm.vuelidate.models[item.name].$dirty && (_vm.models[item.name] == undefined || _vm.models[item.name] == 0 || _vm.models[item.name].length <= 0) && (_vm.vuelidate.models[item.name].$params.required && !_vm.vuelidate.models[item.name].required)
      }],
      staticStyle: {
        "position": "relative"
      },
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(_vm.models, item.name, $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }
      }
    }, _vm._l((item.attributes.options), function(option) {
      return _c('option', {
        key: option.value,
        domProps: {
          "value": option.value
        }
      }, [_vm._v("\n                " + _vm._s(option.value !== undefined ? option.title : (option.title + (_vm.vuelidate.models[item.name].$params.required ? ' *' : ''))) + "\n              ")])
    }), 0)]) : (item.attributes.type === 'checkbox' || item.attributes.type === 'radio') ? _vm._l((item.attributes.options), function(option) {
      return _c('label', {
        key: option.value,
        class: [item.attributes.type]
      }, [(item.attributes.type === 'checkbox') ? _c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (_vm.models[item.name][option.value]),
          expression: "models[item.name][option.value]"
        }],
        attrs: {
          "type": "checkbox",
          "name": [item.name + '-' + item.value],
          "disabled": item.attributes.disabled
        },
        domProps: {
          "checked": Array.isArray(_vm.models[item.name][option.value]) ? _vm._i(_vm.models[item.name][option.value], null) > -1 : (_vm.models[item.name][option.value])
        },
        on: {
          "clicked": function($event) {
            return item.attributes.onChecked()
          },
          "change": function($event) {
            var $$a = _vm.models[item.name][option.value],
              $$el = $event.target,
              $$c = $$el.checked ? (true) : (false);
            if (Array.isArray($$a)) {
              var $$v = null,
                $$i = _vm._i($$a, $$v);
              if ($$el.checked) {
                $$i < 0 && (_vm.$set(_vm.models[item.name], option.value, $$a.concat([$$v])))
              } else {
                $$i > -1 && (_vm.$set(_vm.models[item.name], option.value, $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
              }
            } else {
              _vm.$set(_vm.models[item.name], option.value, $$c)
            }
          }
        }
      }) : (item.attributes.type === 'radio') ? _c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (_vm.models[item.name]),
          expression: "models[item.name]"
        }],
        attrs: {
          "type": "radio",
          "name": [item.name + '-' + item.value],
          "disabled": item.attributes.disabled
        },
        domProps: {
          "value": option.value,
          "checked": _vm._q(_vm.models[item.name], option.value)
        },
        on: {
          "change": function($event) {
            return _vm.$set(_vm.models, item.name, option.value)
          }
        }
      }) : _vm._e(), _vm._v(" "), _c('span', [_vm._v(_vm._s(option.title))])])
    }) : (item.attributes.type === 'textarea') ? _c('textarea', {
      directives: [{
        name: "model",
        rawName: "v-model.trim",
        value: (_vm.models[item.name]),
        expression: "models[item.name]",
        modifiers: {
          "trim": true
        }
      }],
      staticClass: "textarea",
      class: [{
        'is-danger': _vm.vuelidate.models[item.name].$invalid && _vm.vuelidate.models[item.name].$dirty
      }],
      attrs: {
        "placeholder": [item.attributes.title + (_vm.vuelidate.models[item.name].$params.required ? ' *' : '')],
        "maxlength": item.attributes.maxLength
      },
      domProps: {
        "value": (_vm.models[item.name])
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.models, item.name, $event.target.value.trim())
        }, function($event) {
          if (item.attributes.onInput) { item.attributes.onInput(_vm.models[item.name], item.attributes); }
        }],
        "blur": function($event) {
          return _vm.$forceUpdate()
        }
      }
    }) : (item.attributes.type === 'text') ? _c('label', {
      class: [item.attributes.type],
      attrs: {
        "for": item.name
      }
    }, [_c('span', {
      staticClass: "label"
    }, [_vm._v(_vm._s(item.attributes.title + (_vm.vuelidate.models[item.name].$params.required ? ' *' : '')))]), _vm._v(" "), (!item.attributes.null) ? _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.models[item.name]),
        expression: "models[item.name]"
      }],
      staticClass: "input",
      class: [{
        'is-danger': _vm.vuelidate.models[item.name].$invalid && _vm.vuelidate.models[item.name].$dirty
      }],
      attrs: {
        "name": item.name,
        "placeholder": [item.attributes.placeholder || ''],
        "disabled": item.attributes.disabled
      },
      domProps: {
        "value": (_vm.models[item.name])
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.models, item.name, $event.target.value)
        }
      }
    }) : _vm._e()]) : (item.attributes.type === 'label') ? _c('p', {
      staticClass: "label"
    }, [_c('span', {
      style: (item.attributes.style || {}),
      domProps: {
        "innerHTML": _vm._s(item.attributes.title)
      }
    })]) : (item.attributes.type === 'image') ? _c('p', {
      staticClass: "image-wrapper",
      staticStyle: {
        "text-align": "center"
      }
    }, [(item.attributes.onClick &&
      typeof item.attributes.onClick === 'function') ? _c('a', {
      attrs: {
        "href": '#'
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          item.attributes.onClick()
        }
      }
    }, [_c('img', {
      staticClass: "img-responsive",
      attrs: {
        "src": item.attributes.link
      }
    }), _vm._v(" "), _c('span', {
      staticStyle: {
        "color": "gray",
        "font-size": "0.8em"
      }
    }, [_vm._v(_vm._s(item.attributes.title))])]) : (item.attributes.link) ? _c('a', {
      attrs: {
        "href": item.attributes.link,
        "target": "_blank"
      }
    }, [_c('img', {
      staticClass: "img-responsive",
      attrs: {
        "src": item.attributes.link
      }
    }), _vm._v(" "), _c('span', {
      staticStyle: {
        "color": "gray",
        "font-size": "0.8em"
      }
    }, [_vm._v(_vm._s(item.attributes.title))])]) : _vm._e()]) : (item.attributes.type === 'button') ? _c('p', [_c('button', {
      staticClass: "btn btn-default",
      staticStyle: {
        "cursor": "pointer"
      },
      attrs: {
        "disabled": item.attributes.disabled
      },
      on: {
        "click": function($event) {
          return item.attributes.onClick(item, _vm.models[item.name])
        }
      }
    }, [_vm._v("\n              " + _vm._s(item.attributes.title) + ": " + _vm._s(_vm.models[item.name]) + "\n            ")])]) : _c('p', {
      staticClass: "label"
    }, [_vm._v("\n            Invalid field.\n          ")]), _vm._v(" "), (_vm.vuelidate.models[item.name].$dirty && _vm.vuelidate.models[item.name].$invalid) ? _c('span', {
      staticClass: "icon is-small is-right is-danger"
    }, [_c('i', {
      staticClass: "fa fa-warning"
    })]) : _vm._e(), _vm._v(" "), (item.attributes.type === 'text-area') ? _c('small', {
      staticClass: "help counter"
    }, [_vm._v(_vm._s(item.attributes.curLength) + " / " + _vm._s(item.attributes.maxLength))]) : _vm._e(), _vm._v(" "), (item.attributes.note) ? _c('p', {
      staticClass: "help is-note",
      style: (item.attributes.noteStyle),
      domProps: {
        "innerHTML": _vm._s(item.attributes.note)
      }
    }) : _vm._e(), _vm._v(" "), (_vm.vuelidate.models[item.name].$dirty && _vm.vuelidate.models[item.name].$invalid && _vm.vuelidate.models[item.name].$params.required && !_vm.vuelidate.models[item.name].required) ? _c('p', {
      staticClass: "help is-danger"
    }, [_vm._v("required.")]) : _vm._e(), _vm._v(" "), (_vm.vuelidate.models[item.name].$dirty && _vm.vuelidate.models[item.name].$invalid && _vm.vuelidate.models[item.name].$params.numeric && !_vm.vuelidate.models[item.name].numeric) ? _c('p', {
      staticClass: "help is-danger"
    }, [_vm._v("must be numeric value.")]) : _vm._e(), _vm._v(" "), (_vm.vuelidate.models[item.name].$dirty && _vm.vuelidate.models[item.name].$invalid && _vm.vuelidate.models[item.name].$params.between && !_vm.vuelidate.models[item.name].between) ? _c('p', {
      staticClass: "help is-danger"
    }, [_vm._v("must be between " + _vm._s(_vm.vuelidate.models[item.name].$params.between.min) + " and " + _vm._s(_vm.vuelidate.models[item.name].$params.between.max) + ".")]) : _vm._e(), _vm._v(" "), (_vm.vuelidate.models[item.name].$dirty && _vm.vuelidate.models[item.name].$invalid && _vm.vuelidate.models[item.name].$params.minLength && !_vm.vuelidate.models[item.name].minLength) ? _c('p', {
      staticClass: "help is-danger"
    }, [_vm._v("too short.")]) : _vm._e(), _vm._v(" "), (_vm.vuelidate.models[item.name].$dirty && _vm.vuelidate.models[item.name].$invalid && _vm.vuelidate.models[item.name].$params.maxLength && !_vm.vuelidate.models[item.name].maxLength) ? _c('p', {
      staticClass: "help is-danger"
    }, [_vm._v("is too long.")]) : _vm._e(), _vm._v(" "), (_vm.vuelidate.models[item.name].$dirty && _vm.vuelidate.models[item.name].$invalid && _vm.vuelidate.models[item.name].$params.email && !_vm.vuelidate.models[item.name].email) ? _c('p', {
      staticClass: "help is-danger"
    }, [_vm._v("invalid.")]) : _vm._e(), _vm._v(" "), (_vm.vuelidate.models[item.name].$dirty && _vm.vuelidate.models[item.name].$invalid && _vm.vuelidate.models[item.name].$params.hasOwnProperty('required_custom') && !_vm.vuelidate.models[item.name].required_custom) ? _c('p', {
      staticClass: "help is-danger"
    }, [_vm._v("selection with at least one option.")]) : _vm._e(), _vm._v(" "), (_vm.vuelidate.models[item.name].$dirty && _vm.vuelidate.models[item.name].$invalid && _vm.vuelidate.models[item.name].$params.hasOwnProperty('either_custom') && !_vm.vuelidate.models[item.name].either_custom) ? _c('p', {
      staticClass: "help is-danger"
    }, [_vm._v("selection with conflicting option, please revise.")]) : _vm._e()], 2)])])
  }), 0), _vm._v(" "), (!_vm.isPrint) ? _c('b-field', {
    staticStyle: {
      "width": "100%",
      "margin-bottom": "0"
    }
  }, [_c('div', {
    staticClass: "columns is-gapless is-flex-mobile is-vcentered"
  }, [_c('div', {
    staticClass: "column captcha-image-wrapper"
  }, [_c('vue-recaptcha', {
    attrs: {
      "sitekey": _vm.recaptchaKey
    },
    on: {
      "verify": _vm.onVerifyRecaptcha,
      "expired": _vm.onExpiredRecaptcha,
      "render": _vm.onRenderRecaptcha
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.models['recaptcha']),
      expression: "models['recaptcha']",
      modifiers: {
        "trim": true
      }
    }],
    attrs: {
      "type": "hidden"
    },
    domProps: {
      "value": (_vm.models['recaptcha'])
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.models, 'recaptcha', $event.target.value.trim())
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), (_vm.vuelidate.models['recaptcha'] && _vm.vuelidate.models['recaptcha'].$dirty && _vm.vuelidate.models['recaptcha'].$invalid && _vm.vuelidate.models['recaptcha'].$params.required && !_vm.vuelidate.models['recaptcha'].required) ? _c('p', {
    staticClass: "help is-danger"
  }, [_vm._v("Invalid recaptcha.")]) : _vm._e()], 1)])]) : _vm._e(), _vm._v(" "), (!_vm.isPrint) ? _c('b-field', {
    staticClass: "submit-wrapper"
  }, [_c('button', {
    staticClass: "control button is-outlined",
    class: {
      'is-loading': _vm.loading
    },
    on: {
      "click": function($event) {
        return _vm.onSend(_vm.vuelidate)
      }
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.loading ? ' ' : 'SUBMIT'))])])]) : _vm._e(), _vm._v(" "), (_vm.feedback) ? _c('p', {
    staticClass: "help is-danger",
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v(_vm._s(_vm.feedback))]) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),

/***/ 982:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "position": "relative"
    },
    attrs: {
      "id": "app"
    }
  }, [(_vm.$route.name !== 'survey') ? _c('navbar-overlay') : _vm._e(), _vm._v(" "), _c('router-view', {
    staticClass: "page-wrapper",
    staticStyle: {
      "min-height": "600px"
    }
  }), _vm._v(" "), _c('footer-main')], 1)
},staticRenderFns: []}

/***/ }),

/***/ 983:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "navbar-wrapper",
    attrs: {
      "id": "tsection"
    }
  }, [_c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.toggle) ? _c('div', {
    staticClass: "active-nav"
  }, [_c('div', {
    staticClass: "link shorthand"
  }, [_vm._l((_vm.navItems), function(nav, index) {
    return _c('div', {
      key: nav.name,
      staticClass: "small-div"
    }, [_c('a', {
      staticClass: "div-link",
      attrs: {
        "href": nav.path
      }
    }, [_vm._v("\n          " + _vm._s(nav.label) + "\n        ")])])
  }), _vm._v(" "), _c('div', {
    staticClass: "small-div white"
  }, [_c('div', [_c('img', {
    staticClass: "img-responsive",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": __webpack_require__(183)
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.phone && _vm.fax) ? _c('div', {
    staticClass: "font-bold",
    staticStyle: {
      "padding": "0",
      "margin-top": "20px",
      "font-size": "1.2em"
    }
  }, [_vm._v("\n            Call: " + _vm._s(_vm.phone) + "   Fax: " + _vm._s(_vm.fax) + "\n          ")]) : _vm._e(), _vm._v(" "), (_vm.address) ? _c('div', {
    staticStyle: {
      "padding": "0",
      "margin-top": "6px",
      "font-size": "1.2em",
      "font-weight": "normal",
      "line-height": "1.4em"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.address) + "\n          ")]) : _vm._e()])])], 2)]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "full-layer"
  }, [_c('navbar-full', {
    attrs: {
      "toggle": _vm.toggle
    },
    on: {
      "onToggle": function($event) {
        _vm.toggle = $event
      }
    }
  })], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 984:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-top-section",
    class: [_vm.$route.name !== 'landing' ? 'not-landing' : '']
  }, [(false) ? _c('div', {
    staticClass: "section-indicator"
  }, [_c('span'), _vm._v(" "), _c('span'), _vm._v(" "), _c('span')]) : _vm._e(), _vm._v(" "), (_vm.$route.name === 'landing') ? _c('div', {
    staticClass: "container-wrapper"
  }, [(_vm.loading === false) ? _c('div', {
    staticStyle: {
      "height": "100%"
    },
    attrs: {
      "data-aos": "fade-in",
      "data-aos-once": "true"
    }
  }, [_c('div', {
    staticClass: "slick-wrapper",
    staticStyle: {
      "height": "100%"
    },
    attrs: {
      "data-aos": "fade-in",
      "data-aos-once": "true"
    }
  }, [_c('slick', {
    ref: "slick",
    attrs: {
      "options": _vm.slickOptions
    }
  }, _vm._l((_vm.items), function(item) {
    return _c('div', {
      key: item.title,
      staticClass: "item-wrapper",
      attrs: {
        "caption": item.title,
        "href": item.image.path,
        "src": item.image.path
      }
    }, [(_vm.isDesktop) ? _c('div', {
      staticClass: "item-image item-image-desktop",
      style: ({
        'background-image': 'url(' + item.image.path + ')'
      }),
      attrs: {
        "nopin": "nopin"
      }
    }) : (!_vm.isDesktop && item.image_mobile) ? _c('div', {
      staticClass: "item-image item-image-mobile",
      style: ({
        'background-image': 'url(' + item.image_mobile.path + ')'
      }),
      attrs: {
        "nopin": "nopin"
      }
    }) : _c('div', {
      staticClass: "item-image item-image-desktop",
      style: ({
        'background-image': 'url(' + item.image.path + ')'
      }),
      attrs: {
        "nopin": "nopin"
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "item-absolute",
      staticStyle: {
        "text-align": "center"
      }
    }, [_c('video', {
      staticStyle: {
        "min-width": "100%",
        "height": "100%",
        "object-fit": "cover",
        "-webkit-filter": "brightness(.8)",
        "filter": "brightness(.8)"
      },
      attrs: {
        "autoplay": "",
        "muted": "",
        "playsinline": "",
        "loop": "",
        "id": "myVideo"
      },
      domProps: {
        "muted": true
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "item-slogan"
    })])
  }), 0)], 1)]) : _vm._e()]) : _vm._e()])
},staticRenderFns: []}

/***/ }),

/***/ 985:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "help is-danger has-text-left"
  }, _vm._l((_vm.infos), function(info) {
    return _c('li', [_vm._v(_vm._s(info.message))])
  }), 0)
},staticRenderFns: []}

/***/ }),

/***/ 986:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page page-reports container is-fluid"
  }, [_c('div', {
    staticClass: "container container-inner"
  }, [_c('div', {
    staticClass: "columns is-flex is-gapless is-multiline"
  }, [_c('div', {
    staticClass: "column content content-main is-right"
  }, [(_vm.dataReports) ? _c('div', {
    staticClass: "title"
  }, [_vm._v("\n          " + _vm._s(_vm.dataReports.title) + "\n        ")]) : _vm._e(), _vm._v(" "), (_vm.dataReports && _vm.dataReports.content) ? _c('markdown', {
    attrs: {
      "source": _vm.dataReports.content
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "columns is-flex is-multiline has-text-centered"
  }, [(_vm.dataExisting) ? _c('div', {
    staticClass: "column",
    attrs: {
      "data-aos": "fade-up",
      "data-aos-once": "true"
    }
  }, [_c('div', {
    staticClass: "box color-gray-lighter-bg",
    staticStyle: {
      "min-height": "200px"
    }
  }, [_c('div', {
    staticClass: "subtitle font-bold",
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.dataExisting.title) + "\n              ")]), _vm._v(" "), _c('a', {
    staticClass: "button",
    attrs: {
      "href": _vm.dataExisting.link,
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.dataExisting.content))])])]) : _vm._e(), _vm._v(" "), (_vm.dataRegister) ? _c('div', {
    staticClass: "column",
    attrs: {
      "data-aos": "fade-up",
      "data-aos-once": "true",
      "data-aos-delay": "300"
    }
  }, [_c('div', {
    staticClass: "box color-gray-lighter-bg",
    staticStyle: {
      "min-height": "200px"
    }
  }, [_c('div', {
    staticClass: "subtitle font-bold",
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.dataRegister.title) + "\n              ")]), _vm._v(" "), _c('a', {
    staticClass: "button",
    attrs: {
      "href": _vm.dataRegister.link,
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.dataRegister.content))]), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.dataRegisterHow) ? _c('a', {
    staticStyle: {
      "font-size": "0.9em",
      "display": "block",
      "margin-top": "10px"
    },
    attrs: {
      "href": _vm.dataRegisterHow.link,
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.dataRegisterHow.content))]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.dataSurvey) ? _c('div', {
    staticClass: "column",
    attrs: {
      "data-aos": "fade-up",
      "data-aos-once": "true",
      "data-aos-delay": "300"
    }
  }, [_c('div', {
    staticClass: "box color-gray-lighter-bg",
    staticStyle: {
      "min-height": "200px"
    }
  }, [_c('div', {
    staticClass: "subtitle font-bold",
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.dataSurvey.title) + "\n              ")]), _vm._v(" "), _c('a', {
    staticClass: "button",
    attrs: {
      "href": _vm.dataSurvey.link
    }
  }, [_vm._v(_vm._s(_vm.dataSurvey.content))])])]) : _vm._e(), _vm._v(" "), (_vm.dataRegister) ? _c('div', {
    staticClass: "column",
    attrs: {
      "data-aos": "fade-up",
      "data-aos-once": "true",
      "data-aos-delay": "300"
    }
  }, [_vm._m(0)]) : _vm._e()])], 1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box color-gray-lighter-bg",
    staticStyle: {
      "min-height": "200px",
      "opacity": "0.01"
    }
  }, [_c('a', {
    staticClass: "button",
    staticStyle: {
      "pointer-events": "none"
    },
    attrs: {
      "href": "#"
    }
  }, [_vm._v("<      >")]), _vm._v(" "), _c('br')])
}]}

/***/ }),

/***/ 987:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "section-contact",
    attrs: {
      "id": "section-contact"
    }
  }, [_c('div', {
    staticClass: "columns is-gapless is-flex-mobile is-centered"
  }, [_c('div', {
    staticClass: "column is-10 is-11-mobile"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "columns is-gapless is-multiline"
  }, [_c('div', {
    staticClass: "column is-12"
  }, [_c('div', {
    staticClass: "cont-form cont-form-info",
    attrs: {
      "data-aos": "fade-up",
      "data-aos-once": "true"
    }
  }, [_c('b-field', [_c('b-input', {
    attrs: {
      "value": "",
      "placeholder": "NAME"
    },
    on: {
      "input": function($event) {
        return _vm.$v.name.$touch()
      }
    },
    model: {
      value: (_vm.name),
      callback: function($$v) {
        _vm.name = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "name"
    }
  })], 1), _vm._v(" "), _c('b-field', [_c('b-input', {
    attrs: {
      "value": "",
      "placeholder": "EMAIL"
    },
    on: {
      "input": function($event) {
        return _vm.$v.email.$touch()
      }
    },
    model: {
      value: (_vm.email),
      callback: function($$v) {
        _vm.email = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "email"
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "column is-12"
  }, [_c('div', {
    staticClass: "cont-form cont-form-message",
    attrs: {
      "data-aos": "fade-up",
      "data-aos-once": "true"
    }
  }, [_c('b-field', [_c('b-input', {
    attrs: {
      "maxlength": "500",
      "type": "textarea",
      "placeholder": "MESSAGE"
    },
    on: {
      "input": function($event) {
        return _vm.$v.message.$touch()
      }
    },
    model: {
      value: (_vm.message),
      callback: function($$v) {
        _vm.message = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "message"
    }
  })], 1), _vm._v(" "), _c('b-field', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('div', {
    staticClass: "columns is-gapless is-flex-mobile is-vcentered"
  }, [_c('div', {
    staticClass: "column is-narrow"
  }, [_c('img', {
    staticClass: "captcha-image img-responsive",
    attrs: {
      "src": _vm.captchaImage
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "column",
    staticStyle: {
      "padding-right": "15px"
    }
  }, [_c('b-input', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "name": "captcha",
      "placeholder": "INPUT CAPTCHA",
      "type": "text"
    },
    on: {
      "input": function($event) {
        return _vm.$v.captcha.$touch()
      }
    },
    model: {
      value: (_vm.captcha),
      callback: function($$v) {
        _vm.captcha = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "captcha"
    }
  })], 1), _vm._v(" "), (_vm.isDesktop) ? _c('div', {
    staticClass: "column is-4 is-3-mobile"
  }, [_c('button', {
    staticClass: "button is-outlined",
    class: {
      'is-loading': _vm.loading
    },
    on: {
      "click": function($event) {
        return _vm.onSend(_vm.$v)
      }
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.loading ? ' ' : 'SUBMIT'))])])]) : _vm._e()])]), _vm._v(" "), (!_vm.isDesktop) ? _c('b-field', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('button', {
    staticClass: "button is-outlined",
    class: {
      'is-loading': _vm.loading
    },
    on: {
      "click": function($event) {
        return _vm.onSend(_vm.$v)
      }
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.loading ? ' ' : 'SUBMIT'))])])]) : _vm._e(), _vm._v(" "), (_vm.feedback) ? _c('p', [_vm._v(_vm._s(_vm.feedback))]) : _vm._e()], 1)])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "columns is-gapless is-centered is-multiline"
  }, [_c('div', {
    staticClass: "column is-6 has-text-centered"
  }, [_c('div', {
    staticClass: "cont-desc",
    attrs: {
      "data-aos": "fade-up",
      "data-aos-once": "true"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://www.facebook.com/cms",
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-facebook"
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://www.youtube.com/channel/cms",
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-youtube"
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://www.instagram.com/cms",
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-instagram"
  })])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "columns is-gapless is-centered is-multiline"
  }, [_c('div', {
    staticClass: "column is-6 has-text-centered"
  }, [_c('div', {
    staticClass: "cont-desc",
    attrs: {
      "data-aos": "fade-up",
      "data-aos-once": "true"
    }
  }, [_c('h3', {
    staticClass: "title",
    staticStyle: {
      "font-size": "1.8em"
    }
  }, [_vm._v("Contact Us")]), _vm._v(" "), _c('span', [_vm._v("Have a question? Let us know.")])])])])
}]}

/***/ }),

/***/ 988:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    staticClass: "main-dialog",
    attrs: {
      "title": undefined,
      "show-close": false,
      "visible": _vm.visible && !!_vm.data,
      "top": '10vh',
      "width": _vm.isDesktop ? '70%' : '90%',
      "before-close": _vm.onClose
    }
  }, [_c('div', {
    staticClass: "el-dialog__content",
    staticStyle: {
      "max-width": "930px",
      "margin-left": "auto",
      "margin-right": "auto",
      "text-align": "center"
    }
  }, [_c('h1', {
    staticStyle: {
      "padding-bottom": "1em",
      "font-size": "1.4em"
    }
  }, [_vm._v(_vm._s(_vm.data.title))]), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "left",
      "padding-left": "30px",
      "padding-right": "30px"
    }
  }, [(_vm.data.content) ? _c('markdown', {
    attrs: {
      "source": _vm.data.content
    }
  }) : _vm._e()], 1)]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer",
      "align": "center"
    },
    slot: "footer"
  }, [_c('div', {
    staticClass: "button is-primary",
    staticStyle: {
      "margin-bottom": "15px",
      "margin-right": "-10px"
    },
    on: {
      "click": _vm.onClose
    }
  }, [_c('span', {
    staticStyle: {
      "text-transform": "uppercase"
    }
  }, [_vm._v("Close")])])])])
},staticRenderFns: []}

/***/ }),

/***/ 989:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "div-columns"
  }, [_c('div', {
    staticClass: "columns is-gapless is-centered is-vcentered"
  }, [_c('div', {
    staticClass: "column content",
    class: [{
      'is-11': _vm.full !== 'true' && !_vm.columnNum
    }, _vm.columnNum],
    style: ([{
      paddingTop: (_vm.paddingTop ? _vm.paddingTop : undefined),
      paddingBottom: (_vm.paddingBottom ? _vm.paddingBottom : undefined),
      backgroundColor: (_vm.backgroundColor ? _vm.backgroundColor : undefined),
      textAlign: (_vm.textAlign ? _vm.textAlign : undefined)
    }])
  }, [_vm._t("default")], 2)])])
},staticRenderFns: []}

/***/ }),

/***/ 990:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "page page-survey container is-fluid"
  }, [_c('div', {
    staticClass: "container container-inner"
  }, [_c('div', {
    staticClass: "columns is-flex is-gapless is-multiline",
    staticStyle: {
      "flex-direction": "column"
    }
  }, [_c('div', {
    staticClass: "column is-12 is-mobile-12 content content-main is-right",
    staticStyle: {
      "padding-left": "0.7rem",
      "padding-right": "0.7rem",
      "padding-bottom": "0.2rem"
    }
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n            " + _vm._s('Exit Survey') + "\n          ")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "column is-12 is-mobile-12 is-centered"
  }, [(_vm.isSurveyState == null) ? _c('div', {
    staticClass: "columns is-gapless is-centered is-multiline"
  }, [_c('div', {
    staticClass: "column is-6"
  }, [_c('div', {
    staticClass: "box color-gray-lighter-bg"
  }, [_c('div', {
    staticClass: "subtitle",
    staticStyle: {
      "margin-bottom": "0.8em"
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.isSurveyError) + "\n                  "), _c('div', {
    staticStyle: {
      "width": "100%",
      "text-align": "center",
      "margin-top": "24px"
    }
  }, [_c('el-button', {
    staticClass: "button",
    attrs: {
      "type": "info"
    },
    on: {
      "click": function($event) {
        return _vm.$router.push('/')
      }
    }
  }, [_vm._v("Back to Home")])], 1)])])])]) : _vm._e(), _vm._v(" "), (_vm.isSurveyState === 'code') ? _c('div', {
    staticClass: "columns is-gapless is-centered is-multiline"
  }, [_c('div', {
    staticClass: "column is-6"
  }, [_c('div', {
    staticClass: "box color-gray-lighter-bg"
  }, [_c('div', {
    staticClass: "subtitle",
    staticStyle: {
      "margin-bottom": "0.8em"
    }
  }, [_vm._v("\n                  " + _vm._s('Survey Code') + "\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "text"
  }, [_vm._v("\n                  Please enter the survey code below.\n                ")]), _vm._v(" "), _c('form-input', {
    attrs: {
      "name": "surveyCode",
      "value": _vm.surveyCode,
      "placeholder": "",
      "error": _vm.surveyError
    },
    on: {
      "onInput": _vm.onSurveyInput
    }
  }), _vm._v(" "), _c('div', [_c('button', {
    staticClass: "control button is-outlined",
    class: {
      'is-loading': _vm.loading
    },
    on: {
      "click": function () { return _vm.onSurveyCode(_vm.surveyCode); }
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.loading ? ' ' : 'SUBMIT'))])])])], 1)])]) : _vm._e(), _vm._v(" "), (_vm.isSurveyState === 'survey') ? _c('div', [(!_vm.submitted) ? _c('form-dynamix', {
    attrs: {
      "type": "team",
      "feedback": _vm.feedback,
      "loading": _vm.loading,
      "names": _vm.names,
      "models": _vm.models,
      "attributes": _vm.attributes,
      "vuelidate": _vm.$v,
      "is-print": _vm.isPrint,
      "is-print-pdf": _vm.isPrintPdf
    },
    on: {
      "recaptcha": _vm.onRecaptcha,
      "send": _vm.onSend
    }
  }) : _vm._e()], 1) : _vm._e()])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "navbar-wrapper",
    attrs: {
      "data-aos": "fade-in",
      "data-aos-once": "true"
    }
  }, [_c('div', {
    staticClass: "container navbar-row first is-fluid",
    staticStyle: {
      "margin-left": "0",
      "margin-right": "0"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "columns navbar-full first is-gapless is-mobile"
  }, [_c('div', {
    staticClass: "column navbar-brand",
    attrs: {
      "align": "left"
    }
  }, [_c('div', {
    staticClass: "navbar-logo"
  }, [_c('img', {
    staticClass: "img-responsive logo-1",
    attrs: {
      "src": __webpack_require__(124),
      "width": "85"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "img-responsive logo-2 is-hidden-mobile",
    attrs: {
      "src": __webpack_require__(183),
      "width": "360"
    }
  })])])])])]), _vm._v(" "), _c('div', {
    staticClass: "container navbar-row second is-fluid",
    staticStyle: {
      "margin-left": "0",
      "margin-right": "0"
    }
  })])
}]}

/***/ })

},[487]);


// WEBPACK FOOTER //
// static/js/app.090fcea62e1fbea6ce3a.js